import { ROOM_INFO_TRANSLATIONS } from './roomsInfo';

const SWE = {
  'messenger_v2.call.share_screen': "Dela skärm",
  'messenger_v2.call.ongoing': "Gruppsamtal pågår",
  'messenger_v2.call.ongoing_video': "Videosamtal pågår",
  'messenger_v2.call.ongoing_voice': "Röstsamtal pågår",
  'messenger_v2.call.more_members': "{count} fler deltagare",
  'messenger_v2.call.mute_sound': "Stäng av ljud",
  'messenger_v2.call.unmute_sound': "Slå på ljud",
  'messenger_v2.call.sound_off': "Ljud av",
  'messenger_v2.call.live_members': "{count} i samtalet nu",
  'messenger_v2.call.waiting_members': "Väntar på deltagare",
  'messenger_v2.call.joining': "Ansluter…",
  'messenger_v2.call.return_to_call': "Tillbaka till samtalet",
  'messenger_v2.call.rejoin_failed': "Det gick inte att gå med i samtalet. Försök igen.",
  'messenger_v2.call.stop_sharing': "Sluta dela",
  'messenger_v2.call.share_pending': "Uppdaterar skärmdelning",
  'messenger_v2.call.share_unsupported': "Den här webbläsaren kan inte dela skärmen. Du kan fortfarande se delade skärmar.",
  'messenger_v2.call.share_denied': "Skärmdelningen avbröts eller behörigheten nekades. Samtalet är fortfarande anslutet.",
  'messenger_v2.call.share_failed': "Skärmdelningen kunde inte startas eller stoppas korrekt. Försök igen.",
  'messenger_v2.call.view_screen': "Visa skärmen för {name}",
  'messenger_v2.call.expand_screen': "Förstora delad skärm",
  'messenger_v2.call.exit_expand_screen': "Avsluta förstorad skärm",
  'messenger_v2.pin.pin': 'Fäst chatt',
  'messenger_v2.pin.unpin': 'Lossa chatt',
  'messenger_v2.pin.pinned': 'Fäst chatt',
  'messenger_v2.pin.failed': 'Kunde inte uppdatera fäst chatt. Försök igen.',
  'messenger_v2.self.name': '{name} (Du)',
  'messenger_v2.self.subtitle': 'Skicka meddelande till dig själv',
  ...ROOM_INFO_TRANSLATIONS.SWE,
  'tabs.more': 'Mer',
  'header.footer.short.find_grave': 'Hitta grav',
  'header.footer.short.how': 'Hur',
  'header.footer.short.about': 'Om',
  'notifications.general.title': 'Avisering',
  'notifications.auth.title': 'Autentisering',
  'notifications.requests.title': 'Förfrågningar',
  'notifications.gravesHub.title': 'Gravöversikt',
  'notifications.graves.title': 'Gravar',
  'notifications.memoryWall.title': 'Minnesvägg',
  'notifications.payments.title': 'Betalningar',
  'notifications.settings.title': 'Inställningar',
  'notifications.groups.title': 'Grupper',
  'notifications.sparks.title': 'Sparks',
  'notifications.store.title': 'Butik',
  'notifications.purchase.title': 'Köp',
  'notifications.userProfile.title': 'Mitt Ljus',
  'notifications.messaging.title': 'Meddelanden',
  'messenger.header.unseen_messages': 'Meddelanden, {count} nya',
  'notifications.messages.title': 'Meddelanden',
  'notifications.connectRequests.title': 'Kontaktförfrågningar',
  'notifications.designSystem.title': 'Designsystem',
  'notifications.subscription.title': 'Prenumeration',
  'notifications.comments.title': 'Kommentarer',
  'notifications.familyTree.title': 'Släktträd',
  notifications_page_title: 'Aviseringar',
  notifications_see_all: 'Visa alla',
  worthy_calendar_precision_year: 'År',
  worthy_calendar_precision_month: 'Månad',
  worthy_calendar_precision_date: 'Datum',
  worthy_calendar_precision_heading: 'Välj datumprecision',
  worthy_calendar_unset: 'Ingen datum vald',
  worthy_calendar_unset_time: 'Ingen tid vald',
  worthy_calendar_selection_value: '{iso} ({precision})',
  worthy_calendar_select_month: 'Välj månad',
  worthy_calendar_select_year: 'Välj år',
  worthy_calendar_select_day: 'Välj dag',
  worthy_calendar_previous: 'Föregående',
  worthy_calendar_next: 'Nästa',
  worthy_calendar_selected_label: 'Valt:',
  worthy_calendar_valid_years: 'Giltiga år: {min}–{max}',
  worthy_calendar_choose_date: 'Välj datum',
  worthy_calendar_choose_time: 'Välj tid',
  worthy_calendar_choose_datetime: 'Välj datum och tid',
  worthy_calendar_close: 'Stäng',
  worthy_calendar_cancel: 'Avbryt',
  worthy_calendar_apply: 'Använd',
  worthy_calendar_default_label: 'Händelsedatum',
  worthy_calendar_default_time_label: 'Tidpunkt',
  worthy_calendar_default_datetime_label: 'Händelsedatum och tid',
  worthy_calendar_required: 'Välj ett datum',
  worthy_calendar_required_time: 'Välj en tid',
  worthy_calendar_required_datetime: 'Välj datum och tid',
  worthy_calendar_time_heading: 'Välj tid',
  error_boundary_title: 'Vi uppdaterade Nätgrav',
  error_boundary_subtitle:
    'Ladda om sidan för att fortsätta. Om det fortsätter, försök igen om en stund.',
  error_boundary_reload: 'Ladda om nu',
  error_boundary_show_details: 'Visa detaljer',
  error_boundary_hide_details: 'Dölj detaljer',
  auth_mobileNumber: 'Mobilnummer',
  auth_password: 'Lösenord',
  auth_passwordPlaceholder: 'Ange lösenordet',
  auth_show_password: 'Visa lösenord',
  auth_hide_password: 'Dölj lösenord',
  auth_rememberMe: 'Kom ihåg mig på den här enheten',
  sign_in: 'Logga in',
  auth_login: 'Logga in',
  auth_get_newsletr: 'Ta emot nyheter och uppdateringar från Nätgrav',
  auth_notRegistered: 'Har du inget konto? ',
  auth_alreadyRegistered: 'Har du redan ett konto? ',
  auth_login_here: 'Logga in',
  register: 'Skapa konto',
  auth_register: 'Skapa konto',
  'family_tree_guest.eyebrow': 'Släktträd',
  'family_tree_guest.title': 'Se hur familjen hänger samman',
  'family_tree_guest.intro':
    'Släktträdet ger en gemensam plats för att samla människor, gravar och relationer. Då blir det lättare att förstå sammanhang, bevara historier och föra dem vidare.',
  'family_tree_guest.primary_cta': 'Logga in för att fortsätta',
  'family_tree_guest.secondary_cta': 'Skapa konto',
  'family_tree_guest.note': 'Logga in för att börja bygga familjens träd.',
  'family_tree_guest.panel_label': 'Det här kan du göra',
  'family_tree_guest.feature_1':
    'Knyt personer samman, och se hur relationer också växer fram längs vägen.',
  'family_tree_guest.feature_2': 'Upptäck talanger och sinnen som går igen genom generationerna.',
  'family_tree_guest.feature_3':
    'Familjen kan bekräfta det de känner igen, så att insikten blir tydligare och mer förankrad över tid.',
  'family_tree_guest.feature_1_title': 'Bygg och låt trädet växa',
  'family_tree_guest.feature_2_title': 'Talanger och sinnen i familjen',
  'family_tree_guest.feature_3_title': 'Bekräftat av familjen',
  'family_tree_guest.preview_person_name': 'Elias Johansen',
  'family_tree_guest.preview_person_meta': 'Född 1984 • knuten till samma familjelinje',
  'family_tree_guest.preview_relation_1': 'Bror',
  'family_tree_guest.preview_relation_2': 'Förälder',
  'family_tree_guest.preview_grave_name': 'Lorense Johansen',
  'family_tree_guest.preview_grave_meta': 'Gravsida kopplad till samma familj',
  'family_tree_guest.preview_grave_body':
    'Se hur människor och gravar hänger samman i familjen över tid.',
  'family_tree_guest.preview_tree_root': 'Elias Johansen',
  'family_tree_guest.preview_tree_root_meta': 'Du kan börja från en person och bygga utåt',
  'family_tree_guest.preview_tree_left': 'Liv Johansen',
  'family_tree_guest.preview_tree_left_meta': 'Mor',
  'family_tree_guest.preview_tree_right': 'Oskar Johansen',
  'family_tree_guest.preview_tree_right_meta': 'Far',
  'family_tree_guest.detail_title': 'Det här kan du göra i släktträdet',
  'family_tree_guest.detail_intro': 'Släktträdet binder samman människor, gravar och släktlinjer.',
  'family_tree_guest.preview_status': 'Talang bekräftad',
  'family_tree_guest.preview_hint': 'Maren kände igen Delegation hos Elias Johansen.',
  auth_forgotPassword: 'Behöver du hjälp med lösenordet?',
  login_phone_verification_message:
    'Inloggning med telefon kräver att e-postadressen på kontot är verifierad.',
  login_phone_email_verification_message:
    'Verifiera e-postadressen på kontot innan du loggar in med telefonnummer. Logga in med din e-postadress för att fortsätta.',
  login_send_verification_code: 'Skicka verifieringsmejl',
  login_phone_code_sent: 'Verifieringsmejlet har skickats.',
  login_phone_code_verified: 'E-postadressen är verifierad. Loggar in...',
  auth_too_many_attempts: 'För många inloggningsförsök. Vänta en stund innan du försöker igen.',
  phone_verification_uses_email: 'Telefonverifiering sker via e-post.',
  auth_welcome: 'Välkommen tillbaka',
  auth_toNätgrav: 'till natgrav.se',
  auth_toNätgrav: 'till natgrav.se',
  theme_name_familie: 'Familj',
  theme_name_skole: 'Skola',
  theme_name_arbeid: 'Arbete',
  theme_name_kjaerlighet: 'Kärlek',
  theme_name_minne: 'Minne',
  theme_name_natur: 'Natur',
  theme_name_tro: 'Tro/Hopp',
  theme_name_fellesskap: 'Gemenskap',
  theme_name_annet: 'Annat',
  auth_enterPhoneNumber: 'Ange ditt telefonnummer',
  auth_emailOrPhone_label: 'E‑post eller telefonnummer',
  auth_emailOrPhone_placeholder: 'Ange e‑post eller telefonnummer',
  auth_emailOrPhone_required: 'Lägg till e‑post eller telefonnummer.',
  auth_phone_hint:
    'Skriv ett lokalt nummer eller använd ett internationellt format som +47 45007009.',
  auth_man: 'Man',
  auth_woman: 'Kvinna',
  auth_other: 'Annat',
  auth_acceptConditions: 'Jag godkänner att ta emot SMS från Nätgrav och jag godkänner',
  auth_termsAndCondition: 'villkor',
  auth_next: 'Nästa',
  auth_receivedSMS: 'Du kommer nu att få ett meddelande',
  auth_otpCode: 'Ange engångskoden',
  auth_received: 'Har du inte fått en engångskod?',
  auth_newOtp: 'Du kan skicka en ny engångskod om 00:',
  auth_sendNew: 'Skicka ny',
  auth_confirm: 'Bekräfta',
  confirm: 'Bekräfta',
  auth_passwordSentTo: 'Lösenordet skickades till:',
  auth_yourName: 'Ditt namn',
  auth_enterFullName: 'Ange ditt namn',
  auth_enterPasswordAgain: 'Ange lösenordet igen',
  auth_passwordMessage: 'Använd minst 7 tecken och 3 av de 4 kategorierna:',
  auth_capitalLetter: '⚙︎ Versal',
  auth_smallLetters: '⚙︎ Gemener',
  auth_digits: '⚙︎ Siffror',
  auth_characters: '⚙︎ Specialtecken',
  auth_signupInvitation: 'Du blev inbjuden till det medvetna abonnemanget från',
  auth_resetPassword: 'Återställ lösenord',
  auth_resetPasswordSMS: 'En engångskod skickas till din mobiltelefon',
  auth_back: 'Tillbaka',
  auth_send: 'Skicka',
  auth_restOtp: 'Ange engångskoden som skickades till {code}{phoneNumber}',
  auth_code: 'Ange koden',
  auth_confirmPassword: 'Bekräfta nytt lösenord',
  auth_newPassword: 'Nytt lösenord',
  auth_notSame: 'Lösenorden matchar inte',
  auth_save: 'Spara',
  'gravesHub.inviteFamily.title': 'Bjud in familjen att ta hand om graven',
  'gravesHub.inviteFamily.submit': 'Skicka inbjudan',
  'gravesHub.inviteFamily.success':
    'Inbjudan skickad till {email}. De kan nu hjälpa till att ta hand om graven.',
  'gravesHub.inviteFamily.error': 'Kunde inte skicka inbjudan. Försök igen.',
  'gravesHub.inviteFamily.loading': 'Vänta medan vi laddar sidan.',
  settings_profile: 'Profil',
  settings_personalInformation: 'Namn och information',
  settings_payments: 'Betalningar',
  settings_paymentDate: 'Datum',
  settings_paymentStatus: 'Status',
  settings_paymentMethod: 'Betalningsmetod',
  settings_paymentAmount: 'Belopp',
  settings_emptyPayments: 'Det finns inga betalningar tillgängliga för närvarande',
  settings_subscription: 'Prenumeration',
  settings_members: 'Familj och vänner',
  settings_giftInvitations: 'Bjud in med en gåva',
  settings_notifications: 'Aviseringar',
  settings_security: 'Säkerhet',
  settings_title: 'Inställningar',
  settings_back_to_menu: 'Tillbaka till inställningar',
  settings_load_error_title: 'Det gick inte att läsa in inställningarna',
  settings_load_error_body: 'Kontrollera anslutningen och försök igen.',
  settings_notifications_load_error_title: 'Det gick inte att läsa in aviseringarna',
  settings_notifications_load_error_body: 'Dina aviseringsval ändrades inte. Försök igen.',
  settings_password_updated_success: 'Ditt nya lösenord har sparats.',
  settings_password_invalid_error: 'Lösenordet kunde inte ändras. Kontrollera uppgifterna.',
  account_deletion_requested_success: 'Din begäran om att radera kontot har registrerats.',
  account_deletion_cancelled_success: 'Raderingen av kontot har avbrutits.',
  account_deletion_update_error: 'Det gick inte att uppdatera raderingen av kontot. Försök igen.',
  settings_enter_verification_code: 'Ange verifieringskod',
  settings_verification_code_invalid: 'Koden är inte korrekt',
  settings_account_information: 'Kontoinställningar',
  settings_inventory: 'Min samling',
  inventory_section_subtitle: 'End of Time Care i praktiken',
  inventory_empty_title: 'Lägg till produkter från butiken.',
  inventory_empty_description: 'Ditt lager kan användas på alla gravar.',
  inventory_purchase_item: 'Köp vara',
  inventory_purchase_button: 'Gå till butiken',
  settings_contact: 'Kontakta Nätgrav',
  settings_password: 'Lösenord',
  settings_edit: 'Redigera',
  my_light_remove_relation: 'Ta bort relation',
  settings_fullName: 'Namn',
  settings_gender: 'Kön',
  settings_occupation: 'Yrke',
  settings_birthday: 'Födelsedag',
  settings_email: 'E-postadress',
  settings_telephoneNumber: 'Telefonnummer',
  settings_address: 'Adress',
  settings_language: 'Språk',
  settings_currency: 'Valuta',
  settings_timeZone: 'Tidszon',
  settings_invalidEmail: 'Ogiltig e-postadress',
  settings_cancel: 'Avbryt',
  settings_currentPassword: 'Aktuellt lösenord',
  settings_newPassword: 'Ange nytt lösenord',
  settings_retype: 'Ange lösenordet igen',
  confirm_password: 'Bekräfta lösenord',
  settings_billingMethod: 'Betalningsmetod',
  settings_cancelSubscription: 'Avbryt prenumeration',
  settings_cancel_mySubscription: 'Ja, avbryt min prenumeration',
  settings_month: 'månad',
  cancelSubscription_message:
    'Du är på väg att avsluta Nätgrav {name}-planen. Du kan fortfarande vara här på gratisplanen och starta igen när du vill.',
  reactivateSubscription_message:
    'Du håller på att återaktivera din prenumeration på Nätgrav {name}-planen. Detta kommer att återställa full tillgång till alla funktioner som är kopplade till denna plan.',
  not_now: 'inte nu',
  reactivate: 'Ja, återaktivera min prenumeration',
  settings_nextDue: 'Nästa betalning förfaller',
  settings_paymentMethods: 'Betalningsmetoder',
  settings_nextBilling: 'Nästa automatiska fakturering är',
  settings_mangeMethods: 'Visa och hantera din betalningsmetod',
  settings_emptyMethods: 'Det finns inga betalningsmetoder tillagda än',
  settings_vippsHeading: 'Vipps betalningar och avtal kommer hit snart',
  settings_manageVipps: 'För att visa och hantera dina avtal',
  settings_cardEnd: 'slutar med',
  settings_remove: 'Ta bort',
  settings_stop: 'Stoppa',
  relation_title_for_connection: 'Vad är relationen från {firstGrave} till {secondGrave}?',
  relation_direction_title_for_connection:
    'Vad är relationen från {secondGrave} till {firstGrave}?',
  settings_vippsAgreement: 'Vipps-avtal',
  view_manage_agreements: 'Visa och hantera ditt avtal',
  empty_agreements: 'Inga Vipps-avtal hittades',
  settings_amount: '{amount}',
  settings_subscriptionHeading: 'Prenumerations­hantering',
  settings_subscriptionStatus: 'Status',
  settings_length: 'Längd',
  settings_nextBillingDate: 'Nästa faktureringsdatum',
  settings_endDate: 'Slutdatum',
  settings_reactivateSubscription: 'Återaktivera prenumeration',
  settings_freeSubscriptionHeading: 'Kom igång gratis.',
  months: 'månader',
  year: 'år',
  month: 'månad',
  years: 'år',
  saved: 'Sparat',
  saved_message: '{name} har sparats.',
  settings_upgrade: 'Uppgradera plan',
  settings_subDescription: 'För ett meningsfullt liv',
  settings_for: 'för',
  settings_paymentInfo: 'Betalningsuppgifter',
  settings_cardNumber: 'Kortnummer',
  settings_billingInfo: 'Faktureringsuppgifter',
  settings_name: 'Namn',
  settings_billingEmail: 'E-post',
  settings_billingCountry: 'Land',
  settings_postCode: 'Postnummer',
  settings_changePlan: 'Byt plan',
  change_plan: 'byt plan',
  change: 'ändra',
  change_members: 'ändra medlemmar',
  settings_noSubscription: 'Du har ingen aktiv prenumeration ännu.',
  settings_clickHere: 'klicka här',
  settings_getSubscription: 'Skaffa prenumeration',
  settings_subscriptionPrice: 'Pris per år',
  settings_subscriptionLengths: 'Tillåtna längder',
  settings_subscriptionYears: 'Köpta år',
  settings_subscriptionFrameId: 'Ram-ID',
  open_menu: 'Öppna meny',
  settings_memberHeading: 'Inbjudningar',
  settings_receivedMembership: '(Inbjudningar du mottagit)',
  settings_emptyMembership: 'Inga inbjudningar just nu.',
  settings_subscribedPlan: 'Din prenumeration är aktiverad. Du kan visa eller hantera ',
  settings_updatePlan: 'Din prenumeration är uppdaterad. Du kan visa eller hantera ',
  settings_downgradePlan: 'Din prenumeration är nedgraderad. Du kan visa eller hantera ',
  settings_addedMember: 'Nya medlemmar har lagts till. Du kan visa eller hantera ',
  payment_progress: 'Betalning pågår – vänligen vänta',
  something_wrong: 'Något gick fel. Försök igen senare',
  add_validNumber: 'Ange ett giltigt telefonnummer',
  select_planMessage:
    'För att fortsätta, välj en plan som passar dina behov. Våra planer erbjuder flexibilitet och funktioner.',
  settings_memberPage: 'medlemssida',
  settings_your: 'din.',
  settings_enable: 'plan aktiverad',
  free: 'Gratis',
  conscious: 'Conscious',
  consciousPlus: 'Conscious plus',
  settings_membershipOn: '– prenumeration aktiv',
  settings_modalSubheading: 'Störst av allt är kärlek',
  settings_modalLink: 'Tack för att du är här',
  settings_memberSubheading: 'Din familjeplan.',
  settings_emptyMembers: 'Du har inga prenumerationsmedlemmar',
  settings_memberName: '{name}s familj',
  settings_memberLength: '{length} medlemmar',
  settings_administrator: 'Administratör',
  settings_showMembers: 'Visa medlemmar',
  settings_familyMembers: 'Familj',
  settings_you: 'Du',
  settings_connect: 'anslut',
  settings_setRelation: 'Ställ in relation',
  settings_selectedRelation: 'Välj relation',
  settings_giftHeading: 'Ge en prenumeration till någon du bryr dig om.',
  settings_giftFreeSubscription:
    'Du har ett gratiskonto. Uppgradera för att få allt och bjuda in fler.',
  settings_seeSubscriptions: 'Uppgradera',
  settings_youHave: 'Du har {count} ',
  settings_inviteAgain: 'inbjudningar kvar.',
  settings_addMore: 'för att lägga till fler i din plan',
  error_trigger_title: 'Test av felgräns',
  error_trigger_subtitle:
    'Klicka på knappen för att utlösa ett renderingsfel och verifiera den globala felgränsen.',
  error_trigger_button: 'Utlös fel',
  settings_addMember: 'Lägg till medlem',
  settings_invitedMember: 'Inbjudna medlemmar',
  settings_emptyGiftMembers: 'Inga obesvarade inbjudningar',
  settings_inviteTo: 'Klicka här för att bjuda in till familjeprenumerationen',
  settings_pendingSubscription: 'Din prenumeration är {status}.',
  settings_notificationsSubheading: 'Välj vad du vill få från oss.',
  settings_notificationsTitle: 'Notisinställningar',
  settings_preferenceText: 'Aviseringar om samtal och direkta meddelanden.',
  settings_reminders: 'Påminnelser',
  settings_remindersText: 'Minnesdagar och stilla påminnelser.',
  settings_anniversary_marking: 'Jag vill ha markeringar på märkesdagar',
  settings_anniversary_in_app: 'Visa markeringen i Nätgrav',
  settings_anniversary_email: 'Skicka även e-post till mig',
  settings_genealText: 'Nyheter och information från Nätgrav.',
  settings_textMessage: 'SMS',
  settings_general: 'Allmänna uppdateringar',
  delete: 'Ta bort',
  settings_goToAgreements: 'Klicka här',
  settings_shareLink: 'Kopiera och dela din Nätgrav-inbjudan',
  grave_invitation_shareLink: 'Kopiera och dela din grav-inbjudningslänk',
  settings_copyToClipboard: 'länk kopierad',
  discard_subheading: 'Du kan fortsätta redigera eller avsluta nu.',
  no: 'Nej',
  yes: 'Ja',
  invitation: 'Inbjudan',
  information: 'Information',
  interests: 'Intressen',
  note: 'Anteckning',
  relative: 'Familj',
  uploadingImages: 'laddar upp bilder',
  uploading: 'Laddar upp',
  lifeEvent: 'Livshändelse',
  Workplace: 'Arbetsplats',
  delete_modalHeading: 'Bekräfta att du vill ta bort',
  picture: 'bild',
  paymentMethod: 'Betalningsmetod',
  vippsAgreement: 'Vipps-avtal',
  settings_complete_subscription: 'Slutför prenumerationen',
  pending_message:
    'Din prenumeration är ofullständig. Slutför prenumerationen för att fortsätta använda Conscious-funktioner.',
  pending_title: 'Din betalningsöverenskommelse väntar',
  stopped_title: 'Din betalningsöverenskommelse avbröts',
  stopped_message:
    'Prenumerationen är ofullständig eftersom överenskommelsen avbröts. Slutför prenumerationen för att fortsätta använda Conscious-funktioner.',
  expired_title: 'Din betalningsöverenskommelse har löpt ut',
  expired_message:
    'Prenumerationen är ofullständig eftersom överenskommelsen löpt ut. Slutför prenumerationen för att fortsätta använda Conscious-funktioner.',
  complete_setup: 'slutför inställning',
  cancelled_title: 'Din prenumeration är avbruten',
  cancelled_message:
    'Prenumerationen är avbruten. Du kan återaktivera före {period_end_date} för fortsatt åtkomst till Conscious-funktioner. Därefter nedgraderas till gratisplan.',
  activeStopped_title: 'Din betalningsöverenskommelse har avslutats',
  activeStopped_message:
    'Prenumerationens betalningsmetod har löpt ut. Förnya för att fortsätta använda Conscious-funktioner. Vid fortsatt problem nedgraderas till gratisplan efter cykeln.',
  renew_Agreement: 'Förnya betalningsavtal',
  add_card: 'Lägg till betalningsmetod',
  Reactivate: 'Återaktivera prenumeration',
  active_title: 'Din prenumeration aktiveras snart',
  active_message:
    'Din prenumeration behandlas och aktiveras om några minuter. Tack för tålamodet – du får snart åtkomst till Conscious-tjänster.',
  activeExpired_title: 'Din betalningsöverenskommelse har löpt ut',
  activeExpired_message:
    'Prenumerationens betalningsmetod har löpt ut. Förnya eller skapa ett nytt avtal för fortsatt åtkomst.',
  notValid_title: 'Betalningsmetod saknas',
  notValid_message:
    'Det verkar som att din betalningsmetod saknas eller är ogiltig. Uppdatera dina betalningsuppgifter för oavbruten tjänst.',
  consciousness: 'Om oss',
  about_us: 'Om Nätgrav',
  team: 'Vår berättelse',
  careers: 'Bli en del av oss',
  features: 'Om graven',
  available_sustainable: 'Alltid tillgänglig',
  maintenance_free_grave: 'Lätt att använda',
  memory_album: 'Personer',
  value_archive: 'Egenskaper och berättelser',
  memorial_wall: 'Bestående gravbesök',
  life_archive: 'Livsberättelser',
  anniversary_calendar: 'Kalender för viktiga datum',
  Family_values: 'Familjeträd (kommer snart)',
  resources: 'Hjälp och resurser',
  find_grave: 'Sök',
  blog: 'Blogg',
  help_center: 'Frågor och svar',
  contact: 'Kontakt',
  contact_us: 'Kontakta oss',
  business_inquiries: 'Affärsförfrågningar',
  feedback: 'Dela dina tankar',
  basic_information: 'Grundläggande information',
  interest: 'Intresse',
  notes: 'Anteckningar',
  passion: 'Passion',
  relation: 'Relation',
  life_event: 'Livshändelse',
  subscription_invitation: 'Prenumerationsinbjudan',
  cookies_banner_text:
    'Vi använder nödvändig lagring och vår egen trafikmätning för att driva och förbättra Nätgrav.',
  cookies_more: 'Läs mer',
  cookies_accept: 'Godkänn',
  cookies_reject: 'Avvisa',
  cookies_manage: 'Ändra cookieval',
  cookies_page_title: 'Kakor och mätning',
  cookies_page_subtitle: 'Nödvändig lagring och Nätgravs egen trafikmätning.',
  cookies_necessary_title: '1. Nödvändig lagring',
  cookies_necessary_body:
    'Nätgrav använder nödvändig lokal lagring och sessionsteknik för inloggning, säkerhet, språk och grundläggande funktioner. Detta kan inte stängas av i tjänsten när det krävs för den funktion du använder.',
  cookies_first_party_title: '2. Nätgravs egen mätning',
  cookies_first_party_body:
    'Vi räknar sidvisningar och sessioner i vårt eget system för att förstå den samlade användningen, upptäcka tekniska problem och filtrera robotar. Mätningen använder pseudonyma sessions- och besöksnycklar, sidkategori, webbläsartyp, ungefärligt land och en tidsbegränsad hash av IP-adressen. Rapporter används på aggregerad nivå och delas inte med partner som användarprofiler.',
  cookies_list_title: '3. Översikt',
  cookies_list_body:
    'Nödvändiga delar omfattar Nätgravs session och inställningar som språk och visning. Nätgrav använder inte Google Analytics, Google Tag Manager eller analyskakor från tredje part.',
  rooms_landing_eyebrow: 'Rum',
  rooms_landing_title: 'En plats att samlas kring det som betyder något.',
  rooms_landing_lead:
    'Ett rum samlar människor kring det som betyder något. Inte en grupp. Inte en tråd. Ett rum där du sätter tonen, bjuder in dem du vill och skapar en gemenskap kring något som faktiskt betyder något för dig.',
  rooms_landing_coming_soon: 'Kommer snart till Nätgrav.',
  rooms_landing_preview_label: 'Preview',
  rooms_landing_panel_quote: 'Ingen algoritm bestämmer vem som ser vad. Det gör du.',
  rooms_landing_open_rooms: 'Öppna rum',
  rooms_landing_closed_rooms: 'Stängda rum',
  rooms_landing_private_rooms: 'Privata rum',
  rooms_landing_what_title: 'Vad är ett rum?',
  rooms_landing_what_body_1:
    'Ett rum är en gemenskap du skapar kring en tanke, en upplevelse, en sorg eller en glädje. Du bestämmer vem som är välkommen, vad rummet handlar om och hur det hålls tryggt.',
  rooms_landing_what_body_2:
    'Vissa rum är öppna. Alla kan läsa, men man måste gå med för att delta. Andra är stängda, där du godkänner vem som kommer in. Och några är privata, bara för dem du själv bjuder in.',
  rooms_landing_who_title: 'Vem kan skapa ett rum?',
  rooms_landing_who_body: 'Alla med ett Nätgrav-konto kan skapa ett rum.',
  rooms_landing_use_case_1: 'Du som har förlorat någon och vill samla dem som kände personen.',
  rooms_landing_use_case_2: 'En sjuksköterska som vill ge anhöriga en trygg plats.',
  rooms_landing_use_case_3: 'En psykolog eller samtalsledare som håller en sorggrupp.',
  rooms_landing_use_case_4: 'En vän som vill hålla ett minnesrum levande över tid.',
  rooms_landing_who_question: 'Det enda vi frågar är: hur vill du hålla rummet tryggt?',
  rooms_landing_support_title: 'Stöd rummet du bryr dig om',
  rooms_landing_support_body_1:
    'Vissa rum förtjänar att leva länge. Om du håller ett rum som betyder något för andra kan du öppna för stöd. De som finner värde där kan bidra med till exempel 99 kr i månaden.',
  rooms_landing_support_body_2:
    'Stödet är en månadsprenumeration. Nätgrav behåller 15 %, och betalningsavgifter dras av innan resten betalas ut till dig.',
  rooms_landing_directions_title: 'Inriktningar',
  rooms_landing_directions_body:
    'Alla rum tillhör en inriktning, en kategori som hjälper människor att hitta det som är relevant för dem. Du väljer inriktning när du skapar rummet, och ditt rum kan bli synligt för dem som söker just det du erbjuder.',
  rooms_landing_direction_grief: 'Sorg och förlust',
  rooms_landing_direction_relationships: 'Relationer',
  rooms_landing_direction_life_choices: 'Livsval',
  rooms_landing_direction_health: 'Hälsa',
  rooms_landing_direction_eot: 'End of Time Consciousness',
  rooms_landing_cta_eyebrow: 'Tidigt tillträde',
  rooms_landing_cta_title: 'Rum är på väg in i Nätgrav.',
  rooms_landing_cta_body:
    'Funktionen är inte helt lanserad ännu. Befintliga rum är fortfarande tillgängliga för dem som redan använder dem.',
  rooms_landing_cta_primary: 'Skapa ett rum',
  rooms_landing_cta_secondary: 'Läs villkor',
  find_grave_norway: 'Hitta en grav',
  find_grave_value_statement: 'Se var någon är gravsatt, och besök graven på nätet.',
  search_grave: 'Sök efter namn',
  search_recent_title: 'Nyliga sökningar',
  search_recent_clear: 'Rensa',
  search_recent_remove: 'Ta bort',
  search_suggestions_title: 'Förslag',
  search_searching: 'Söker…',
  search_no_results: 'Inga resultat',
  or: 'eller',
  find_grave_create_cta: 'lägg till en grav',
  create_netgrave: 'skapa en Nätgrav',
  netgrave: 'Nätgrav',
  visit: 'Besök',
  relation_summary_self: 'Jag är {relationLower}',
  relation_summary_target: '{name} är min {relationLower}',
  relation_summary_fallback_person: 'den här personen',
  visit_grave: 'Hitta den du tänker på',
  wish: '',
  find_grave_practical_reason:
    'Här kan du hitta gravar i {municipalityName} och vara nära dem som betyder något för dig.',
  find_grave_cemetery_practical_reason:
    '{cemeteryName} ligger i {municipalityName}. Här kan du hitta grav och se vem som är begravd på kyrkogården. Sök efter namn för att hitta rätt gravplats och besöka graven på nätet.',
  find_grave_support_statement: 'Små handlingar ger utrymme för närhet över tid.',
  find_grave_guest_cta_title: 'När du hittar rätt grav',
  find_grave_guest_cta_body: 'kan du knyta dig till den, lämna ett tecken och följa med över tid.',
  find_grave_guest_cta_button: 'Ta hand om en grav',
  find_grave_search_heading: 'Sök efter namn',
  find_grave_search_description: 'Börja med ett namn för att hitta rätt grav.',
  find_grave_name_placeholder: 'Skriv ett namn, t.ex. Anna Andersson',
  second_section_description: 'Börja med ett namn, eller utforska kommun och kyrkogård.',
  find_grave_start_hint: 'Skriv ett namn',
  find_grave_faq_title: 'Vanliga frågor',
  find_grave_faq_question_1: 'Hur hittar jag en grav?',
  find_grave_faq_answer_1:
    'Sök på namn. Du kan också använda kommun eller kyrkogård för att smalna av träffarna.',
  find_grave_faq_question_2: 'Kan jag söka på kommun eller kyrkogård?',
  find_grave_faq_answer_2:
    'Ja. Skriv kommunen eller kyrkogården i söket, eller välj vidare från översikten.',
  find_grave_faq_question_3: 'Vad gör jag om jag inte hittar personen?',
  find_grave_faq_answer_3:
    'Prova en annan stavning eller sök med färre ord. Du kan också skapa en Nätgrav om den saknas.',
  memorial_plaque: 'Kommuner',
  memorial_plaque_description: 'Utforska kommuner och gravplatser.',
  archive: 'Kyrkogårdar',
  archive_description: 'Se kyrkogårdar i kommunen.',
  memory_album_description: 'Hitta personer som är gravsatta där.',
  find_municipality: 'Gravar i dessa kommuner',
  search_municipality: 'Sök efter län',
  find_grave_municipality_cta: 'Se kyrkogårdar',
  it_is: 'Det är',
  find_grave_count: '{count}',
  municipality_description: 'Sök bland {count} kommuner och hitta den grav du letar efter.',
  no_results: 'Inga resultat för',
  find_cemetery: 'Välj en kyrkogård i {municipalityName}',
  find_cemetery_generic: 'Hitta en grav på dessa kyrkogårdar',
  search_cemetery: 'Sök efter kyrkogård',
  cemetery_description:
    'kyrkogårdar i {municipalityName}. Utforska kyrkogårdarna för att hitta personer som är gravsatta där.',
  grave_description:
    'personer som är gravsatta här. Sök efter namn för att hitta rätt gravplats och besöka graven på nätet.',
  goto_grave: 'visa grav',
  payment_due_message:
    'Din prenumeration är aktiv. Betalningen behandlas. Vipps hanterar avgiften.',
  payment_due_title: 'Din prenumeration är aktiv',
  find_grave_image_title: 'Graven ger ett nytt perspektiv på vårt liv. På din',
  find_grave_text: 'har du en egen vägg där kontakter kan ställa frågor.',
  life_page: 'Livssida',
  the_life_page: 'Mitt Ljus',
  first_description: 'Följ din Gnista. Här kan du dela din egen gnista och svara på andras.',
  your_graves: 'De du bär med vidare',
  second_description: 'Personerna du har kopplat till dig länkas till ditt Ljus.',
  update: 'Dina relationer',
  third_description: 'De närmaste blir en del av ditt Ljus.',
  find_grave_last_text:
    'Välkommen till Nätgrav Ett socialt nätverk för livets verkliga utmaningar – där vi börjar med meningsfulla, tillgängliga och underhållsfria gravar för oss som ska leva vidare. Vi hoppas också få uppleva din inre gnista – dina erfarenheter från livet som du finner mod att dela med andra. Världen behöver höra dina ord och tankar.',
  plans_page_heading: 'Ett medvetet val för ett meningsfullt liv',
  plans_page_subheading:
    'Släpp taget om det förflutna, omfamna resan framåt med den mest värdefulla graven för dina nära och kära.',
  per_user: 'per medlem',
  current_members: 'Aktuella medlemmar',
  added_members: 'Antal medlemmar som ska läggas till',
  removed_members: 'Antal medlemmar som ska tas bort',
  view_current_members: 'Visa aktuella medlemmar',
  total_members: 'Medlemmar efter ändring',
  plan_price: 'Planpris',
  increment_text: 'Välj antal prenumerationer du vill ha för dig och din familj',
  free_description: 'För dem som vill söka efter och besöka gravar utan kostnad.',
  conscious_description:
    'Med Conscious-prenumeration blir du en verifierad anhängare av End Of Time-perspektiven.',
  consciousPlus_description:
    'Åtkomst som Conscious, med extra tonvikt på gravens etik. Pris: 500 NOK per år',
  total_user_count: 'För {subscriptionTotalCount} familjemedlemmar är totalbeloppet:',
  per_month: 'per månad',
  current_plan: 'Aktuell plan',
  got_started: 'Kom igång',
  free_feature_heading: 'Alla funktioner ingår i gratisplanen',
  conscious_feature_heading: 'Alla funktioner ingår i gratisplanen, plus ytterligare',
  conscious_plus_feature_heading: 'Alla funktioner ingår i Conscious-planen, plus ytterligare',
  feature_memory_album: 'Minnealbum',
  feature_purposes: 'Syften',
  feature_end_of_time: 'End Of Time-mynt',
  feature_family_tree: 'Släktträd',
  feature_testament: 'Testamente',
  feature_groups: 'Grupper (gemenskaper)',
  feature_Shop: 'Närvaro',
  feature_Sparks: 'Sparks',
  feature_life_page: 'Mitt ljus',
  feature_search_grave: 'Sök efter gravar',
  feature_create_grave: 'Skapa Spark',
  question_answer: 'Frågor och svar',
  feature_life_archive: 'Livsarkiv',
  feature_anniversary_calendar: 'Minnesdagskalender',
  feature_memory_wall: 'Minnesvägg',
  feature_value_archive: 'Egenskaper',
  benefits_1_title: 'Kärleken fortsätter',
  benefits_1_description:
    'Varje conscious grav är en plats där kärleken lever vidare – med värdighet, värme och mening.',
  benefits_2_title: 'Stödjer det som räddar liv',
  benefits_2_description:
    'Din gåva går direkt till forskning och utveckling för att förstå och övervinna det som tar liv.',
  benefits_3_title: 'En meningsfull grav',
  benefits_3_description:
    'Från blommor och ljus – till handling. Conscious-gravar hjälper till att forma en bättre framtid.',
  benefits_4_title: 'Mot en värld utan oönskad död',
  benefits_4_description:
    'Tillsammans skapar vi hopp. Varje grav för oss ett steg närmare en säkrare och mer hel värld.',
  benefits_title: 'Bra skäl att välja Conscious på Nätgrav',
  faqs_1_question: 'Vilka betalningsmetoder accepterar ni?',
  faqs_1_answer: 'Vi accepterar kredit-/betalkort (Visa, Mastercard) och Vipps',
  faqs_2_question: 'Finns det några ytterligare avgifter jag bör känna till?',
  faqs_2_answer:
    'Det finns inga dolda avgifter. Här kan du samla alla gravar och begravningar utan extra kostnader',
  faqs_3_question: 'Hur uppdaterar jag mina betalningsuppgifter?',
  faqs_3_answer:
    'För att uppdatera dina betalningsuppgifter, gå till dina kontoinställningar och välj fliken prenumeration',
  faqs_4_question: 'Vad händer efter att betalningen är slutförd?',
  faqs_4_answer:
    'När betalningen är slutförd får du en avisering från Nätgrav som indikerar att din prenumeration har aktiverats.',
  faqs_5_question: 'Vad är skillnaden mellan Free och Conscious?',
  faqs_5_answer:
    'Gratisprenumeration ger fem sökningar och fem minnen. Det finns också begränsning för storlek på media som kan läggas till gravar. Med Conscious har du obegränsad åtkomst till alla funktioner och nya funktioner som läggs till.',
  faqs_6_question: 'Vem är Conscious-planen för?',
  faqs_6_answer:
    'Conscious är för dem som vill ha det mesta av livet. Den ger dig frihet att släppa gamla antaganden och ritualer. Med Conscious har du alltid åtkomst till funktioner som stöder din resa i livet – med utgångspunkt i den mest meningsfulla graven för dina nära och kära och vårt löfte att alltid vägleda dig till där kärleken är.',
  update_modal_change_plan: 'Byt {name}-plan',
  waite_for_validation: 'Vänligen vänta medan vi kontrollerar din prenumeration',
  add_members: 'Lägg till medlemmar',
  remove_members: 'Ta bort medlemmar',
  allowed_members: 'Tillåtet antal medlemmar',
  how_many_add: 'Hur många medlemmar vill du lägga till?',
  how_many_remove: 'Hur många medlemmar vill du ta bort?',
  not_remove_all: 'Behåll minst en medlem.',
  updated_price: 'Uppdaterat pris efter ändringarna',
  remaining_members: 'Totalt återstående medlemmar',
  total_price: 'Totalpris',
  extra_user:
    'För ytterligare {subscriptionTotalCount} familjemedlemmar tillkommer en extra kostnad',
  process_payment: 'Gå till betalning',
  continue: 'Fortsätt',
  subscription_members: 'Prenumerationsmedlemmar',
  remove_subscription_members: 'Ta bort prenumerationsmedlemmar genom att klicka ta bort',
  subscription_invitation_members: 'Inbjudningar till prenumeration',
  remove_invitation_members: 'Ta bort prenumerationsinbjudan genom att klicka ta bort',
  downgrade_plan: 'Nedgradera plan',
  upgrade_plan: 'Uppgradera plan',
  downgrade_message:
    'Inaktivera alla prenumerationsmedlemmar och inbjudningar för att fortsätta nedgradera',
  upgrade_message: 'Ta bort alla prenumerationsmedlemmar och inbjudningar för att uppgradera',
  close_message: 'Du kan nu stänga och fortsätta',
  close: 'Stäng',
  active_members: 'Aktiva medlemmar i din prenumeration',
  active_members_message:
    'För att fortsätta, inaktivera en eller flera medlemmar från din prenumeration.',
  active_members_empty_message: 'Inga aktiva medlemmar hittades i din prenumeration',
  active_invitations: 'Väntande inbjudningar för din prenumeration',
  active_invitations_message: 'Återkalla gärna inbjudningarna för medlemmar för att fortsätta.',
  active_invitations_empty_message: 'Inga utestående inbjudningar kopplade till din prenumeration',
  check_out: 'Betala',
  select_payment_method: 'Välj betalningsmetod',
  order_details: 'Orderdetaljer',
  subscription_number: 'Antal prenumerationer',
  taxes: 'Skatter',
  total: 'Totalt att betala:',
  sub_total: 'Ordinarie medlemspris:',
  discount_title: 'Faktureringsfrekvens:',
  subscription_length: 'Planlängd',
  discount: 'Rabatt för flera medlemmar:',
  renewal: 'Prenumerationen förnyas automatiskt.',
  renewal_details: 'Fornyelse sker enligt vald faktureringsfrekvens. Du kan avbryta när som helst.',
  payment_page_terms: 'Genom att välja "Nästa" eller "Prenumerera" godkänner du våra',
  terms_conditions: 'Användarvillkor.',
  terms_conditions_page_title: 'Vilkår & betingelser',
  terms_conditions_page_subtitle: 'Allmänna användarvillkor och integritet för natgrav.se',
  terms_conditions_section1_title: '1. Allmänt',
  terms_conditions_section1_body:
    'natgrav.se är en digital mötesplats där familj och vänner kan samlas kring den avlidne. Tjänsten erbjuder ett molnbaserat gravrum där anhöriga kan tända ljus, dela bilder, berättelser och andra handlingar när behovet uppstår. Förutom att skapa och besöka en Nätgrav kan medlemmar använda Gravalbumet, Gravtavlan, Värdearkivet och Livsarkivet. Vissa delar av tjänsten har egna villkor – exempelvis priser, betalningsmetoder eller avtalstid – som presenteras på webbplatsen. Om dessa särskilda villkor skiljer sig från de allmänna villkoren här gäller de särskilda villkoren i första hand.',
  terms_conditions_section2_title: '2. Registrering, användarnamn och lösenord',
  terms_conditions_section2_body:
    'Hur du får åtkomst till tjänsten beror på om du ansvarar för den fysiska graven eller besöker den digitalt. Du kan registrera ett konto på natgrav.se eller via andra tjänster och sociala medier i den mån Nätgrav erbjuder detta. Om du registrerar dig via en tredjepart godkänner du att Nätgrav hämtar nödvändiga uppgifter för att skapa kontot. Du ansvarar för att den information du lämnar vid registrering är korrekt. Lösenordet är personligt och får inte delas. Om du misstänker obehörig användning ska du omedelbart kontakta Nätgrav AS och byta lösenord. För att skydda tjänsten kan Nätgrav AS begära att du uppdaterar ditt lösenord när som helst.',
  terms_conditions_section3_title: '3. Användning av tjänsten',
  terms_conditions_section3_body:
    'Du ansvarar för din egen användning av produkten och ska endast använda tjänsten för dess avsedda syfte. Du förbinder dig att hålla Nätgrav AS skadeslöst för eventuella konsekvenser av lagbrott eller krav från tredje part som uppstår genom din användning av produkten och de tjänster som erbjuds.',
  terms_conditions_section4_title: '4. Priser och betalning',
  terms_conditions_section4_body:
    'Lägg till priserna för tjänsten visas på natgrav.se och kan ändras vid behov. samtliga priser presenteras inklusive tillämpliga skatter när detta.',
  terms_conditions_section5_title: '5. Ansvarsbegränsning',
  terms_conditions_section5_body:
    'Om inget annat anges ansvarar inte Nätgrav AS för information eller innehåll som publiceras eller skickas via tjänsterna. Nätgrav har ingen kontroll över externa webbplatser som vi länkar till och ansvarar inte för deras innehåll. I den utsträckning lagen tillåter friskriver sig Nätgrav AS från ansvar för skador eller förluster som beror på dina handlingar eller försummelser i samband med tjänsten.',
  terms_conditions_section6_title: '6. Ändringar',
  terms_conditions_section6_body:
    'Nätgrav AS kan när som helst justera innehållet i eller omfattningen av tjänsterna, liksom priser och andra villkor. Om ändringarna är väsentliga och till nackdel för dig meddelas du via brev, SMS eller e-post till den adress du har registrerat, senast 30 dagar innan ändringen träder i kraft. Om du inte accepterar de nya villkoren kan du säga upp ditt medlemskap när som helst.',
  terms_conditions_section7_title: '7. Avtalstid och uppsägning',
  terms_conditions_section7_body:
    'Du kan när som helst radera ditt konto och eventuella abonnemang. Kontakta kontakt@nettgrav.no om du har frågor eller behöver hjälp.',
  terms_conditions_section8_title: '8. Reklamation',
  terms_conditions_section8_body:
    'Om du vill reklamera en leverans ska du meddela Nätgrav AS via e-post, telefon, brev eller genom webbplatsen inom fem dagar från leverans. Blommor och växter räknas som färskvaror och omfattas inte av ångerrätten.',
  terms_conditions_section9_title: '9. Integritet',
  terms_conditions_section9_1_title: '9.1 Allmänt',
  terms_conditions_section9_1_paragraph1:
    'Din integritet är viktig och enligt gällande lagstiftning informerar vi dig om följande:',
  terms_conditions_section9_1_paragraph2:
    'Nätgrav AS, Damstredet 3, 0177 Oslo (org.nr. 912 857 336) är personuppgiftsansvarig för de uppgifter som behandlas i samband med leverans av produkten och tjänsterna. Nätgrav AS behandlar personuppgifter i enlighet med norsk personuppgiftslagstiftning.',
  terms_conditions_section9_1_paragraph3:
    'Genom att registrera ett konto samtycker du till att Nätgrav AS behandlar personuppgifter i enlighet med dessa villkor och vår integritetspolicy.',
  terms_conditions_section9_2_title: '9.2 Syfte',
  terms_conditions_section9_2_body:
    'Nätgrav AS behandlar personuppgifter för att kunna leverera tjänsterna, analysera hur de används, administrera kundrelationer, kommunicera med kontoinnehavare och uppfylla rättsliga förpliktelser.',
  terms_conditions_section9_3_title: '9.3 Vilka personuppgifter behandlas?',
  terms_conditions_section9_3_body:
    'Vi behandlar de uppgifter du lämnar vid registrering samt den information som skapas när du använder tjänsten. Det kan exempelvis röra sig om namn, adress, telefonnummer, e-postadress, betalningsuppgifter samt relevanta uppgifter om den avlidne och de bidrag som läggs till graven.',
  terms_conditions_section9_4_title: '9.4 Utlämning av uppgifter',
  terms_conditions_section9_4_body:
    'Nätgrav AS kan lämna ut personuppgifter till leverantörer som utför tjänster för vår räkning, till exempel drift, IT eller kundsupport. Vi lämnar inte ut personuppgifter till andra tredje parter och använder inte dina data för träning av AI.',
  terms_conditions_section9_5_title: '9.5 Rättelse, radering och insyn',
  terms_conditions_section9_5_body:
    'Du har rätt att begära insyn i de personuppgifter som Nätgrav AS behandlar om dig. Du kan också begära att uppgifter korrigeras, kompletteras eller raderas när det finns rättslig grund för det.',
  terms_conditions_section9_6_title: '9.6 Användning av cookies',
  terms_conditions_section9_6_body:
    'Vi använder cookies på webbplatsen. Cookies är små textfiler som lagras på din enhet och gör att vi kan komma ihåg dina val och hur tjänsten används. Informationen hjälper oss att anpassa webbplatsen, göra tjänsterna mer användarvänliga och mäta trafiken.',
  terms_conditions_section9_6_paragraph2:
    'De flesta moderna webbläsare accepterar cookies automatiskt, men du kan själv välja att stänga av dem. Vi använder inte cookies för att personalisera upplevelsen individuellt – alla ser samma innehåll.',
  terms_conditions_section9_6_paragraph3:
    'Trafiken mäts i Nätgravs eget system med pseudonyma besöks- och sessionsnycklar. Vi använder inte Google Analytics eller andra externa analysverktyg för denna mätning, och mätdata delas inte med kommersiella partner som användarprofiler.',
  terms_conditions_section9_6_paragraph4: '',
  terms_conditions_section10_title: '10. Tvister',
  terms_conditions_section10_body:
    'Dessa villkor regleras av norsk lag och eventuella tvister ska avgöras av norska domstolar. Oslo tingrett (tingsrätt) är avtalt forum.',
  terms_conditions_section11_title: '11. Kontaktinformation',
  terms_conditions_section11_body:
    'Har du frågor om tjänsten kan du kontakta Nätgrav AS på kontakt@nettgrav.no, +47 450 07 009 eller via post: Damstredet 3, 0151 Oslo.',
  terms_conditions_accept_button: 'Acceptera',
  terms_conditions_reject_button: 'Avvisa',
  change_free_plan: 'Gratisplanen är kostnadsfri',
  free_plan_message:
    'Med gratis kan du utforska, besöka och skapa Nätgrav. Gratis är en grundläggande värdering.',
  ending_with: 'slutar med',
  add_payment_method: 'Lägg till betalningsmetod',
  name_on_card: 'Namn på kort',
  expiry_date: 'Utgångsdatum',
  secure_payment_message: 'Säker betalning med SSL-kryptering',
  billing_address: 'Faktureringsadress',
  enter_address: 'Ange adress',
  billing_info_message:
    'Denna information används för att utfärda första fakturan. Du kan uppdatera framtida fakturadetaljer i din kontoprofil.',
  subscribe: 'Prenumerera',
  select_language: 'Välj språk',
  payment_error: 'Betalningsfel',
  subscription_waiting_message: 'Betalning behandlas. Vänligen vänta, din prenumeration bearbetas',
  success_message: 'Prenumerationen avbröts framgångsrikt',
  reactivate_success_message: 'Prenumerationen har återaktiverats',
  choose_plan: 'Välj en plan innan du prenumererar',
  canceling_waite_message: 'Avbokning av prenumeration pågår, vänligen vänta…',
  subscription_overview: 'Prenumerationsöversikt',
  users: 'Medlemmar',
  for_members: 'För {user} medlemmar',
  for_member: 'För {user} medlem',
  for_6_members: 'För {user} eller fler',
  billing_cycle: 'Faktureringscykel',
  amount: 'Belopp',
  cancelSubscriptionInfo:
    'Abonnemanget avslutas på slutdatumet och går över till gratisplan. Du kan starta igen när som helst.',
  confirm_billing_cycle: 'Spara ändringar',
  different_cycle: 'Välj en annan faktureringscykel',
  update_billing: 'Faktureringscykeln har uppdaterats',
  waiting_update_billing_cycle: 'Ett ögonblick, uppdaterar faktureringscykeln…',
  add_members_message: 'Medlemmar har lagts till',
  remove_members_message: 'Medlemmar har tagits bort',
  your_current_plan: 'Din nuvarande plan',
  upgrade_to: 'Uppgradera till {planName}',
  downgrade_to: 'Nedgradera till {planName}',
  members_removed: 'Prenumerationsmedlem har tagits bort',
  invitation_removed: 'Inbjudningsmedlem har tagits bort',
  mann: 'Man',
  kvinne: 'Kvinna',
  annen: 'Annan',
  life_page_description: 'Här hittar du dina gravar och Mitt Ljus.',
  settings: 'Inställningar',
  settings_description: 'Dina kontouppgifter såsom lösenord, prenumeration och person.',
  logout: 'Logga ut',
  logout_description: 'Gör något snällt. En blick. Ett leende. Ett ord. Ditt ljus betyder något.',
  logout_success: 'Du är nu utloggad.',
  create_new_grave: 'Skapa ny grav',
  create_grave_description: 'Skapa en ny gravpost för en avliden i registret.',
  new: 'Ny',
  read: 'Läs',
  empty_notification_message: 'Nya aviseringar visas här',
  public_anniversaries: 'Offentliga högtidsdagar',
  grave_anniversaries: 'Minnesdagar',
  public_anniversary: 'Offentlig högtidsdag',
  grave_anniversary: 'Privat minnesdag',
  anniversary: 'Minnesdag',
  birthday_event: 'Födelsedag',
  death_anniversary_event: 'Dödsdag',
  memorial_days: 'Minnesdagar',
  anniversary_delete: 'Minnesdagen har tagits bort.',
  anniversary_created: 'Minnesdagen har skapats.',
  anniversary_updated: 'Minnesdagen har uppdaterats.',
  empty_anniversaries: 'Inga minnesdagar har skapats än.',
  anniversaries_today: 'I dag',
  anniversaries_upcoming: 'Kommande',
  anniversaries_past: 'Tidigare',
  anniversaries_past_empty: 'Inga tidigare minnesdagar ännu.',
  anniversaries_personal: 'Dina minnesdagar',
  anniversaries_personal_empty: 'Du har inte lagt till några minnesdagar ännu.',
  anniversaries_personal_login: 'Logga in för att lägga till egna dagar.',
  anniversaries_care_title: 'Omsorg över tid',
  anniversaries_care_body:
    'Ljus och gravskötsel kan tas om hand på minnesdagar, även när ingen är i närheten.',
  anniversaries_care_soon: 'Kommer snart',
  anniversaries_focus_title: 'Denna dag',
  anniversaries_focus_today: 'Tänd ett ljus i dag för att vara nära.',
  anniversaries_focus_future: 'Ljus kan beställas för den här dagen.',
  anniversaries_focus_future_scheduled:
    '{count, plural, one {# ljus är beställt för den här dagen.} other {# ljus är beställda för den här dagen.}}',
  anniversaries_focus_future_scheduled_self: 'Du har beställt ett ljus för den här dagen.',
  anniversaries_focus_future_cta: 'Beställ ljus',
  anniversaries_focus_past: 'Denna dag ligger bakom oss. Minnet består.',
  anniversaries_focus_empty: 'Välj en minnesdag för att se detaljer.',
  anniversaries_recurring_note: 'Årligen · {year}',
  anniversaries_show_all: 'Visa alla',
  anniversaries_show_less: 'Visa färre',
  candles_now: 'Ljus nu',
  candles_on_selected_day: 'Ljus denna dag',
  candles_on_selected_day_empty: 'Inga ljus denna dag.',
  schedule_candle: 'Beställ ljus',
  schedule_candle_cta: 'Beställ',
  scheduled_gift_context_label: 'Beställer för',
  scheduled_gift_created: 'Ljuset är beställt.',
  scheduled_gift_error: 'Kunde inte beställa ljus.',
  scheduled_gift_load_error: 'Kunde inte hämta beställda ljus just nu.',
  quiet_presence_count: 'Tysta närvaror · {count}',
  quiet_presence_zero: 'Inga tysta närvaror ännu',
  quiet_presence_return: 'Du har varit här tidigare',
  calendar_today_with_date: 'Idag, {date}',
  calendar_today: 'Idag',
  calendar_tomorrow: 'Imorgon',
  calendar_upcoming: 'Kommande',
  calendar_month: 'Månad',
  calendar_week: 'Vecka',
  calendar_day: 'Dag',
  weekday_short_0: 'Sön',
  weekday_short_1: 'Mån',
  weekday_short_2: 'Tis',
  weekday_short_3: 'Ons',
  weekday_short_4: 'Tor',
  weekday_short_5: 'Fre',
  weekday_short_6: 'Lör',
  create: 'Skapa',
  add_dates: 'Lägg till datum',
  date: 'Datum',
  time: 'Tid',
  title: 'Titel',
  reset_time: 'Återställ tid',
  home: 'Hem',
  about: 'Om',
  howTo: 'Hur man',
  plans: 'Planer',
  find_a_grave: 'Hitta en grav',
  create_a_grave: 'Skapa en grav',
  take_control: 'Ta kontroll över graven',
  pricing: 'Priser',
  get_started: 'Kom igång',
  create_new_account: 'Skapa ditt eget konto.',
  did_you_know: 'Visste du att',
  registration_description_one:
    'Här finns ingen gravrätt eller gravskötsel. Du behöver inte tänka på underhåll. Nätgrav tar hand om det yttre – du tar hand om det inre.',
  registration_description_two:
    'En grav att ta med i livet. Att minnas någon är också ett sätt att älska.',
  registration_description_three:
    'Du behöver inte prestera här. Det räcker att bara vara närvarande.',
  enter_your_password: 'Ange ditt lösenord',
  confirm_your_password: 'Bekräfta ditt lösenord',
  type_your_email: 'Ange din e-postadress',
  type_email: 'Ange e-post',
  hi: 'Hej {name}',
  dream_world_question: 'Hur ser din drömvärld ut?',
  decline: 'Avvisa',
  read_only: '(endast läsning)',
  accept: 'Acceptera',
  accepted_message: 'Inbjudan godkänd',
  invited_title: 'Du är inbjuden till en prenumeration',
  open: 'Öppna',
  subscription_invitation_message: 'Du är inbjuden till {subscription}-prenumeration från {name}',
  email_error: 'Ange en giltig e-post',
  password_length: 'Använd minst 8 tecken, med stora och små bokstäver och siffror.',
  filled_out: 'Fyll i alla fält för att fortsätta.',
  must_agree: 'Godkänn villkoren för att fortsätta.',
  inactive: 'Inaktiv',
  delete_payment_method: 'Tar bort betalningsmetod…',
  payment_method_deleted: 'Betalningsmetoden har tagits bort',
  payment_method_inactive: 'Din betalningsmetod är borttagen eller inaktiv.',
  subscription_changes_title: 'Du begärde dessa abonnemangsändringar.',
  period: 'Du begärde att ändra faktureringscykel från {month} {previous} till {newMonth} {new}',
  user_count: 'Du begärde att minska medlemmar från {previous} till {new}',
  product_id: 'Du begärde att byta plan från {previous} till {new}',
  remove_subscription_change: 'Begäran om ändring återställd',
  remove_subscription_loading: 'Vänligen vänta, bearbetar…',
  revert: 'Återställ',
  subscription_changes_subTitle:
    'Ändringar tillämpas efter att din nuvarande cykel slutar den {date}',
  add_new_paymentMethod: 'Lägg till betalningsmetod',
  filled_out_info: 'Se till att alla fält är ifyllda innan du fortsätter',
  continue_new_card: 'Välj betalningsmetod eller lägg till nytt kort för att fortsätta',
  create_payment_method_waiting: 'Skapar betalningsmetod…',
  login_description: 'Närhet till de döda och till livet på natgrav.se. Följ din Gnista.',
  login_with_email: 'Logga in med e-post',
  login_with_phone: 'Logga in med telefonnummer',
  account_created: 'Välkommen! Ditt konto är skapat',
  verify_account: 'E-posten är inte bekräftad',
  verification_message:
    'För att logga in, bekräfta din e-post. Kolla inkorgen eller skräppost, eller be om ett nytt mejl:',
  resend_email: 'Skicka bekräftelse-e-post igen',
  sending_verification_email: 'Verifierings-e-post skickad',
  sending_verification_code: 'Verifieringskod skickad till telefonen',
  sending_verification_waiting: 'Verifieringskod skickas…',
  email_verification: 'Verifierings-e-post har skickats. Klicka på länken i inkorgen.',
  signup_step_title: 'Bekräfta din e-post',
  signup_relation_ready:
    'Relationen är klar — vi kopplar dig till {name} så snart e-postadressen är bekräftad.',
  signup_message_heading: 'Bekräfta din e-post',
  signup_message_subheading: 'För att slutföra behöver du bekräfta din e-post.',
  signup_primary_cta: 'Vi har skickat en bekräftelselänk till {email}',
  signup_secondary_cta: 'När du öppnar länken loggas du in automatiskt.',
  signup_secondary_cta_relation:
    'När du öppnar länken loggas du in automatiskt och relationen kopplas.',
  signup_help_text: 'Hittar du inte mejlet? Kolla skräpposten eller skicka länken igen.',
  signup_verification_reason: 'Detta gör vi för att säkerställa rätt åtkomst.',
  signup_primary_action: '🕊 Väntar på e‑postbekräftelse …',
  signup_resend_action: 'Skicka länken igen',
  signup_save_email: 'Spara e-post',
  signup_cancel_email: 'Avbryt',
  signup_email_updated: 'E-posten är uppdaterad. En ny länk har skickats.',
  signup_verification_refresh_hint: 'Verifierad – uppdaterar…',
  signup_change_email: 'Ändra e-post',
  signup_login_action: 'Gå till inloggning',
  signup_resend_toast: 'Bekräftelsemejl skickades på nytt.',
  signup_waiting_cta: 'Inväntar bekräftelse',
  signup_delivery_status_label: 'E-poststatus:',
  grave_guest_visit_title: 'Besök graven',
  grave_guest_visit_body: 'Här kan du läsa, se vilka som hör till och vara närvarande runt {name}.',
  grave_guest_visit_support: 'Logga in för att knyta dig till graven och följa med vidare.',
  grave_guest_visit_primary: 'Knyt dig till graven',
  signup_delivery_status_sending: 'Skickar e-post …',
  signup_delivery_status_sent: 'E-posten har skickats från oss. Väntar på leveransbekräftelse.',
  signup_delivery_status_delivered: 'E-posten har levererats.',
  signup_delivery_status_temporary_failure:
    'Vi kunde inte leverera e-posten just nu. Försök igen om en stund.',
  signup_delivery_status_temp_over_quota:
    'E-posten kunde inte levereras eftersom inkorgen är full. Försök igen om en stund.',
  signup_delivery_status_permanent_failure:
    'E-posten kunde inte levereras. Kontrollera adressen eller använd en annan e-post.',
  signup_login_inline: 'Har du redan konto? Logga in',
  waiting_for_account: 'Skapar konto…',
  account_verification_waiting: 'Verifiering pågår…',
  account_verification_heading: 'Konto verifierat!',
  account_verification_heading_error: 'Verifiering misslyckades',
  account_verification_description: 'Ditt konto har verifierats.',
  account_verification_description_error:
    'Kunde inte verifiera. Försök igen eller kontakta support.',
  update_payment_method_waiting: 'Uppdaterar betalningsmetod…',
  update_payment_method_success: 'Betalningsmetod uppdaterad!',
  warning_payment_method: 'Välj en ny betalningsmetod',
  complete_pending_payment: 'Slutför betalningen.',
  plans_card_payment_method: 'Se betalningsalternativ här:',
  forgot_password_heading: 'Behöver du hjälp med lösenordet?',
  forgot_password_description: 'Skriv in din e-postadress, så skickar vi en länk.',
  forgot_password_button: 'Skicka länk',
  forgot_password_message: 'Vi har skickat en länk till din e-post. Kolla inkorg eller skräppost.',
  forgot_password_title: 'Länk skickad',
  forgot_password_waiting: 'Skickar länk…',
  set_new_password: 'Ange nytt lösenord',
  set_new_password_description: 'Välj nytt lösenord och bekräfta. Därefter kan du logga in.',
  set_new_password_error: 'Ange lösenord',
  set_new_password_success: 'Lösenord uppdaterat!',
  set_new_password_waiting: 'Uppdaterar lösenord…',
  action_required: 'Åtgärd krävs:',
  email_verification_alert: 'Lägg till och verifiera e-post för att fortsätta inloggning.',
  goTo_settings_page: 'Gå till inställningar',
  go_to_home_page: 'Gå till startsida',
  verify_now: 'Verifiera nu',
  authCode_verified: 'Telefon verifierad!',
  personal_information_updated: 'Personlig info uppdaterad',
  change_phone_number: 'Ändra telefonnummer',
  verify_phone_button: 'Verify phone number',
  change_email: 'Ändra e-post',
  current_email: 'Nuvarande e-post',
  new_email: 'Ny e-post',
  verify_email_button: 'Verify email',
  change_email_btn: 'Ändra e-post',
  change_password: 'Ändra lösenord',
  change_password_btn: 'Ändra lösenord',
  reset_date: 'Återställ datum',
  date_picker_day_label: 'Dag',
  date_picker_month_label: 'Månad',
  date_picker_year_label: 'År',
  date_picker_day_placeholder: 'Välj dag',
  date_picker_month_placeholder: 'Välj månad',
  date_picker_year_placeholder: 'Välj år',
  date_picker_search_placeholder: 'Sök…',
  date_picker_no_results: 'Inga träffar',
  date_picker_clear: 'Rensa val',
  sending_verification_email_waiting: 'Verifieringslänk skickad…',
  local_name: 'Lokalt namn',
  create_anniversary_waiting: 'Skapar minnesdag… vänligen vänta',
  anniversary_time_end: 'Evenemanget är avslutat',
  hello: 'Hej',
  coins: 'Mynt',
  store: 'Närvaro',
  purchase: 'Köp',
  checkout_title: 'Slutför ditt val',
  checkout_billing_address: 'Faktureringsadress',
  checkout_billing_name_label: 'Fullständigt namn',
  checkout_billing_name_placeholder: 'Fullständigt namn',
  checkout_billing_email_label: 'E-post',
  checkout_billing_email_placeholder: 'E-post',
  checkout_billing_phone_label: 'Telefonnummer',
  checkout_billing_phone_placeholder: 'Telefonnummer',
  checkout_billing_street_label: 'Gatuadress',
  checkout_billing_street_placeholder: 'Gatuadress',
  checkout_billing_city_label: 'Stad',
  checkout_billing_city_placeholder: 'Stad',
  checkout_billing_state_label: 'Kommun',
  checkout_billing_state_placeholder: 'Kommun',
  checkout_billing_postal_label: 'Postnummer',
  checkout_billing_postal_placeholder: 'Postnummer',
  checkout_billing_country_label: 'Land',
  checkout_billing_country_placeholder: 'Välj land',
  checkout_card_details: 'Kortuppgifter',
  checkout_card_number_label: 'Kortnummer',
  checkout_card_number_placeholder: '1234 1234 1234 1234',
  checkout_card_expiration_label: 'Utgångsdatum',
  checkout_card_expiration_placeholder: 'MM / ÅÅ',
  partner_card_expiration: 'Utgångsdatum',
  checkout_card_cvc_label: 'Säkerhetskod',
  checkout_card_cvc_placeholder: 'CVC',
  checkout_payment_unavailable: 'Betaltjänsten är inte redo. Försök igen.',
  checkout_missing_card_details: 'Ange ditt kortnummer för att fortsätta.',
  checkout_missing_card_expiry: 'Ange utgångsdatumet.',
  checkout_missing_card_cvc: 'Ange CVC-koden.',
  checkout_saved_payment_methods: 'Betalningsmetod',
  checkout_add_new_payment: 'Lägg till betalningsmetod',
  checkout_notice_banner_title: 'Gåva till familjen',
  checkout_notice_banner_body:
    'Den här beställningen kopplas till annonsen{hasName, select, true { för {name}} false {}}.',
  checkout_cart_title: 'Din kundvagn',
  checkout_subtotal: 'Delsumma',
  checkout_total: 'Totalt',
  checkout_checkout: 'Bekräfta ditt val',
  checkout_complete_purchase: 'Bekräfta ditt val',
  checkout_pay_amount: 'Betala {amount}',
  bonus_tc: 'Bonus TC',
  set_color: 'Vilken färg känner du idag?',
  set_color_button: 'Välj din färg',
  sparks: 'Gnistor',
  community: 'Gemenskap',
  purpose: 'Syfte',
  talents: 'Talanger',
  profile_image_changed: 'Bild uppdaterad',
  cover_photo_updated: 'Omslagsbilden har uppdaterats.',
  cover_photo_removed: 'Omslagsbilden har tagits bort.',
  edit_cover_photo: 'Redigera omslagsbild',
  waiting_profile_upload: 'Uppdaterar profilbild… vänligen vänta',
  graves: 'De jag bär med mig',
  'cemeteryLanding.title': 'Hitta en grav på {cemetery}',
  wisdom: 'Visdom',
  sparks_description: 'Dela din Gnista som kan tändas och sprida ljus.',
  text_area_placeholder: 'Hur kan du lysa upp någons väg?',
  crop_image: 'Beskär bild',
  recurring_anniversary: 'Upprepa varje år',
  nick_name: 'Smeknamn',
  birth_name: 'Födelsenamn',
  date_of_birth: 'Födelsedatum',
  date_of_death: 'Dödsdatum',
  time_of_birth: 'Födelseklockslag',
  time_of_death: 'Dödsklockslag',
  place_of_birth: 'Födelseort',
  place_of_death: 'Dödsort',
  cause_of_death: 'Dödsorsak',
  municipality: 'Kommun',
  country: 'Land',
  cemetery: 'Kyrkogård',
  grave_number: 'Gravnummer',
  grave_info_updating: 'Uppdaterar gravinformation… vänligen vänta',
  deceased_name: 'Namn',
  deceased_placeholder: 'Ange den avlidnes namn',
  deceased_gender: 'Kön',
  i_am: 'Jag är',
  buried_is_mine: 'Den avlidne är min',
  select_relationship: 'Välj relation',
  upload_document: 'Ladda upp dokument för graven',
  upload_document_description: 'Välj vilket dokument du vill ladda upp:',
  death_certificate: 'Dödsbevis',
  birth_certificate: 'Födelsebevis',
  invoice: 'Kvitto för gravskötsel eller hyra',
  power_of_attorney: 'Fullmakt',
  driving_license: 'ID-handling för den avlidne',
  proof_of_person: 'Ladda upp dokument om den avlidne',
  proof_of_person_description: 'Dokumentet kan vara PDF, PNG eller JPG och högst 5 MB',
  replace_files: 'Ersätt filer',
  browse_files: 'Hitta din fil',
  drag_image: 'eller dra filen hit',
  dear: 'Kära',
  new_grave_first_description: 'Välkommen att skapa en ny Nätgrav.',
  new_grave_second_description: 'Här kan du skapa en säker och respektfull grav.',
  new_grave_third_description:
    'Genom att skapa en Nätgrav bekräftar du att du har tillstånd för den avlidne.',
  new_grave_fourth_description: "Klicka 'Acceptera' för att fortsätta.",
  new_grave_agree_terms: 'Jag godkänner villkoren ovan',
  enter_name_error: 'Ange personens namn',
  select_gender_error: 'Välj personens kön.',
  select_relation_error: 'Välj din relation till personen.',
  select_date_error: 'Välj ett datum',
  select_reason_error: 'Välj dödsorsak',
  reason_of_death: 'Dödsorsak',
  other_reason: 'Ange annan orsak',
  other_reason_error: 'Ange annan dödsorsak',
  select_country: 'Välj land',
  select_municipality: 'Välj kommun',
  select_cemetery: 'Välj kyrkogård',
  select_country_error: 'Välj ett land',
  select_municipality_error: 'Välj en kommun',
  select_cemetery_error: 'Välj en kyrkogård',
  create_the_grave: 'Skapa graven',
  create_the_message: 'Skapar grav… vänligen vänta',
  death_date_error: 'Välj ett giltigt dödsdatum',
  birth_date_error: 'Välj ett giltigt födelsedatum',
  month_0: 'januari',
  month_1: 'februari',
  month_2: 'mars',
  month_3: 'april',
  month_4: 'maj',
  month_5: 'juni',
  month_6: 'juli',
  month_7: 'augusti',
  month_8: 'september',
  month_9: 'oktober',
  month_10: 'november',
  month_11: 'december',
  unknown_year: 'Okänt år',
  unknown_month: 'Okänd månad',
  'life.unknown_month': 'Okänd månad',
  weekday_0: 'söndag',
  weekday_1: 'måndag',
  weekday_2: 'tisdag',
  weekday_3: 'onsdag',
  weekday_4: 'torsdag',
  weekday_5: 'fredag',
  weekday_6: 'lördag',
  father: 'Far',
  mother: 'Mor',
  son: 'Son',
  husband: 'Make',
  wife: 'Maka',
  brother: 'Bror',
  sister: 'Syster',
  maternal_grandfather: 'Morfar',
  maternal_grandmother: 'Mormor',
  paternal_grandfather: 'Farfar',
  paternal_grandmother: 'Farmor',
  maternal_uncle: 'Morbror',
  maternal_aunt: 'Moster',
  paternal_uncle: 'Farbror',
  paternal_aunt: 'Faster',
  farfar: 'Farfar',
  morfar: 'Morfar',
  farmor: 'Farmor',
  mormor: 'Mormor',
  grandfather: 'Morfar eller farfar',
  grandmother: 'Mormor eller farmor',
  grandchild: 'Barnbarn',
  grandson: 'Barnbarn',
  granddaughter: 'Barnbarn',
  uncle: 'Farbror/Morbror',
  uncle_child: 'Kusiner',
  aunt: 'Faster/Moster',
  aunt_child: 'Kusiner',
  nephew: 'Brorson/Systerson',
  niece: 'Brorsdotter/Systerdotter',
  cousin: 'Kusin',
  aunt_husband: 'Mosters/Fasters man',
  uncle_wife: 'Morbrors/Farbrors fru',
  cousin_wife: 'Kusins fru',
  cousin_husband: 'Kusins man',
  stepbrother: 'Styvbror',
  stepsister: 'Stysyster',
  stepfather: 'Styvpappa',
  stepmother: 'Styvmamma',
  stepson: 'Styveson',
  stepdaughter: 'Styvedotter',
  father_in_law: 'Svärfar',
  mother_in_law: 'Svärmor',
  brother_in_law: 'Svåger',
  sister_in_law: 'Svägerska',
  son_in_law: 'Svärson',
  daughter_in_law: 'Svärdotter',
  self: 'Jag',
  parent: 'Förälder',
  child: 'Barn',
  sibling: 'Syskon',
  spouse: 'Make/maka',
  grandparent: 'Mor-/farförälder',
  great_grandparent: 'Gammelmor-/farförälder',
  great_grandchild: 'Barnbarnsbarn',
  great_great_grandparent: 'Gammelgammelmor-/farförälder',
  great_great_grandchild: 'Barnbarnsbarnsbarn',
  great_great_great_grandparent: 'Gammelgammelgammelmor-/farförälder',
  great_great_great_grandchild: 'Barnbarnsbarnsbarnsbarn',
  aunt_or_uncle: 'Faster/Moster/Farbror/Morbror',
  great_uncle: 'Gammelfarbror/Gammelmorbror',
  great_aunt: 'Gammelfaster/Gammelmoster',
  great_aunt_or_uncle: 'Gammelfaster/Gammelmoster/Gammelfarbror/Gammelmorbror',
  nibling: 'Brors-/systers barn',
  grand_niece: 'Brors-/systers barnbarn',
  grand_nephew: 'Brors-/systers barnbarn',
  grand_nibling: 'Brors-/systers barnbarn',
  great_niece: 'Brors-/systers barnbarnsbarn',
  great_nephew: 'Brors-/systers barnbarnsbarn',
  great_nibling: 'Brors-/systers barnbarnsbarn',
  cousin_in_law: 'Ingift kusin',
  aunt_in_law: 'Ingift faster/moster',
  uncle_in_law: 'Ingift farbror/morbror',
  first_cousin_in_law: 'Ingift kusin',
  uncle_in_law_son: 'Ingift farbrors son',
  first_cousin: 'Kusin',
  first_cousin_once_removed: 'Kusin (en gång borttagen)',
  first_cousin_twice_removed: 'Kusin (två gånger borttagen)',
  second_cousin: 'Syssling',
  second_cousin_once_removed: 'Syssling (en gång borttagen)',
  second_cousin_twice_removed: 'Syssling (två gånger borttagen)',
  third_cousin: 'Brylling',
  third_cousin_once_removed: 'Brylling (en gång borttagen)',
  third_cousin_twice_removed: 'Brylling (två gånger borttagen)',
  aunt_uncle_in_law: 'Ingift faster/moster/farbror/morbror',
  nibling_in_law: 'Ingift brors-/systers barn',
  niece_in_law: 'Ingift brorsdotter/systerdotter',
  nephew_in_law: 'Ingift brorson/systerson',
  parent_in_law: 'Svärförälder',
  child_in_law: 'Svärbarn',
  sibling_in_law: 'Svärsyskon',
  grandparent_in_law: 'Svärmor-/farförälder',
  grandchild_in_law: 'Svärbarnbarn',
  step_parent: 'Styförälder',
  step_mother: 'Styvmamma',
  step_father: 'Styvpappa',
  step_child: 'Styvbarn',
  step_daughter: 'Styvdotter',
  step_son: 'Styvson',
  step_sibling: 'Stysyskon',
  step_sister: 'Stysyster',
  step_brother: 'Styvbror',
  boyfriend: 'Pojkvän',
  girlfriend: 'Flickvän',
  adopt_son: 'Adopterad son',
  adopt_daughter: 'Adopterad dotter',
  adopted_son: 'Adopterad son',
  adopted_daughter: 'Adopterad dotter',
  moons: 'Månar',
  my_moons: 'Mina månar',
  has_you_as_moon: 'Har dig som måne',
  moons_empty_title: 'Inga månar ännu.',
  moons_empty_description: 'En måne är någon som har väglett dig. Någon vars ljus du följer.',
  friends: 'Vänner',
  friends_and_family: 'Familj och vänner',
  colleagues: 'Kollegor',
  friend: 'Vän',
  other: 'Annan',
  daughter: 'Dotter',
  partner: 'Partner',
  relation_category_parent: 'Förälder',
  relation_category_child: 'Barn',
  relation_category_partner: 'Partner',
  relation_category_sibling: 'Syskon',
  relation_category_grandparent: 'Mor-/farförälder',
  relation_category_aunt_uncle: 'Faster/Moster/Farbror/Morbror',
  relation_quick_pick_hint: 'Vi har fyllt i ditt val. Bekräfta eller byt.',
  relation_quick_pick_parent_choose: 'Välj mor eller far.',
  relation_quick_pick_sibling_choose: 'Välj bror eller syster.',
  relation_quick_pick_child_choose: 'Välj son eller dotter.',
  open_details: 'Öppna detalj',
  colleague: 'Kollega',
  great_granddaughter: 'Barnbarnsbarn',
  great_grandson: 'Barnbarnsbarn',
  great_grandmother: 'Gammelmormor/gammelfarmor',
  great_grandfather: 'Gammelmorfar/gammelfarfar',
  great_great_granddaughter: 'Barnbarnsbarnsbarn',
  great_great_grandson: 'Barnbarnsbarnsbarn',
  great_great_grandmother: 'Gammelgammelmormor/gammelgammelfarmor',
  great_great_grandfather: 'Gammelgammelmorfar/gammelgammelfarfar',
  great_great_great_granddaughter: 'Barnbarnsbarnsbarnsbarn',
  great_great_great_grandson: 'Barnbarnsbarnsbarnsbarn',
  great_great_great_grandmother: 'Gammelgammelgammelmormor/gammelgammelgammelfarmor',
  great_great_great_grandfather: 'Gammelgammelgammelmorfar/gammelgammelgammelfarfar',
  cohabitant: 'Sambo',
  contact_person: 'Din kontaktperson',
  monthly: 'Månadsvis',
  semi_annual: 'Halvårsvis',
  annually: 'Årligen',
  biennial: 'Tvåårsvis',
  auth_modal_description:
    'Logga in eller skapa ett gratis konto för att besöka gravar och använda alla funktioner.',
  auth_modal_heading: 'Logga in | Skapa konto',
  active: 'Aktiv',
  requested_to_remove: 'Begäran om borttagning',
  manage_members: 'Hantera medlemmar',
  invited_person_name: 'Inbjuden persons namn',
  remove_members_warring:
    'Ta bort {remainingNumber} fler medlemmar eller avboka deras inbjudningar (eller båda).',
  relation_to_grave: 'Den inbjudnas relation till {graveName}',
  relation_to_person: '{graveName}s relation till den inbjudna',
  administrator_access: 'Administratörsåtkomst',
  select_role: 'Välj roll',
  administrator: 'Administratör',
  normal: 'Normal',
  select_role_error: 'Välj användarroll',
  user_name: 'Användarnamn',
  remove_members_warning: 'Ta bort medlemmar eller minska antalet för att fortsätta.',
  subscription_base_price: 'Baspris',
  membership: 'medlemskap',
  remove_all_grave_user: 'Viktigt: Uppdatering av gravhantering',
  remove_all_grave_user_message:
    'Behåll minst en person eller administratör kopplad. För att ta bort alla, överför ägarskap eller ta bort graven.',
  send_it: 'Skicka',
  public_view: 'Publik vy',
  spark_posting_to_privacy: 'Synlig för {privacy}',
  constellation: 'Stjärnbild',
  moons_only: 'Endast månar',
  form: 'Formulär',
  state_of_mind: 'Tillstånd',
  spark_state_of_mind_info: 'Välj ditt tillstånd. Det formar hur din gnista tas emot.',
  spark_state_of_mind_info_label: 'Info om sinnesstämning',
  spark_form_info_label: 'Info om uttryck',
  spark_remove_link_preview_to_add_media: 'Ta bort länkförhandsvisningen för att lägga till media.',
  taggable_composer_type_to_tag: 'Skriv ett namn för att tagga',
  taggable_composer_no_matches: 'Inga träffar',
  taggable_composer_clear: 'Rensa',
  question: 'fråga',
  insight: 'insikt',
  experience: 'erfarenhet',
  discovery: 'upptäckt',
  feeling: 'känsla',
  value: 'värde',
  energy: 'energi',
  select_category: 'Välj kategori',
  spark_delete: 'Gnista borttagen',
  spark_create: 'Gnista skapad',
  spark_update: 'Gnista uppdaterad',
  ENG: 'Engelska',
  NOR: 'Norska',
  loading: 'Laddar…',
  in_your_mind: 'Dela en tanke, en fråga eller en erfarenhet…',
  spark_reflection_placeholder:
    'Svara med det denna gnista väcker i dig – reflektion, hopp eller gemenskap.',
  create_spark: 'Skapa en Gnista',
  reflect_on_spark: 'Reflect on Spark',
  empty_graves:
    'Använd sökfältet uppe till vänster för att hitta graven du är kopplad till. När relation är satt visas den här.',
  all: 'Alla',
  owner: 'Ägare',
  affiliated: 'Anknuten',
  view_all: 'Visa alla',
  close_relation: 'När du lägger till någon syns de här.',
  no_relation_set: 'Ingen relation satt',
  love_ones: 'De som går med {name}',
  set_relation: 'Välj din relation',
  join_set_relation_free: 'Välj din relation till {firstName}',
  join_sheet_title: 'Välj din relation till {name}',
  join_sheet_intro: 'Ett personligt rum för närhet till {name} – tillgängligt när du vill.',
  join_sheet_auth_title: 'Logga in för att fortsätta',
  join_sheet_auth_intro:
    'Logga in för att reagera, lägga till en reflektion eller skriva en kommentar.',
  join_sheet_intent_react_title: 'Logga in för att reagera på Gnistor',
  join_sheet_intent_react_intro: 'När du är inloggad kan du reagera och delta i samtalet.',
  join_sheet_intent_weekly_question_title: 'Logga in för att svara på veckans fråga',
  join_sheet_intent_weekly_question_intro:
    'När du är inloggad kan du dela ditt eget svar som en Gnista.',
  join_sheet_intent_reflect_title: 'Logga in för att lägga till en reflektion',
  join_sheet_intent_reflect_intro: 'När du är inloggad kan du dela din reflektion.',
  join_sheet_intent_composer_title: 'Logga in för att skriva en kommentar',
  join_sheet_intent_composer_intro: 'När du är inloggad kan du vara med i samtalet.',
  join_sheet_intent_submit_title: 'Logga in för att publicera din kommentar',
  join_sheet_intent_submit_intro: 'När du är inloggad kan din kommentar delas.',
  guest_quota_notice_title: 'Fler sök i dag',
  guest_quota_notice_body: 'För att fortsätta söka i dag kan du logga in eller skapa ett konto.',
  please_sign_in_to_continue: 'Logga in för att fortsätta.',
  join_sheet_subtitle: 'En plats för närhet till {name}.',
  join_sheet_name_fallback: 'dem du bryr dig om',
  relation_request_send: 'Relationsförfrågan skickad',
  relation_updated_success: 'Relationen har uppdaterats.',
  relation_update_failed: 'Det gick inte att uppdatera relationen.',
  relation_removed_success: 'Relationen har tagits bort.',
  relation_remove_failed: 'Det gick inte att ta bort relationen.',
  relation_connection: '{name} är min {reciprocalRelation}, och jag är {name}s {relation}.',
  request_send: 'Förfrågan skickad',
  empty_sparks: 'Inga gnistor, skapa en ny',
  'sparks.empty_stars':
    'Inga gnistor har blivit stjärnor ännu. När en gnista blir en stjärna visas den här.',
  create_post: 'Gravväggen · {graveName}',
  grave_wall_cta_primary: 'Lämna orden',
  grave_wall_cta_secondary: 'Stäng',
  post: 'Publicera',
  update_post: 'Uppdatera inlägg',
  account_heading: 'Ta bort ditt konto',
  delete_account: 'Ta bort konto',
  delete_account_pending: 'Radering pågår',
  deleted_message_pending:
    'Begäran om radering skickad. Konto och data tas bort. Avbryt innan 23:50 idag. Frågor? kontakt@nettgrav.no',
  deleted_message:
    'Om du raderar ditt konto tas all information och data bort permanent. Raderingen är slutgiltig efter 23:50. Kontakta kontakt@nettgrav.no om du har frågor.',
  confirm_delete_account: 'Detta tar bort kontot och allt innehåll.',
  confirm_cancel_account: 'Detta stoppar raderingen och behåller kontot.',
  account_delete_confirm_button: 'Ta bort konto',
  account_delete_cancel_button: 'Behåll konto',
  account_cancel_delete_confirm_button: 'Stoppa radering',
  account_cancel_delete_cancel_button: 'Behåll konto',
  phone_number_error: 'Telefonnummer/lösenord stämmer inte',
  email_error_login: 'E-post och lösenord stämmer inte.',
  set_relation_heading: 'Anslut till graven',
  set_relation_free_description: 'Berätta vem {graveName} är för dig för åtkomst.',
  set_relation_access: 'Som medlem kan du:',
  do_you_know: 'Vem är {graveName} för dig?',
  set_relation_description: 'Skicka förfrågan för att bli medlem som släkting, vän eller välgörare',
  set_relation_info_message:
    'Gratiskonton ombeds betala 2 $/månad när du klickar “Bekräfta och gå med”.',
  click_button_below: 'Välj relation för att fortsätta.',
  feature_title_1: 'Minnealbum',
  feature_description_1: 'Lägg till foton av din älskade och familj.',
  feature_title_2: 'Minnevägg',
  feature_description_2: 'Läs och dela minnen med andra som kände dem.',
  feature_title_3: 'Minnesdagskalender',
  feature_description_3: 'Få påminnelser om viktiga dagar.',
  feature_title_4: 'Värdearkiv',
  feature_description_4: 'Spara viktiga lärdomar från din älskade.',
  feature_title_5: 'Livsarkiv',
  feature_description_5: 'Skriv ned berättelser om deras liv.',
  choose_relation: 'Välj relation',
  relation_label: 'Jag är {grave}s',
  reciprocal_label: '{grave} är min',
  set_relation_note: 'Välj vem den avlidne är för dig och ge graven ett hem.',
  set_relation_other: 'För alla som kände den avlidne – kollega, fan eller annat.',
  set_relation_placeholder: 'Exempel: Jag var vän med {grave} på universitetet i Oslo…',
  confirm_relation_member: 'Bekräfta relation och bli medlem',
  pay_and_reactivate: 'Betala för att återaktivera',
  confirm_membership: 'Bekräfta medlemskap',
  enlightened: 'Upplyst',
  inspired: 'Inspirerad',
  spark_reaction_add_wood: 'Lägg på ved',
  spark_reaction_add_breath: 'Ge gnistan luft',
  spark_reaction_add_light: 'Tänd gnistan med ljus',
  spark_reaction_legacy: 'Tidigare reaktioner',
  spark_stage_spark: 'Gnista',
  spark_stage_campfire: 'Lägereld',
  spark_stage_star: 'Stjärna',
  'spark.openDetail': 'Öppna gnista',
  reflected: 'Reflekterad',
  comments: 'svar',
  comment: 'svar',
  empty_comments: 'Inga svar hittades',
  comment_placeholder: 'Skriv här…',
  reply: 'Svara',
  view_replies: 'Visa alla {total} svar',
  create_grave_body: 'För att skapa en ny Nätgrav behöver du ett Conscious-medlemskap.',
  upgrade_modal_heading: 'Skapa ny grav',
  go_to: 'Gå till',
  our_plans: 'aktivera medlemskap',
  choose_the_subscription: 'för att få tillgång till alla funktioner.',
  link_grave_body:
    'Så bra att du vill koppla samman de begravda. För det behöver du ett Conscious-medlemskap.',
  add_more_images_body:
    'För att lägga till fler bilder i albumet behöver du uppgradera ditt abonnemang.',
  inviting_body: 'Inbjudningar är tillgängliga med Conscious-medlemskap.',
  life_archive_body: 'Livsarkivet är tillgängligt med Conscious-medlemskap.',
  upload_images_body: 'För att lägga till bilder måste du uppgradera ditt nuvarande abonnemang.',
  add_value_body:
    'Så fint att du vill lägga till en egenskap. För det behöver du ett Conscious-medlemskap.',
  search_limit_body:
    'Utforska Nätgrav med vår Conscious-plan. Uppgradera idag för obegränsade sökningar.',
  grave_invitation_first_text: 'Du har blivit inbjuden att bidra till graven',
  of: 'av',
  grave_invitation_second_text: 'Här kan ni samla minnen, bilder och märkesdagar tillsammans.',
  grave_email_info:
    'Den här e-posten är låst för denna inbjudan. Om något är fel, kontakta den som bjöd in dig.',
  subscription_email_info:
    'Den här e-posten är låst för detta abonnemang. Om något är fel, kontakta den som satte upp det.',
  grave_invitation_message:
    '{name} har bjudit in dig att vara med och ta hand om graven för {grave}.',
  accept_or_pay: 'Godkänn och betala',
  paid_grave_user_message:
    'Du har blivit inbjuden av {userName} med ett betalt abonnemang. Godkänn för att gå med, eller avböj om det inte passar just nu.',
  unpaid_grave_user_message:
    'Du är inbjuden av {userName}. För att gå med behöver du uppgradera till betalt abonnemang. Godkänn eller avböj nedan.',
  active_unpaid_grave_user_message:
    'Du har inget aktivt abonnemang. Återaktivera för att fortsätta bidra. Klicka nedan för att förnya!',
  invite: 'Bjud in',
  complete_relation_setup: 'Slutför betalningen för att bekräfta din relation',
  already_set_relation: 'Du har redan satt relationen till {graveName} som {relation}.',
  already_accept_relation: 'Du har redan accepterat relationen till {graveName} som {relation}.',
  finalize_membership:
    'För att slutföra anslutningen och låsa upp alla medlemsförmåner, slutför betalningen. Då kopplas graven till din livssida och du får tillgång till:',
  click_below_to_complete: 'Klicka nedan för att slutföra betalningen och bekräfta relationen.',
  complete_payment: 'Slutför betalning',
  awaiting_owner_approval: 'Väntar på ägarens godkännande',
  awaiting_approval_message:
    'Grävägaren har notifierats om din förfrågan. Vänta på godkännande eller avslag.',
  subscribed_grave_invitation:
    'Du är inbjuden att koppla dig till {graveName} som {relation} av {name}.',
  click_below_to_accept: 'Klicka nedan för att acceptera inbjudan.',
  accept_invitation: 'Acceptera inbjudan',
  accept_invitation_payment: 'Acceptera och betala',
  complete_invitation: 'Slutför inbjudan',
  unsubscribed_grave_invitation:
    'För att acceptera inbjudan, slutför betalningen. Därefter får du tillgång till exklusiva funktioner:',
  you_are_invited: 'Du är inbjuden!',
  reclaim_user_access: 'Återta din åtkomst',
  previous_relation: 'Du var tidigare kopplad till {graveName} som {relation}.',
  downgrade_subscription:
    'Ditt medlemskap har nedgraderats till gratisplanen, tillgången är begränsad men du är fortfarande ett erkänd medlem.',
  regain_access: 'För full åtkomst, uppgradera ditt medlemskap.',
  click_below_to_upgrade: 'Klicka nedan för att uppgradera och återställa åtkomst.',
  upgrade_membership: 'Uppgradera medlemskap',
  set_self_relation: 'Berätta vem {graveName} är för dig för att koppla till graven.',
  set_relation_linked: 'När du gör det kan du:',
  set_self_relation_1: 'Besöka graven när som helst.',
  set_self_relation_2: 'Bevara minnen och familj.',
  set_self_relation_3: 'Låta graven ge mer mening framöver.',
  set_self_relation_message: 'Viktig meddelande:',
  claim_grave_labe: 'Jag vill ansvara för denna grav. Kryssa i rutan.',
  claim_grave_terms_1: 'Välkommen till Nätgrav.',
  claim_grave_terms_2: 'Här kan du göra anspråk på en säker och respektfull grav.',
  claim_grave_terms_3: 'Genom att göra anspråk bekräftar du att du har tillstånd.',
  claim_grave_terms_4:
    "Vanligtvis är det den fysiska gravens ägare. Klicka 'Acceptera' för att fortsätta.",
  i_agreed_claim: 'Jag godkänner villkoren ovan',
  upload_death_document: 'Ladda upp dödsattesten för personen.',
  upload_death_document_limit: 'Filformat: PDF/PNG/JPG, max 5 MB',
  drag_files: 'eller dra filen hit',
  'grave.new.docs.header': 'Jag är gravrättsinnehavare.',
  'grave.new.docs.upload_title': 'Ladda upp dokumentation',
  'grave.new.docs.upload_note': 'Format: PDF, PNG eller JPG (max 5 MB).',
  'grave.new.docs.button': 'Ladda upp dokumentation',
  'grave.new.docs.drop_hint': 'Klicka eller dra filen hit',
  'grave.new.info.title': 'Ansvar för graven.',
  'grave.new.info.line1':
    'När du går vidare bekräftar du att du har rätt att ta hand om denna grav.',
  'grave.new.info.line2':
    'Detta gäller vanligtvis den som har ansvar för den fysiska graven, eller någon med fullmakt.',
  'grave.new.info.line3': 'Dokumentationen används endast för detta ändamål.',
  'grave.new.accept_label': 'Jag bekräftar att jag har ansvar för denna grav',
  'grave.new.create_cta': 'Skapa grav',
  claim_grave_message: 'Har du ansvar för att ta hand om denna grav?',
  claim_grave_document_helper: 'Detta används bara för att bekräfta ansvar för graven.',
  claim_guardian_info_title: 'Vad innebär omsorgsansvar?',
  claim_guardian_info_lead:
    'Att vara förmyndare innebär att ta hand om graven och gemenskapen runt den.',
  claim_guardian_info_bullet_relations: 'Godkänna eller avvisa relationer',
  claim_guardian_info_bullet_content: 'Administrera innehåll på graven',
  claim_guardian_info_bullet_admins: 'Lägga till eller ta bort administratörer',
  claim_guardian_info_note: 'Omsorgsansvar bekräftas med dokumentation.',
  take_ownership: 'Bli {firstName}s förmyndare',
  manage_grave: 'Förvalta graven',
  claim_request_queue: 'Din begäran om att äga {graveName} har skickats. Väntar på godkännande.',
  register_ownership: 'Registrera ägarskap',
  public: 'Offentlig',
  moon: 'Måne',
  moon_set: 'Välj som min måne',
  moon_remove: 'Ta bort månrelation',
  moon_remove_as_moon: 'Ta bort som måne',
  moon_remove_confirm_moon:
    'Detta tar bort {username} som din måne. Du kan lägga till {username} igen senare.',
  moon_remove_confirm_as_moon:
    'Detta tar bort dig som måne för {username}. Du kan välja igen senare.',
  moon_cancel_request: 'Avbryt förfrågan',
  moon_ping_cta: 'Ge ett tecken',
  moon_request_sent: 'Måneförfrågan skickad.',
  moon_request_accepted: 'Måneinbjudan accepterad.',
  moon_request_declined: 'Måneinbjudan avböjd.',
  moon_request_page_title: 'Inbjudan till månrelation',
  moon_request_page_subtitle: '{name} vill att du ska vara deras måne.',
  moon_request_sign_in: 'Logga in för att svara',
  moon_request_accept: 'Acceptera',
  moon_request_decline: 'Avböj',
  moon_request_already_handled: 'Den här inbjudan är redan hanterad.',
  moon_removed: 'Månrelation borttagen.',
  moon_ping_sent: 'Signal skickad.',
  moon_ping_cta_sent: 'Tecken skickat',
  moon_ping_sent_hint: 'De får veta att du är här för dem.',
  moon_ping_cooldown: 'Du har redan gett ett tecken i dag. Du kan skicka ett nytt om några timmar.',
  moon_helper_text_line_1: 'En måne är någon som har väglett dig.',
  moon_helper_text_line_2: 'Någon vars ljus du följer.',
  moon_helper_text: 'En måne är någon som har väglett dig. Någon vars ljus du följer.',
  own_words_tab: 'Mina egna ord',
  own_words_public_tab: 'Egna ord',
  own_words_title: 'Mina egna ord',
  own_words_subtitle:
    'En plats för det du vill att andra ska förstå om dig medan ni kan prata tillsammans.',
  own_words_prompts_title: 'Börja med en fråga',
  own_words_prompt_1: 'Vad hoppas jag att du förstår om mig?',
  own_words_prompt_2: 'Vad ger mitt liv riktning?',
  own_words_prompt_3: 'Vad är svårt att säga högt?',
  own_words_prompt_4: 'Vad behöver jag sätta ord på just nu?',
  own_words_placeholder: 'Skriv med dina egna ord...',
  own_words_visibility_title: 'Vem kan läsa detta?',
  own_words_visibility_everyone: 'Alla på Nettgrav',
  own_words_self_only: 'Bara du kan läsa detta tills du väljer en annan synlighet.',
  own_words_reader_invitation_title: 'Hur kan läsaren möta dina ord?',
  own_words_reader_invitation_help:
    'Val med privat chatt visar en meddelandeknapp tillsammans med dina ord.',
  own_words_reader_invitation_listen: 'Bara läs',
  own_words_reader_invitation_ask: 'Fråga mig i privat chatt',
  own_words_reader_invitation_understand_together: 'Förstå tillsammans i privat chatt',
  own_words_reader_invitation_keep: 'Ta vara på detta',
  own_words_publish: 'Dela orden',
  own_words_update: 'Uppdatera',
  own_words_publish_success: 'Dina ord har delats.',
  own_words_publish_needs_words: 'Skriv några ord innan du delar.',
  own_words_save_error: 'Kunde inte spara just nu.',
  own_words_public_title: 'Med egna ord',
  own_words_public_subtitle: 'Ord som {name} har skrivit och valt att dela.',
  own_words_updated: 'Uppdaterad {date}',
  own_words_chat_cta: 'Fråga för att förstå',
  own_words_chat_ask_cta: 'Skicka privat meddelande',
  own_words_chat_understand_cta: 'Förstå tillsammans',
  own_words_chat_error: 'Samtalet kunde inte öppnas just nu.',
  after_me_tab: 'Efter mig',
  after_me_title: 'Efter mig',
  after_me_subtitle: 'En plats för att göra val och önskemål tydligare.',
  after_me_intro_title: 'Om jag en dag inte själv kan säga detta',
  after_me_intro_text: 'Du kan skriva lite eller mycket. Du kan ändra allt senare.',
  after_me_step_counter: 'Steg {current} av {total}',
  after_me_step_intentions_title: 'Vad vill du att detta ska ge?',
  after_me_step_words_title: 'Något jag vill att andra ska veta',
  after_me_step_legacy_title: 'Det som lever vidare',
  after_me_words_help: 'Det behöver inte vara perfekt. Skriv det med dina egna ord.',
  after_me_writing_prompts_title: 'Börja med en fråga',
  after_me_writing_prompt_1: 'Vad hoppas jag att ni förstår om mig?',
  after_me_writing_prompt_2: 'Vad har gett mitt liv riktning?',
  after_me_writing_prompt_3: 'Vad hoppas jag kunna föra vidare?',
  after_me_writing_prompt_4: 'Vad bör de som står mig närmast veta?',
  after_me_public_tab: 'Egna ord',
  after_me_public_title: 'Det jag vill att ni ska veta om mig',
  after_me_public_subtitle: 'Ord skrivna av {name} och delade på egna villkor.',
  after_me_public_intentions_title: 'Det jag hoppas att detta ska ge',
  after_me_public_legacy_title: 'Det jag hoppas föra vidare',
  after_me_public_choices_title: 'Mina val',
  after_me_public_updated: 'Uppdaterad {date}',
  after_me_public_chat_cta: 'Fråga för att förstå',
  after_me_public_chat_error: 'Samtalet kunde inte öppnas just nu.',
  after_me_emotional_context_title: 'Varifrån kommer orden?',
  after_me_emotional_context_help: 'Välj bara om det gör orden lättare att förstå.',
  after_me_emotional_context_vulnerable: 'Sårbarhet',
  after_me_emotional_context_grateful: 'Tacksamhet',
  after_me_emotional_context_hopeful: 'Hopp',
  after_me_emotional_context_uncertain: 'Osäkerhet',
  after_me_emotional_context_peaceful: 'Lugn',
  after_me_reader_invitation_title: 'Hur vill du bli bemött?',
  after_me_reader_invitation_help: 'Gör det tydligt hur du vill bli bemött.',
  after_me_reader_invitation_listen: 'Bara lyssna',
  after_me_reader_invitation_ask: 'Fråga mig',
  after_me_reader_invitation_understand_together: 'Förstå tillsammans',
  after_me_reader_invitation_keep: 'Ta vara på detta',
  after_me_public_emotional_context_label: 'Orden kommer från',
  after_me_public_reader_invitation_label: 'Jag vill bli bemött med',
  after_me_legacy_help: 'Detta är valfritt. Det kan ge riktning för dem som står dig nära.',
  after_me_step_boundaries_title: 'Vad vill du inte?',
  after_me_step_sharing_title: 'Vem ska veta?',
  after_me_label_visibility: 'Vem kan se detta?',
  after_me_label_activation_mode: 'När ska detta vara synligt?',
  after_me_label_intentions: 'Vad vill du att detta ska ge?',
  after_me_label_message_text: 'Något jag vill att andra ska veta',
  after_me_label_grave_choice: 'Gravform',
  after_me_label_ceremony_choice: 'Ceremoniform',
  after_me_label_place_choice: 'Föredragen plats',
  after_me_label_religious_preference: 'Önskar du en religiös ram?',
  after_me_label_body_title: 'Kroppen',
  after_me_label_body_choice: 'Har du en preferens för kremering eller kistgrav?',
  after_me_label_legacy_focus: 'Riktning',
  after_me_label_legacy_reason: 'Om du vill, skriv en mening om varför.',
  after_me_label_boundaries: 'Vad vill du inte?',
  after_me_visibility_moons: 'Månar',
  after_me_visibility_family_friends: 'Familj och vänner',
  after_me_visibility_self_only: 'Bara jag',
  after_me_activation_show_when_deceased: 'Visa om andra behöver fatta beslut för min räkning',
  after_me_activation_visible_now: 'Synlig nu',
  after_me_intention_calm: 'Lugn',
  after_me_intention_clarity: 'Tydlighet',
  after_me_intention_closeness: 'Närhet',
  after_me_intention_calm_help: 'Så att de närmaste slipper gissa.',
  after_me_intention_clarity_help: 'Så att dina val blir lätta att förstå.',
  after_me_intention_closeness_help: 'Så att det som händer kan kännas äkta.',
  after_me_choice_unsure: 'Osäker',
  after_me_choice_both: 'Båda',
  after_me_grave_choice_physical: 'Fysisk grav',
  after_me_grave_choice_nettgrav: 'Nätgrav',
  after_me_ceremony_choice_small: 'Liten',
  after_me_ceremony_choice_open: 'Öppen',
  after_me_ceremony_choice_none: 'Ingen',
  after_me_body_choice_cremation: 'Kremering',
  after_me_body_choice_coffin_burial: 'Kistgrav',
  after_me_place_choice_church: 'Kyrka',
  after_me_place_choice_nature: 'Natur',
  after_me_place_choice_home: 'Hemma',
  after_me_religious_preference_religious: 'Ja',
  after_me_religious_preference_non_religious: 'Nej',
  after_me_legacy_focus_knowledge: 'Kunskap',
  after_me_legacy_focus_knowledge_help: 'Förståelse som kan göra livet klarare och längre.',
  after_me_legacy_focus_health: 'Hälsa',
  after_me_legacy_focus_health_help: 'Arbete som kan bidra till att färre liv slutar för tidigt.',
  after_me_legacy_focus_care: 'Omsorg',
  after_me_legacy_focus_care_help: 'Värdighet och närhet där människor är som mest sårbara.',
  after_me_legacy_focus_nature: 'Natur',
  after_me_legacy_focus_nature_help: 'Livets sammanhang och det som bär oss vidare.',
  after_me_legacy_focus_creation: 'Skapande',
  after_me_legacy_focus_creation_help: 'Det människan bygger, uttrycker och för vidare.',
  after_me_legacy_focus_freedom: 'Frihet',
  after_me_placeholder_message_text: 'Är det något du vill göra tydligt för dem som står dig nära?',
  after_me_placeholder_legacy_reason: 'Skriv en kort mening…',
  after_me_placeholder_boundaries: 'Ibland är det viktigaste att sätta en gräns.',
  after_me_status_ready: 'Tydlig',
  after_me_status_draft: 'Utkast',
  after_me_status_ready_hint: 'Du kan när som helst göra ändringar.',
  after_me_save_state_idle: 'Utkast',
  after_me_save_state_saving: 'Sparar…',
  after_me_save_state_saved: 'Sparat',
  after_me_save_state_error: 'Kunde inte spara',
  after_me_back: 'Tillbaka',
  after_me_next: 'Vidare',
  after_me_mark_ready: 'Gör tydligt',
  after_me_update: 'Uppdatera',
  after_me_mark_ready_success: 'Sparat som tydligt.',
  after_me_mark_ready_needs_more: 'För att göra detta tydligt behöver vi lite mer.',
  after_me_saved_inline: 'Tydlig version sparad',
  after_me_warning_self_only: 'Bara du kan se detta. Andra kan inte hjälpa om något händer.',
  after_me_last_updated: 'Uppdaterad {date}',
  after_me_save_error: 'Kunde inte spara just nu. Försök igen.',
  after_me_error_visibility_missing: 'Välj vem som kan se detta.',
  after_me_error_activation_mode_missing: 'Välj när detta ska vara synligt.',
  after_me_error_intentions_missing: 'Välj minst en intention.',
  after_me_error_content_missing: 'Lägg till några ord innan du gör detta tydligt.',
  after_me_error_message_text_too_long: 'Texten är för lång. Korta ner den lite.',
  after_me_error_boundaries_text_too_long: 'Texten om gränser är för lång. Korta ner den lite.',
  after_me_error_legacy_reason_too_long: 'Motiveringen är för lång. Korta ner den lite.',
  after_me_practical_title: 'Enkla val',
  after_me_practical_intro: 'Det handlar inte om detaljer. Bara det viktigaste.',
  after_me_boundaries_help: 'Ibland är det viktigaste att sätta en gräns.',
  private: 'Privat',
  relatives: 'Släktingar',
  need_subscription: 'Du behöver ett abonnemang för att lägga till minnen.',
  upgrade_subscription: 'Uppgradera abonnemang',
  no_memories_added: 'En plats för det som blir kvar.',
  no_memories_added_with_relation: 'En plats för det som blir kvar.',
  no_memories_added_ceremony: 'En plats för orden också nu.',
  no_memories_added_with_relation_ceremony: 'En plats för orden också nu.',
  no_memories_added_no_relation_hint:
    'För dem som hörde till. Välj din relation för att se gravväggen och det som lever vidare.',
  grave_wall_pending_review_hint:
    'Din relation är registrerad. Gravväggen öppnas när Nätgrav har godkänt graven.',
  input_memory_placeholder: 'Lämna några ord här.',
  input_memory_placeholder_ceremony: 'Skriv när du behöver det.',
  memory_discard_message: 'Är du säker på att du vill avbryta ändringarna?',
  discard_changes: 'Avbryt ändringar?',
  discard: 'Avbryt',
  discard_cancel: 'Fortsätt redigera',
  post_update_success: 'Inlägget uppdaterades!',
  post_share_success: 'Inlägget delades!',
  post_share_failed: 'Kunde inte dela inlägget. Försök igen.',
  post_failed: 'Det gick inte att posta. Försök igen.',
  company_request_approved: 'Företagsförfrågan godkänd',
  company_request_declined: 'Företagsförfrågan avvisad',
  ad_request_approved: 'Annonsförfrågan godkänd',
  ad_request_declined: 'Annonsförfrågan avvisad',
  spark_comment_create_failed: 'Kunde inte skapa kommentar',
  spark_comment_update_failed: 'Kunde inte uppdatera kommentar',
  settings_notification_preferences_saved: 'Notisinställningar sparade',
  file_upload_failed: 'Kunde inte ladda upp filen',
  posting: 'Postar…',
  updating: 'Uppdaterar…',
  edit_post: 'Redigera inlägg',
  update_memory: 'Uppdatera',
  create_memory_post: 'Publicera till grav',
  memory_description_placeholder: 'Lämna några ord här.',
  add_photos_videos: 'Lägg till bilder/video',
  click_or_drag_media: 'Klicka eller dra media hit',
  edit_image: 'Redigera bild',
  edit_video: 'Redigera video',
  add_caption: 'Lägg till bildtext…',
  memory_deleted_success: 'Minnet raderat!',
  memory_delete_failed: 'Misslyckades radera minne.',
  memory_load_failed: 'Inlägget kunde inte hämtas. Försök igen.',
  comments_load_failed: 'Kommentarerna kunde inte hämtas. Försök igen.',
  comment_delete_failed: 'Kommentaren kunde inte raderas. Försök igen.',
  grave_wall_load_failed: 'Gravväggen kunde inte hämtas',
  grave_wall_load_failed_description: 'Försök igen. Ditt innehåll har inte ändrats.',
  delete_memory_title: 'Ta bort från den här platsen?',
  delete_media_confirmation:
    'Detta tar bort mediet från den här platsen. Du kan lägga till det igen senare.',
  delete_img_title: 'Ta bort från den här platsen?',
  delete_memory_content:
    'Detta tar bort innehållet från den här platsen. Du kan lägga till det igen senare.',
  delete_memory_confirm: 'Ta bort',
  write_something_or_add_media:
    'En Gnista behöver något att brinna. Dela ett foto, ett minne eller några ord – och låt det lysa.',
  empty_grave_post_warning:
    'Ett gravinlägg behöver något att dela. Lägg till ett foto, ett minne eller några ord – och låt det leva vidare.',
  empty_memory_post_warning:
    'Du har inte skrivit något än. Dela några ord, tankar eller minnen innan du publicerar.',
  add_to_your_post: 'Lägg till bild eller video',
  memory_review: 'Förhandsgranska minne',
  grave_wall: 'Gravväggen',
  grave_ceremony_title: 'Dödsannons och ceremoni',
  grave_ceremony_death_notice_section: 'Dödsannons',
  grave_ceremony_ceremony_section: 'Ceremoni',
  grave_ceremony_edit: 'Redigera',
  grave_ceremony_subtitle_ready: 'Tid och plats, när det är klart.',
  grave_ceremony_subtitle_empty: 'Lägg till tid och plats när det är klart.',
  grave_ceremony_published_by: 'Informationen delades av {name}',
  grave_ceremony_published_by_relation: '{relation} till {graveName}',
  grave_ceremony_updated_at: 'Uppdaterad {dateTime}',
  grave_ceremony_when: 'Tidpunkt',
  grave_ceremony_where: 'Plats',
  grave_ceremony_place_of_death: 'Dödsplats',
  grave_ceremony_message: 'Meddelande',
  grave_ceremony_save: 'Spara',
  grave_ceremony_not_set: 'Inte angivet',
  grave_ceremony_saved: 'Ceremoniinformation sparad.',
  grave_ceremony_save_failed: 'Kunde inte spara just nu.',
  grave_ceremony_attendance_coming: 'Kommer',
  grave_ceremony_attendance_unsure: 'Osäker',
  grave_ceremony_attendance_not_coming: 'Kan inte komma',
  grave_ceremony_attendance_summary: 'Svar',
  grave_ceremony_attendance_prompt: 'Kan du delta i ceremonin?',
  grave_ceremony_response_saved: 'Ditt svar har sparats.',
  grave_ceremony_response_failed: 'Kunde inte spara ditt svar just nu.',
  grave_ceremony_copy_link_failed: 'Kunde inte kopiera länken just nu.',
  grave_ceremony_redirecting: 'Öppnar dödsannonsen på gravsidan…',
  grave_ceremony_timing_pending: 'Tid och plats är inte satta än',
  grave_ceremony_responses_title: 'Vem kommer',
  grave_ceremony_share_link: 'Dela dödsannonsen',
  grave_ceremony_link_copied: 'Länk till dödsannonsen kopierad',
  grave_ceremony_responses_empty: 'Inga svar ännu.',
  grave_ceremony_responses_load_failed: 'Kunde inte hämta svarslistan just nu.',
  grave_ceremony_move_to_anniversaries: 'Flytta till minnesdagar nu',
  grave_ceremony_move_to_anniversaries_saved: 'Flyttad till minnesdagar.',
  grave_ceremony_move_to_anniversaries_failed: 'Kunde inte flytta just nu.',
  create_grave_ceremony_visibility_notice:
    'Dödsannonsen publiceras på gravväggen och kan delas med andra. Du kan redigera uppgifterna senare.',
  life_archive_menu: 'Livsarkiv',
  media: 'Media',
  connect_grave: 'Anslut grav',
  upgrade_plan_modal: 'Uppgradera plan',
  more: 'Mer',
  about_name: 'Namn',
  about_gender: 'Kön',
  relations: 'Relationer',
  about_birthplace: 'Födelseort',
  about_nickname: 'Smeknamn',
  about_birth_name: 'Födelsenamn',
  about_death_location: 'Dödsplats',
  about_cemetery: 'Kyrkogård',
  about_birthday: 'Födelsedag',
  about_death_date: 'Dödsdag',
  about_relations: 'Relationer',
  about_cause_of_death: 'Dödsorsak',
  about_country: 'Land',
  about_title: 'Om',
  about_privacy: 'Synlighet',
  buried: 'Begravd',
  edit_grave_details: 'Redigera gravdetaljer',
  relationships: 'Relationer',
  grave_people_tab_label: 'De som hör till',
  grave_people_title: 'De som hör till',
  grave_people_title_with_name: 'De som stod {name} nära',
  grave_people_subtitle_with_name: 'Det här är människorna som var en del av livet för {name}.',
  work: 'Arbete',
  announcements: 'Dödsannonser',
  grave_link: 'Tillsammans med',
  grave_link_header: '{graveName}, din {relation}, är ansluten med',
  Søndag: 'Söndag',
  Mandag: 'Måndag',
  Tirsdag: 'Tisdag',
  Onsdag: 'Onsdag',
  Torsdag: 'Torsdag',
  Fredag: 'Fredag',
  Lørdag: 'Lördag',
  placeholder_name: 'Ange namn',
  placeholder_nickname: 'Ange smeknamn',
  placeholder_birth_name: 'Ange födelsenamn',
  placeholder_birthplace: 'Ange födelseort',
  placeholder_death_location: 'Ange dödsplats',
  placeholder_gender: 'Välj kön',
  placeholder_country: 'Välj land',
  placeholder_municipality: 'Välj kommun',
  placeholder_cemetery: 'Välj kyrkogård',
  placeholder_cause_of_death: 'Välj dödsorsak',
  placeholder_privacy: 'Välj synlighet',
  placeholder_date_of_birth: 'Välj födelsedatum',
  placeholder_time_of_birth: 'Välj födelsetid',
  placeholder_date_of_death: 'Välj dödsdatum',
  placeholder_time_of_death: 'Välj dödstid',
  grave_owner: 'grävägare',
  admin: 'admin',
  edit_relation: 'Redigera relation',
  remove_member: 'Ta bort medlem',
  confirm_delete_user_title: 'Är du säker?',
  confirm_button: 'Ta bort',
  cancel_button: 'Behåll',
  confirm_delete_message:
    'Detta tar bort {username} som familjemedlem. Du kan lägga till {username} igen senare.',
  confirm_remove_member_self_title: 'Vill du lämna den här graven?',
  confirm_remove_member_self_message: 'Du förlorar åtkomst nu, men kan ansluta igen senare.',
  confirm_remove_member_other_title: 'Ta bort {username} från den här graven?',
  confirm_remove_member_other_message:
    '{username} förlorar åtkomst nu, men kan bjudas in igen senare.',
  relation_to_buried: 'Relation till dig',
  relation_to_user: 'Din relation till den begravde',
  role_required: 'Välj en roll',
  relation_required: 'Välj en relation',
  direction_required: 'Välj relationens riktning.',
  relation_you_are_prefix: 'Du är',
  relation_you_are_suffix: 'till {name}',
  relation_they_are_prefix: '{name} är din',
  invitation_relation_you_are_prefix: 'Den inbjudna är',
  invitation_relation_you_are_suffix: 'till {name}',
  invitation_relation_they_are_prefix: '{name} är den inbjudnes',
  invite_family_member: 'Bjud in någon',
  grave_people_invite_button: 'Ge familjen tillgång',
  invite_coming_soon: 'Inbjudningar kommer snart',
  email_required: 'Ange e-post',
  email_required_validation: 'Ange en giltig e-postadress',
  name_required: 'Ange namn',
  pending_invitations: 'Väntande inbjudningar',
  find_grave_member: 'Sök i relationer',
  grave_people_pending_invitations: 'Väntande inbjudningar',
  grave_people_search_placeholder: 'Hitta en person',
  grave_people_search_failed: 'Det gick inte att söka efter personer. Försök igen.',
  grave_people_search_empty_title: 'Inga träffar',
  grave_people_search_empty_message: 'Prova ett annat namn.',
  grave_invitations_load_failed: 'Inbjudningarna kunde inte hämtas.',
  relation_requests_load_failed: 'Relationsförfrågningarna kunde inte hämtas.',
  relation_request_update_failed: 'Relationsförfrågan kunde inte uppdateras.',
  grave_invitation_sent: 'Inbjudan har skickats.',
  grave_invitation_updated: 'Inbjudan har uppdaterats.',
  find_invited_user: 'Hitta någon du bjudit in',
  find_workplace: 'Hitta arbetsplats',
  add_workplace: 'Lägg till arbetsplats',
  company_name_label: 'Företagsnamn',
  company_name_placeholder: 'Ange företagsnamn',
  company_name_required: 'Lägg till företagsnamn.',
  city_label: 'Stad',
  city_placeholder: 'Ange stad',
  city_required: 'Lägg till stad.',
  position_label: 'Position',
  position_placeholder: 'Ange position',
  position_required: 'Lägg till position.',
  start_year_label: 'Startår',
  start_year_placeholder: 'Välj startår',
  start_year_required: 'Välj startår.',
  end_year_label: 'Slutår',
  end_year_placeholder: 'Välj slutår',
  end_year_required: 'Välj slutår.',
  description_label: 'Beskrivning',
  description_placeholder: 'Ange jobbbeskrivning',
  publicPrivacy_label: 'Sekretess',
  publicPrivacy_placeholder: 'Välj sekretessinställning',
  publicPrivacy_required: 'Välj sekretessval.',
  invalid_end_date: 'Ogiltigt slutdatum',
  invalid_end_date_message: 'Slutdatum kommer efter startdatum.',
  no_workplaces_added: 'Platser som hörde till livet.',
  add_workplaces_message: 'Välj din relation för att lägga till arbetsplatser som betydde något.',
  add_workplaces_message_member: 'Här kan du lägga till var personen arbetat under sitt liv.',
  no_invitations_sent: 'Dela graven med de närmaste',
  no_invitations_message: 'Bjud in familj och vänner att vara närvarande – när det passar dem.',
  grave_people_empty_title: 'Inga väntande inbjudningar',
  grave_people_empty_message: 'Inbjudningar du skickar visas här tills de besvaras.',
  grave_relation_responsible: 'Har ansvar',
  grave_people_owner_tag: 'Den som håller graven',
  photos: 'Album',
  find_interests: 'Hitta intressen',
  add_interest: 'Lägg till intresse',
  interest_name: 'Intressertitel',
  interest_name_placeholder: 'Ange intresenamn',
  interest_name_required: 'Lägg till intresenamn.',
  interest_category: 'Kategori',
  interest_category_placeholder: 'Välj kategori',
  interest_category_required: 'Välj kategori.',
  interest_description: 'Beskrivning',
  interest_description_placeholder: 'Ange beskrivning',
  interest_description_required: 'Lägg till beskrivning.',
  confirm_delete_workplace_message:
    'Detta tar bort arbetsplatsen. Du kan lägga till arbetsplatsen igen senare.',
  confirm_delete_interests_message:
    'Detta tar bort intresset. Du kan lägga till intresset igen senare.',
  confirm_delete_payment_method_message:
    'Detta tar bort betalningsmetoden. Du kan lägga till en ny senare.',
  no_interests_added: 'Det som gav glädje, ro eller nyfikenhet.',
  add_interests_message: 'Välj din relation för att dela intressen som hörde till livet.',
  add_interests_message_member:
    'Här kan du dela vad som väckte deras nyfikenhet, inspirerade dem eller fick dem att le.',
  add_passion: 'Lägg till passion',
  confirm_delete_passion_message:
    'Detta tar bort passionen från den här platsen. Du kan lägga till passionen igen senare.',
  confirm_delete_gift_message:
    'Detta tar bort gåvan från den här platsen. Du kan lägga till gåvan igen senare.',
  passion_description: 'Passionsbeskrivning',
  passion_description_placeholder: 'Ange passionsbeskrivning',
  passion_description_required: 'Lägg till passionsbeskrivning.',
  no_passion_added: 'Det som gav energi och mening.',
  add_passion_message: 'Välj din relation för att lägga till passioner som betydde mycket.',
  add_passion_message_member:
    'Lägg till det de verkligen brydde sig om – det som gav dem energi, mening eller glädje.',
  no_grave_linked: 'Förbindelser ger sammanhang.',
  add_grave_linked_message:
    'Visa hur {firstName} hänger ihop med sin familj. Knyt {firstName} till dem som betyder något – oavsett var gravarna finns.',
  grave_link: 'Tillsammans med',
  grave_link_empty_primary: 'Vissa gravar hörde samman i livet.',
  grave_link_empty_secondary: 'Här kan de stå tillsammans – oavsett var de är gravsatta.',
  grave_link_empty_tertiary: 'Välj din relation för att knyta ihop dem på Nätgrav.',
  grave_link_empty_image_alt: 'Två gravplatser som är sammanknutna',
  grave_link_open_grave: 'Öppna graven för {name}',
  grave_link_more_actions: 'Fler åtgärder för gravkopplingen',
  grave_link_removed: 'Gravkopplingen har tagits bort.',
  grave_link_remove_failed: 'Vi kunde inte ta bort kopplingen. Försök igen om en stund.',
  grave_link_updated: 'Gravkopplingen har uppdaterats.',
  photo_albums_manage: 'Redigera samling',
  upload_photo: 'Ladda upp foto',
  photo_uploading_title: 'Laddar upp bilder',
  photo_album_system_name: 'Samlade bilder',
  photo_album_images_count: '{count, plural, one {# bild} other {# bilder}}',
  photo_album_empty_count: 'Inga bilder här än',
  photo_tagging_label: 'Visa också på andra gravar',
  photo_tagging_placeholder: 'Välj gravar',
  photo_tagged_section_title: 'Bilder som delas med andra gravar',
  photo_tagged_source: 'Också på graven till {graveName}',
  photo_tagged_open_original: 'Se original',
  photo_upload_progress: 'Laddar upp {completed} av {total}',
  photo_upload_partial_failure:
    '{successCount} bilder uppladdade, {failedCount} misslyckades. Du kan försöka igen.',
  photo_album_delete_confirm_title: 'Radera album?',
  photo_album_delete_confirm_body: 'Bilderna raderas inte. De flyttas till Samlade bilder.',
  photo_album_delete_confirm_body_with_images: 'Bilderna finns fortfarande kvar i Samlade bilder.',
  photo_album_delete_confirm_body_empty: 'Detta album är tomt och kommer att raderas.',
  photo_album_delete_confirm_action: 'Radera album',
  photo_delete_image_title: 'Ta bort bilden?',
  photo_delete_image_content:
    'Bilden tas bort från den här graven. Du kan lägga till den igen senare.',
  photo_delete_failed: 'Bilden kunde inte tas bort. Försök igen.',
  grave_photos_loading: 'Hämtar bilder',
  grave_photos_load_failed: 'Bilderna kunde inte hämtas',
  grave_photos_load_failed_description: 'Försök igen. Ditt innehåll har inte ändrats.',
  grave_photos_retry: 'Försök igen',
  grave_photos_load_more: 'Visa fler bilder',
  grave_photos_load_more_failed: 'Fler bilder kunde inte hämtas.',
  photo_albums_load_failed: 'Albumsamlingarna kunde inte hämtas.',
  grave_photo_alt: 'Bild på gravplatsen för {name}',
  photo_comment_action_failed: 'Kommentaren kunde inte sparas. Försök igen.',
  photo_comment_delete_title: 'Radera kommentaren?',
  photo_comment_delete_content: 'Kommentaren tas bort permanent.',
  photo_move_to_album: 'Flytta till album',
  photo_move_to_album_title: 'Flytta bild till album',
  photo_move_to_album_placeholder: 'Välj album',
  no_photos_added: 'Här kan bilder samlas över tid.',
  add_photos_message: 'När ett foto läggs till blir det en del av berättelsen.',
  album_empty_primary: 'Bilder som samlas över tid.',
  album_empty_album_title: 'Inga bilder här än',
  album_empty_album_message: 'När ett foto läggs till blir det en del av berättelsen.',
  album_empty_secondary: 'Välj din relation för att lägga till bilder och se mer av berättelsen.',
  album_empty_cta: 'Knyt dig till {firstName}',
  select_cover_photo: 'Välj omslagsbild',
  add_photos: 'Lägg till bilder',
  choose_cover_photo: 'Välj omslagsbild',
  adjust_cover_position: 'Justera position',
  upload_image: 'Lägg till bild',
  remove_image: 'Ta bort från omslaget',
  remove_grave_avatar: 'Ta bort profilbild',
  grave_avatar_removed: 'Profilbilden är borttagen.',
  grave_avatar_remove_failed: 'Kunde inte ta bort profilbilden.',
  edit_profile_photo: 'Redigera profilbild',
  edit_cover_image: 'Redigera omslagsbild',
  add_cover_photo: 'Lägg till omslagsbild',
  edit: 'Redigera',
  upload_photos: 'Ladda upp bilder',
  label_description: 'Beskrivning',
  placeholder_description: 'Ange beskrivning',
  label_address: 'Adress',
  placeholder_address: 'Ange adress',
  date_time: 'Datum och tid',
  create_anniversary: 'Skapa minnesdag',
  edit_anniversary: 'Redigera minnesdag',
  add_life_event: 'Lägg till berättelse',
  no_events_added: '{firstName}s bok rymmer berättelserna som hör till {firstName}s liv.',
  life_events_empty_primary: 'Här kan livets berättelser få plats.',
  life_events_empty_secondary: 'Knyt dig till graven om du vill bidra med minnen och berättelser.',
  life_events_empty_cta: 'Knyt dig till {firstName}',
  add_events_message: 'Här kan du dela minnen, ögonblick och ord som visar vem {firstName} var.',
  life_events_load_failed: 'Livsberättelsen kunde inte hämtas.',
  life_events_load_failed_description: 'Försök igen. Ditt innehåll har inte ändrats.',
  try_again: 'Försök igen',
  life_event_media_update_failed: 'Bilden kunde inte uppdateras. Försök igen.',
  life_event_media_delete_failed: 'Mediet kunde inte tas bort. Försök igen.',
  event_label_name: 'Berättelsens titel',
  event_placeholder_name: 'Ange titel',
  event_required_name: 'Lägg till titel.',
  event_label_date: 'Datum för berättelsen',
  event_placeholder_date: 'Välj datum',
  event_required_date: 'Välj datum.',
  event_label_theme: 'Välj tema',
  event_placeholder_theme: 'Välj tema',
  event_required_theme: 'Välj tema.',
  event_label_country: 'Land',
  event_placeholder_country: 'Välj land',
  event_required_country: 'Välj land.',
  event_theme_selected: 'Vald färg:',
  event_label_description: 'Berättelsetext',
  event_placeholder_description: 'Skriv berättelsen här',
  event_required_description: 'Välj berättelsetext.',
  event_theme_light: 'Ljust tema',
  event_theme_dark: 'Mörkt tema',
  create_event: 'Skapa berättelse',
  create_event_grave_info: 'Lägg till en livshändelse på {graveName}s grav.',
  edit_event: 'Redigera berättelse',
  show_all: 'Visa alla',
  set_as_cover: 'Ange som omslag',
  creator: 'Skapare',
  previous: 'Föregående',
  view_more_events: 'Visa fler livshistorier',
  view_more: 'Visa mer',
  connect_grave_title: 'Gravar du kan knyta till {graveName}',
  connect_grave_select_title: 'Välj graven du vill knyta till',
  connect_grave_relations_title: 'Sätt relationer',
  connect_grave_relation_subject: '{name} är',
  connect_grave_relation_object: 'till {name}',
  connect_grave_confirm: 'Knyt gravarna',
  connect_grave_section_direct: 'Dina gravar',
  connect_grave_section_other: 'Andra relevanta',
  link_to_grave: 'Koppla till denna grav',
  your: 'Din',
  graves_not_found: 'Inga gravar tillgängliga just nu.',
  connect_grave_empty_title: 'Det finns inga andra gravar här ännu',
  connect_grave_empty_message: 'När du får tillgång till fler kan du knyta ihop dem.',
  connect_grave_load_failed: 'Vi kunde inte hämta gravarna just nu.',
  share: 'Dela',
  linked_copied: 'Länk kopierad',
  share_memory: 'Dela minne',
  copy_link: 'Kopiera länk',
  media_not_added: 'Ingen media tillagd ännu.',
  delete_event_title: 'Bekräfta radering av berättelse?',
  grave_is_private_title: '{graveName}s grav är privat',
  grave_is_private_message: 'Endast nära släktingar kan se minnen och berättelser här.',
  grave_relations_private_title: 'Relationer är privata',
  grave_relations_private_message:
    'Eftersom denna grav är privat är relationer endast synliga för nära släktingar.',
  grave_user_not_found_message:
    'Här samlas relationerna kring {firstName}. Börja med dig själv och lägg till dem som betyder något.',
  grave_user_not_found_message_primary: 'Här samlas relationerna kring {firstName}.',
  grave_user_not_found_message_secondary:
    'Börja med dig själv och lägg till dem som betyder något.',
  grave_relations_empty_primary: 'Här ser du vem som hör till.',
  grave_relations_empty_secondary:
    'Knyt dig till graven för att se vilka som hör till runt {firstName}.',
  grave_relations_empty_cta: 'Knyt dig till {firstName}',
  connect_with_grave: 'Välj din relation till {graveName}',
  connect_grave_message:
    'Ange din relation till en älskad. Kräver Premium. Uppgradera för åtkomst.',
  cancel_relation_request: 'Avbryt relationsbegäran',
  cancel_claim_request: 'Avbryt ägarskapsbegäran',
  grave_welcome_title: 'Välkommen till {name}s grav.',
  grave_intro_text: 'Här kan du läsa, reflektera, dela historier eller bara vara stilla.',
  grave_natural_feelings_text:
    'Det är naturligt att tänka på ditt eget liv och dina egna förluster när du besöker en grav. Det är helt okej. Du är inte ensam.',
  grave_what_you_can_do_title: 'Detta kan du göra här:',
  grave_read_stories: 'Läsa berättelser och minnen',
  grave_react_comment_care: 'Reagera och kommentera',
  grave_share_reflections: 'Dela egna reflektioner',
  grave_light_candle: 'Var nära på märkesdagar, och bjud in andra som kände den avlidne',
  grave_why_nettgrav_matters_title: 'Nätgrav missionen',
  grave_support_end_of_time_center:
    'Varje Nätgrav stöttar arbetet hos End Of Time Center, som arbetar för en friskare värld där färre dör av sjukdom.',
  grave_team_end_of_time_message:
    'Hos Nätgrav kan du också läsa meddelanden från våra partner – företag som vill göra mer för dig och bidra till en bättre värld.',
  grave_enter_grave_button: 'Stäng',
  my_light_welcome_title: 'Mitt Ljus',
  my_light_you_are_the_light: 'Du är ljuset.',
  my_light_intro_text: 'Detta är din plats.',
  my_light_sparks_relationships_graves: 'Här kommer lösningar för det som betyder något.',
  my_light_what_you_find_here_title: 'Allt som byggs här har som mål att stärka goda sociala liv.',
  my_light_sparks: 'Med styrka, omsorg och mänsklig närhet i centrum.',
  my_light_graves: 'Detta är en plats för dig.',
  my_light_loved_ones: 'För det du bär, och det du vill ge vidare.',
  my_light_everything_begins_with_you: 'Mer kommer.',
  my_light_enter_button: 'Förstått',
  my_light_profile_occupation_label: 'Yrke eller roll',
  my_light_profile_occupation_placeholder: 'Vad arbetar du med?',
  my_light_profile_bio_label: 'Om mig',
  my_light_profile_bio_placeholder: 'Skriv några rader om dig',
  compass_tab: 'Mitt kompass',
  compass_title: 'Mitt kompass',
  compass_title_other: 'Så håller {name} kurs',
  compass_subtitle: 'Det jag försöker leva efter.',
  compass_empty_lead: 'Vissa väljer att skriva ner riktningen de vill hålla fast vid.',
  compass_empty_copy: 'Det kan göra både livet och relationerna tydligare.',
  compass_empty_cta: 'Skriv Mitt kompass',
  compass_help_primary: 'Skriv det som det är för dig.',
  compass_label_pressure_pattern: 'Det som drar mig ur kurs',
  compass_nav_pressure_pattern: 'Ur kurs',
  compass_help_pressure_pattern: 'Vad får dig oftast att tappa riktning?',
  compass_placeholder_pressure_pattern: 'När jag vill bli omtyckt mer än ärlig.',
  compass_label_anchor_statement: 'Det som inte är förhandlingsbart för mig',
  compass_nav_anchor_statement: 'Inte förhandlingsbart',
  compass_help_anchor_statement: 'Det jag inte kompromissar med.',
  compass_placeholder_anchor_statement: 'Jag ljuger inte för mig själv.',
  compass_label_choice_question: 'Frågan som håller mig på kurs',
  compass_nav_choice_question: 'Min fråga',
  compass_help_choice_question: 'En fråga före viktiga val.',
  compass_placeholder_choice_question: 'Är detta sant, eller bara tryggt?',
  compass_label_known_for: 'Så märker du att jag är ur kurs',
  compass_nav_known_for: 'Så märker du det',
  compass_help_known_for: 'Vad andra kan lägga märke till.',
  compass_placeholder_known_for: 'Jag blir tyst och drar mig undan.',
  compass_label_growth_edge: 'Så hittar jag tillbaka',
  compass_nav_growth_edge: 'Så hittar jag tillbaka',
  compass_help_growth_edge: 'Vad hjälper dig tillbaka i riktning?',
  compass_placeholder_growth_edge: 'Jag behöver stillhet och ett ärligt samtal.',
  compass_label_visibility: 'Synlighet',
  compass_visibility_self_only: 'Bara jag',
  compass_visibility_moons: 'Månar',
  compass_visibility_family_friends: 'Familj och vänner',
  compass_visibility_public: 'Offentlig',
  compass_visibility_shown_for: 'Synlig för: {visibility}',
  compass_visibility_owner_hint:
    'Så här visas din kompass för andra utifrån den synlighet du har valt.',
  compass_visibility_reason_family_friends:
    'Du ser detta eftersom du är registrerad som familj eller vän.',
  compass_visibility_reason_moons: 'Du ser detta eftersom du är registrerad som måne.',
  compass_visibility_reason_public: 'Du ser detta eftersom kompassen är delad offentligt.',
  compass_visibility_reason_default: 'Synligheten styrs av ägaren.',
  compass_safety_hint: 'Din kompass kan ändras när livet förändras.',
  compass_share_nudge: 'Vill du dela din kompass med någon nära?',
  compass_share_nudge_moons: 'Dela med månar',
  compass_share_nudge_family: 'Dela med familj och vänner',
  compass_share_nudge_public: 'Dela offentligt',
  compass_step_indicator: 'Fält {current} av {total}',
  compass_step_counter: '{current}/{total}',
  compass_summary_title: 'Så håller jag kurs',
  compass_prev: 'Föregående',
  compass_prev_alt: '← Föregående',
  compass_prev_to: '← Till {label}',
  compass_next: 'Vidare',
  compass_next_alt: 'Nästa →',
  compass_next_to: 'Till {label} →',
  compass_save: 'Spara',
  compass_saving: 'Sparar...',
  compass_saved: 'Sparat',
  compass_save_error: 'Kunde inte spara just nu.',
  compass_signal_cta: 'Tack för att du delade',
  compass_signal_sent: 'Tecken skickat',
  compass_signal_sent_to: 'Tack skickat till {name}',
  compass_signal_toast_sent: 'Tack skickat.',
  compass_signal_error: 'Kunde inte skicka tack just nu.',
  compass_signal_hint: 'Ett stilla tack för att de delade sin kompass. Det visas inte offentligt.',
  compass_signal_sent_hint: 'Det visas bara för {name}.',
  compass_signal_guest_hint: 'Logga in för att låta dem veta att du såg detta.',
  compass_signal_guest_cta: 'Logga in',
  compass_can_change: 'Du kan ändra detta när som helst.',
  compass_shared_none: 'Ingen kompass delad ännu.',
  my_light_profile_cancel: 'Stäng',
  my_light_profile_save: 'Spara',
  my_light_about_title: 'Om mig',
  conversation_starters_tab_self: 'Fråga mig om',
  conversation_starters_tab_other: 'Fråga {name}',
  conversation_starters_title_self: 'Fråga mig om',
  conversation_starters_title_other: 'Fråga {name}',
  conversation_starters_subtitle: 'Vissa samtal behöver bara en plats att börja på.',
  conversation_starters_placeholder: 'Skriv något andra gärna får fråga dig om',
  conversation_starters_suggestion_1: 'varför jag',
  conversation_starters_suggestion_2: 'hur jag',
  conversation_starters_suggestion_3: 'vad jag lärde mig när',
  conversation_starters_suggestion_4: 'vad som fick mig att',
  conversation_starters_visibility_label: 'Vem kan se detta?',
  conversation_starters_visibility_everyone: 'Alla',
  conversation_starters_visibility_moons: 'Månar',
  conversation_starters_visibility_family_friends: 'Familj och vänner',
  conversation_starters_visibility_self_only: 'Bara jag',
  conversation_starters_add: 'Lägg till',
  conversation_starters_ask: 'Fråga {name}',
  conversation_starters_chat_draft: 'Hej {name}. Du skriver att jag kan fråga dig om ”{starter}”.',
  conversation_starters_empty: 'Lägg till något som kan öppna ett gott samtal.',
  conversation_starters_save_error: 'Kunde inte spara samtalsingången just nu.',
  conversation_starters_delete_error: 'Kunde inte ta bort samtalsingången just nu.',
  conversation_starters_chat_error: 'Kunde inte öppna samtalet just nu.',
  day_title: 'Dagen',
  day_subtitle: 'Något att tänka på, någon att förstå och något att bevara.',
  day_reflection_label: 'En tanke för dagen',
  day_reflection_1: 'Vad har du kommit att förstå annorlunda med tiden?',
  day_reflection_2: 'Vilken fråga följer dig just nu?',
  day_reflection_3: 'Vad önskar du att fler människor var nyfikna på?',
  day_reflection_4: 'Vad har en annan människa lärt dig utan att veta om det?',
  day_reflection_5: 'Vad betyder närhet för dig i dag?',
  day_reflection_action: 'Gå till Skapa Gnista',
  day_connection_label: 'Förstå tillsammans',
  day_connection_title: '{name} har delat något de vill förstå tillsammans med andra.',
  day_connection_empty_title: 'Har du något du vill förstå tillsammans med andra?',
  day_connection_empty_text:
    'Dela det med egna ord och välj om Nätgrav får hjälpa nya människor att hitta det.',
  day_connection_action: 'Läs och förstå tillsammans',
  day_connection_empty_action: 'Dela med egna ord',
  day_preserve_label: 'Bevara',
  day_preserve_title: 'Finns det ett foto med en historia som bara du känner till?',
  day_preserve_action: 'Gå till dina gravar',
  own_words_discovery_title: 'Låt Nätgrav knyta mig till nya människor',
  own_words_discovery_help:
    'Dessa ord kan visas i Dagen för personer du inte känner. Du kan stänga av detta när du vill.',
  my_light_about_subtitle: 'Några ord om mig, så som livet känns nu.',
  my_light_questions_title: 'Tre frågor',
  my_light_question_1: 'Vad är viktigt för mig i livet just nu?',
  my_light_question_2: 'Vad ger mig ro, mening eller energi i vardagen?',
  my_light_question_3: 'Vad håller jag på att lära mig om mig själv?',
  spark_energy_tooltip: 'Din Gnista gör världen till en bättre plats.',
  grave_support_title: 'Vad stöder denna grav?',
  grave_support_intro: 'Varje Nätgrav är en del av något större.',
  grave_support_body:
    'Denna grav stöder End Of Time Center – ett vetenskapscenter med en radikal vision: En värld utan död.',
  grave_support_help:
    'Tillsammans söker vi svar på varför vi dör och hur insikten från döden kan hjälpa oss leva djupare och mer omtänksamt – för oss själva och varandra.',
  grave_support_read_more: 'Läs mer om End Of Time Center.',
  end_of_time_center_title: 'End Of Time Center',
  end_of_time_center_intro:
    'Nätgrav är den första produkten från The End Of Time Corporation. Vi planerar att etablera End Of Time Center – ett vetenskapligt centrum för forskning om liv och död, med ett radikalt mål: Att förstå döden och skapa en framtid där ingen behöver en grav.',
  end_of_time_center_body:
    'Här kommer forskare, visionärer och problemlösare att samlas för att utveckla kunskap, lösningar och nya perspektiv på livets största frågor. Tillsammans söker vi insikt och inspiration som kan göra världen tryggare, varmare – och kanske lite mer evig.',
  end_of_time_center_close: 'Stäng',
  about_this_grave: 'Om denna grav',
  my_light: 'Mitt Ljus',
  relation_confirmation_label: 'Automatisk bekräftelse av relation',
  auto_confirm_on: 'Automatisk',
  auto_confirm_off: 'Kräver godkännande',
  relation_requests: 'Relationsförfrågningar',
  connection_request_sent_info:
    'Din anslutningsförfrågan har skickats till ägaren av {graveName}. När den godkänts kommer graven att visas bland dina anslutna gravar.',
  connection_request_sent: 'Anslutningsförfrågan skickad.',
  connection_created_unverified: 'Gravkopplingen skapades utan bekräftelse från en gravförvaltare.',
  connection_request_failed: 'Kunde inte skicka anslutningsförfrågan. Försök igen senare.',
  linked_grave_unverified_status: 'Inte bekräftad av en gravförvaltare',
  grave_already_connected: '{graveName} is already connected',
  is_grave_already_connected: 'Is this grave already connected?',
  take_grave_ownership: 'Vill du bli ägare till denna grav?',
  grave_privacy_public:
    'Denna grav är offentlig. Vem som helst kan se och interagera med offentligt innehåll.',
  grave_privacy_private:
    'Denna grav är privat. Endast inbjudna användare kan se innehållet. Andra kan inte se något.',
  grave_privacy_relatives:
    'Denna grav är inställd på släktingar. Släktingar kan se både släkt- och offentligt innehåll. Andra kan bara se offentligt innehåll.',
  please_fill_all_fields: 'Vänligen fyll i alla obligatoriska fält',
  grave_invitations: 'Gravinbjudningar',
  'relationships.manageInvites': 'Bjud in familj och vänner',
  invite_you_as: 'bjuder in dig som',
  grave_invitation: 'Gravinbjudan',
  grave_invitations_not_found_title: 'Inga inbjudningar hittades',
  grave_invitations_not_found_subtile:
    'Du har inte fått några gravinbjudningar ännu. När någon bjuder in dig kommer du att se det här.',
  invited_you_to_grave: '{name} bjöd in dig till graven',
  search_by_name: 'Sök efter namn',
  confirm_delete_linked_grave_message:
    'Detta tar bort länken till den här graven. Du kan länka graven igen senare.',
  search_grave_placeholder: 'Sök efter namn',
  search_open: 'Öppna sök',
  search_open_full: 'Sök',
  search_submit: 'Sök',
  clear_search: 'Rensa sök',
  close_search: 'Stäng sök',
  search_grave_heading: 'Hitta graven du letar efter',
  search_grave_intro: 'Sök efter namn, eller filtrera vidare.',
  search_all_heading: 'Hitta människor och gravar',
  search_all_intro: 'Sök efter en människa eller grav med namn.',
  search_all_placeholder: 'Sök efter människor och gravar',
  search_people_heading: 'Hitta personen du letar efter',
  search_people_intro: 'Sök efter namn för att hitta människor.',
  search_people_placeholder: 'Sök efter människor',
  search_grave_guest_cta_title: 'När du hittar rätt grav',
  search_grave_guest_cta_body:
    'kan du knyta dig till den, lämna ett tecken och följa med över tid.',
  search_grave_guest_cta_button: 'Skapa konto',
  search_grave_loading_title: 'Vi hämtar graven...',
  search_grave_loading_subtitle: 'Detta tar vanligtvis under en sekund.',
  search_all_loading_title: 'Vi hämtar resultaten...',
  search_all_loading_subtitle: 'Detta tar vanligtvis under en sekund.',
  search_people_loading_title: 'Vi hämtar medlemmarna...',
  search_people_loading_subtitle: 'Detta tar vanligtvis under en sekund.',
  search_grave_none_subtext:
    'Prova ett annat namn eller sök med färre bokstäver. Du kan också avgränsa träffarna med kommun och kyrkogård.',
  search_grave_none_text: 'Inga resultat hittades för',
  search: 'Sök',
  search_grave_perfect_matches: 'Kan detta vara den du letar efter?',
  search_grave_filter_heading: 'Filtrera efter land, kommun och kyrkogård',
  search_grave_show_filters: 'Visa fler sökval',
  search_grave_hide_filters: 'Dölj sökval',
  search_grave_image_heading: 'Sök gravar för att komma igång.',
  search_grave_image_subtitle: 'Vem söker du idag?',
  search_grave_search_for: 'Resultat för',
  search_grave_no_relation_hint:
    'Du kan besöka graven nu. När du väljer relation blir den en del av ditt rum här.',
  search_grave_visit_cta: 'Besök graven',
  grave_invitation_email: 'E-postadress',
  grave_invitation_email_placeholder: 'Skriv e-postadress',
  grave_invitation_email_required: 'Lägg till e-post.',
  grave_invitation_email_required_validation: 'Ange en giltig e-post',
  grave_invitation_invited_person_name: 'Namn',
  grave_invitation_invited_person_name_placeholder: 'Skriv namn',
  grave_invitation_name_required: 'Lägg till namn.',
  grave_invitation_relation_to_grave: 'Er relation',
  grave_invitation_relation_to_grave_modal: 'Den inbjudnas relation till {graveName}',
  grave_invitation_relation_to_grave_help:
    'Sätt relationen som den inbjudna personen kommer att se den.',
  grave_invitation_relation_required: 'Välj relation.',
  grave_invitation_select_relationship: 'Välj hur ni hänger ihop',
  grave_invitation_select_relationship_short: 'Välj relation',
  grave_invitation_relation_to_person: 'Så ser de {graveName}',
  grave_invitation_relation_to_person_modal: '{graveName}s relation till den inbjudna',
  grave_invitation_relation_to_person_help: 'Detta visas från den inbjudna personens perspektiv.',
  grave_invitation_select_reciprocal: 'Välj relation (till exempel förälder eller syskon)',
  grave_invitation_direction_required: 'Välj relationsriktning.',
  grave_invitation_administrator_access: 'Administratörsåtkomst',
  grave_invitation_role_required: 'Välj roll.',
  grave_invitation_administrator: 'Administratör',
  grave_invitation_normal: 'Normal',
  anniversary_create_name: 'Namn',
  anniversary_create_placeholder_name: 'Ange namn',
  anniversary_create_date_time: 'Datum',
  anniversary_create_name_required: 'Ange namn',
  anniversary_create_date_time_required: 'Välj datum',
  anniversary_create_date_hint: 'Kan ändras senare.',
  anniversaries_create_title: 'Lägg till minnesdag',
  anniversaries_create_hint: 'För samling, besök eller en dag som betyder något för er.',
  spark_create_modal_category: 'Gnista kategori:',
  spark_suggestions_label: 'Lite inspiration:',
  spark_category_question: 'fråga',
  spark_category_insight: 'insikt',
  spark_category_experience: 'erfarenhet',
  spark_category_discovery: 'upptäckt',
  spark_category_emotion: 'känsla',
  spark_category_value: 'värde',
  spark_category_energy: 'energi',
  spark_category_intention: 'avsikt',
  spark_category_Story: 'Berättelse',
  spark_category_Feeling: 'Känsla',
  edit_spark: 'Redigera Gnista',
  share_spark: 'Dela Gnistan',
  extinguish_park: 'Släck Gnistan',
  spark_info_title: 'Vad är min Gnista?',
  spark_info_intro:
    'En Gnista börjar inom dig. Det kan vara en tanke, en fråga, en erfarenhet eller något som får dig att stanna upp och känna efter. När du delar den kan den väcka reflektion, närhet eller handling hos andra.',
  spark_examples_title: 'Exempel på en Gnista',
  spark_form_info:
    'Välj formen på din Gnista. Då visar du hur du vill dela din sanning – som en fråga, berättelse, insikt, känsla eller avsikt.',
  spark_example_question: 'En fråga du funderar på.',
  spark_example_insight: 'En insikt du fått.',
  spark_example_experience: 'En upplevelse som berörde dig.',
  spark_example_value: 'Ett värde du vill lyfta fram.',
  spark_why_title: 'Varför skapa en Gnista?',
  spark_why_inspire: 'För att inspirera andra.',
  spark_why_express: 'För att sätta ord på det du tänker och känner.',
  spark_why_share: 'För att dela något som betyder mycket för dig.',
  spark_why_build: 'För att bygga ett varmare och mer öppet gemenskap.',
  spark_how_title: 'Hur skapar du en Gnista?',
  spark_how_step1: 'Skriv en tanke, en fråga eller dela en känsla.',
  spark_how_step2: 'Välj kategori: Fråga, Insikt, Upplevelse, Värde, Känsla, Energi.',
  spark_how_step3: 'Publicera – och låt din gnista lysa för andra!',
  spark_helper_text:
    'Dela din gnista – en fråga, en tanke eller en känsla. Små eller stora ord kan ge ljus åt andra.',
  spark_show_inspirations: 'Låt dig inspireras – hämta en fråga',
  spark_get_question: 'Hämta en fråga',
  spark_selected_question: 'Vad är din gnista?',
  spark_change_question: 'Byt fråga',
  spark_optional_helper: 'Ditt bidrag kan vara en gnista för andra.',
  spark_textarea_label: 'Vad väcker en Gnista inom dig?',
  'sparks.media.limits': 'Upp till 5 bilder eller videor. Högst 50 MB per fil.',
  'sparks.media.tooMany': 'Du kan lägga till upp till 5 bilder eller videor.',
  'sparks.media.tooLarge': '{name} är större än 50 MB.',
  'sparks.media.invalidType': '{name} är inte ett bild- eller videoformat som stöds.',
  spark_reflection_label: 'Lägg till din gnista som svar.',
  spark_menu_button: 'Gnistemeny',
  spark_share_button: 'Dela',
  discard_draft: 'Lägg utkastet åt sidan',
  share_life_event: 'Dela livshändelse',
  delete_spark_title: 'Vill du ta bort denna Gnista?',
  share_link_spark: 'Gnistan är redo att delas',
  public_view_description: 'Denna Gnista delas med alla',
  moons_only_description: 'Denna Gnista delas med dina månar',
  constellation_description: 'Denna Gnista delas med ditt stjärnbild',
  memory_public_description: 'Alla som besöker {name} på Nätgrav kan läsa inlägget.',
  memory_private_description: 'Ditt inlägg är bara synligt för dig',
  memory_relatives_description:
    'Det du delar här visas bara för dem som har en relation till {name} på Nätgrav.',
  memory_privacy_label: 'Sekretess',
  memory_description_label: 'Orden du lämnar',
  file_remove_failed: 'Det gick inte att ta bort filen.',
  add_value: 'Lägg till egenskap',
  spark_feeling_Reflecting: 'Reflekterande',
  spark_feeling_Reflecting_description: 'Skapa en Gnist om något du har tänkt mycket på.',
  spark_feeling_Wonder: 'Förundran',
  spark_feeling_Wonder_description: 'Skapa en Gnist med en fråga du undrar över.',
  spark_feeling_Connection: 'Anslutning',
  spark_feeling_Connection_description: 'Skapa en Gnist som binder människor samman.',
  spark_feeling_Freedom: 'Frihet',
  spark_feeling_Hopeful: 'Hopp',
  spark_feeling_Gratitude: 'Tacksamhet',
  spark_feeling_Peace: 'Fred',
  spark_feeling_Freedom_description:
    'Skapa en Gnist från din fria, inre plats – en plats vi måste värna om. Dela utan rädsla för att sätta igång förändring.',
  spark_feeling_tooltip: 'Välj perspektiv',
  memory_reaction_name_Healed: 'Visa att det tröstade',
  memory_reaction_name_Love: 'Visa kärlek',
  memory_reaction_name_Remembered: 'Jag minns det också',
  memory_reaction_name_Cherished: 'Uppskatta minnet',
  views: 'visningar',
  grave_memories: 'Gravminnen',
  grave_memories_placeholder: 'Lämna några ord här.',
  grave_memories_message: 'En plats att lämna ord när du är på besök.',
  grave_post_on: 'Publicerat på:',
  select_grave: 'Välj grav',
  select_a_grave: 'vänligen välj en grav',
  user_values_title: 'Det här ser vi i {name}',
  user_values_menu: 'Det här ser jag i {name}',
  profile_values_tab_self: 'Det andra har förstått om mig',
  profile_values_tab_self_mobile: 'Förstått om mig',
  profile_values_tab_other: 'Det andra har förstått om {name}',
  profile_values_tab_other_mobile: 'Om personen',
  profile_people_tab_self: 'Mina människor',
  profile_people_tab_self_mobile: 'Människor',
  compass_tab_mobile: 'Kompass',
  profile_people_tab_other: 'Människorna runt {name}',
  profile_people_tab_other_mobile: 'Människor',
  my_light_profile_label: 'Mitt ljus',
  my_light_profile_purpose_self:
    'En plats för det du står för, människorna omkring dig och det du vill föra vidare.',
  my_light_profile_purpose_other:
    'En plats för det som kännetecknar {name}, människorna omkring och det som ska leva vidare.',
  intention_moment_section_title_self: 'Det andra har förstått om mig',
  intention_moment_section_title_other: 'Det andra har förstått om {name}',
  intention_moment_section_intro:
    'Ögonblick som andra lade märke till och samtal om hur de upplevdes.',
  intention_moment_add: 'Dela ett ögonblick',
  intention_moment_empty_self_title: 'Ingen har delat ett sådant ögonblick ännu',
  intention_moment_empty_self_message:
    'Här kan andra dela ett ögonblick de lade märke till, och du kan svara med ditt perspektiv.',
  intention_moment_empty_other_title: 'Är det något du har lagt märke till hos {name}?',
  intention_moment_empty_other_message: 'Dela ett konkret ögonblick och vad det gjorde med dig.',
  intention_moment_empty_readonly_title: 'Ingen har delat ett sådant ögonblick om {name} än',
  intention_moment_empty_readonly_message:
    'Här får ögonblick som människor nära {name} väljer att dela en plats.',
  intention_moment_create_title: 'Något du lade märke till hos {name}',
  intention_moment_edit_title: 'Redigera ögonblicket',
  intention_moment_observed_label: 'Vad hände?',
  intention_moment_observed_help:
    'Berätta om en konkret handling, ett val eller ett ögonblick med {name}.',
  intention_moment_observed_placeholder: 'Beskriv situationen så som du upplevde den.',
  intention_moment_impact_label: 'Vad gjorde det med dig?',
  intention_moment_impact_help: 'Vad tänkte, kände eller gjorde du annorlunda efteråt?',
  intention_moment_impact_placeholder: 'Det gjorde att jag ...',
  intention_moment_share: 'Dela ögonblicket',
  intention_moment_update: 'Spara',
  intention_moment_save_error: 'Ögonblicket kunde inte sparas. Försök igen.',
  intention_moment_card_impact: 'Det gjorde med mig',
  intention_moment_legacy_value: 'Ett ord som valdes: {value}',
  intention_moment_delete_title: 'Radera ögonblicket?',
  intention_moment_delete_message: 'Bidraget tas bort permanent.',
  intention_moment_hide_title: 'Ta bort detta från din profil?',
  intention_moment_hide_message: 'Bidraget tas bort. Orden ändras inte och tillskrivs inte dig.',
  intention_moment_hide_action: 'Ta bort',
  intention_moment_creator_consent: 'Jag är bekväm med offentlig visning om {name} också vill det.',
  intention_moment_private_until_both:
    'Kortet är privat mellan er tills båda uttryckligen väljer offentlig visning.',
  intention_moment_response_title: 'Så var det för dig',
  intention_moment_response_observer_label: 'Detta blev uppmärksammat',
  intention_moment_response_prompt: 'Vad var viktigt för dig i situationen?',
  intention_moment_response_help:
    'Berätta med egna ord. Det kan ha varit sammansatt eller något du inte tänkt på tidigare.',
  intention_moment_response_placeholder: 'Så här upplevde jag det som pågick inom mig ...',
  intention_moment_subject_consent: 'Jag vill att hela kortet kan visas offentligt i Mitt ljus.',
  intention_moment_public_only_together:
    'Kortet blir offentligt endast eftersom ni båda har valt det.',
  intention_moment_response_save: 'Dela mitt perspektiv',
  intention_moment_card_subject_response: 'Så var det för {name}',
  intention_moment_respond: 'Svara med ditt perspektiv',
  intention_moment_edit_response: 'Redigera mitt perspektiv',
  intention_moment_continue_chat: 'Fortsätt i chatten',
  intention_moment_chat_error: 'Kunde inte öppna samtalet.',
  intention_moment_content_locked:
    'När mottagaren har svarat kan orden ovan inte ändras. Du kan fortfarande ändra ditt samtycke.',
  user_values_add_cta: 'Säg något du ser',
  user_values_empty_title: 'Lägg till egenskaperna som visar vem {firstName} är.',
  user_values_empty_message:
    'Dela vad som betyder mest för {name} så att andra vet hur de kan stötta.',
  user_values_empty_self_title: 'Det andra ser i dig',
  user_values_empty_self_message: 'När någon delar det de ser i dig visas det här.',
  user_values_modal_title: 'Vad ser du i {name}?',
  user_values_modal_edit_title: 'Redigera egenskap',
  user_values_modal_heading: 'Välj en egenskap du känner igen, och säg varför.',
  user_values_selected_label: 'Jag ser detta i {name}',
  user_values_selected_message: 'Vad får dig att välja “{personality}”?',
  user_values_placeholder: 'Skriv några ord om det du har sett eller upplevt.',
  user_values_create_cta: 'Dela',
  user_values_update_cta: 'Dela',
  user_values_privacy_public_description: 'Synligt för alla som besöker {name}s sida.',
  user_values_privacy_private_description: 'Endast du och {name} ser den här egenskapen.',
  user_values_privacy_relatives_description:
    'Personer du bjuder in för att ta hand om {name} ser den här egenskapen.',
  gift_from: 'Tände ett ljus',
  grave_values: 'Ord om {graveName}',
  grave_values_fallback: 'Ord om',
  grave_values_load_failed: 'Det gick inte att hämta orden just nu',
  grave_values_load_failed_description: 'Försök igen. Det som redan har delats finns kvar.',
  grave_values_options_load_failed: 'Det gick inte att hämta egenskaperna',
  grave_values_options_load_failed_description: 'Försök igen innan du delar dina ord.',
  grave_values_privacy_label: 'Vem kan se detta?',
  grave_values_created: 'Egenskapen har lagts till.',
  grave_values_updated: 'Egenskapen har uppdaterats.',
  grave_values_deleted: 'Egenskapen har tagits bort.',
  grave_values_save_failed: 'Det gick inte att spara egenskapen. Försök igen.',
  the_value_archive: 'Egenskaper',
  edit_value_archive: 'Redigera egenskap',
  create_value_archive: 'Skapa egenskap',
  update_value_archive: 'Uppdatera egenskap',
  value_archive_title: 'Välj en egenskap och lägg till en historia',
  value_archive_selected: 'En egenskap som beskriver {graveName}',
  value_archive_selected_message:
    'Du minns {graveName} som {personality}. Dela några ord som visar det.',
  no_suggestions: 'Inga förslag tillgängliga',
  value_archive_placeholder: 'Skriv några ord som visar på egenskapen',
  select_personality_warning: 'Välj en egenskap.',
  enter_description_warning: 'Kom ihåg att lägga till några ord som visar på egenskapen.',
  grave_values_empty_primary: 'Ord och små berättelser om vem {firstName} var för andra.',
  grave_values_empty_secondary: 'Knyt dig till graven för att dela dina ord om {firstName}.',
  grave_values_empty_cta: 'Knyt dig till {firstName}',
  no_values_added: '{firstName}s berättelse rymmer mer.',
  add_values_message:
    'Egenskaper är ord som beskriver hur personen var att möta – det som satte spår hos andra.',
  confirm_delete_value_message:
    'Detta tar bort egenskapen från den här platsen. Du kan lägga till den igen senare.',
  confirm_delete_product_message:
    'Detta tar bort produkten. Du kan lägga till produkten igen senare.',
  added_personality_value: 'lade till',
  create_grave: 'Skapa grav',
  create_grave_mode_label: 'Vad vill du skapa?',
  create_grave_mode_grave: 'Ny grav',
  create_grave_mode_with_ceremony: 'Ny grav med dödsannons',
  create_grave_mode_with_ceremony_mobile: 'Med dödsannons',
  create_grave_mode_with_ceremony_help:
    'Du kan lägga till det viktigaste nu. Tid och plats kan fyllas i senare.',
  create_grave_ceremony_accuracy_confirm_label:
    'Jag bekräftar att uppgifterna är riktiga så långt jag vet.',
  create_grave_ceremony_confirm_required: 'Bekräfta att uppgifterna är riktiga så långt du vet.',
  create_grave_death_notice_section: 'Dödsannons',
  create_grave_ceremony_section: 'Ceremoni',
  create_grave_ceremony_message_label: 'Meddelande till familj och vänner',
  create_grave_ceremony_message_placeholder: 'Skriv ett kort meddelande.',
  create_grave_ceremony_place_of_death_label: 'Var gick personen bort',
  create_grave_ceremony_place_of_death_placeholder: 't.ex. hemma, på äldreboende eller sjukhus',
  create_grave_ceremony_timing_pending: 'Tid och plats är inte satta än',
  create_grave_ceremony_timing_pending_help: 'Du kan uppdatera detta senare på graven.',
  create_grave_ceremony_funeral_date_label: 'Ceremoni (datum)',
  create_grave_ceremony_funeral_time_label: 'Ceremoni (tid)',
  create_grave_ceremony_funeral_time_placeholder: 't.ex. 12:00',
  create_grave_ceremony_funeral_at_label: 'Ceremoni (datum och tid)',
  create_grave_ceremony_funeral_venue_label: 'Plats',
  create_grave_optional_field_help: 'Valfritt',
  create_grave_ceremony_funeral_venue_placeholder: 't.ex. Lade kyrka',
  create_grave_any_proof: 'Har du dokument för att bekräfta dödsfallet?',
  create_grave_validation_name_required: 'Lägg till namn.',
  create_grave_validation_gender_required: 'Välj kön.',
  create_grave_validation_birthday_required: 'Välj födelsedatum.',
  create_grave_validation_death_date_required: 'Välj dödsdatum.',
  create_grave_validation_country_required: 'Välj land.',
  create_grave_validation_municipality_required: 'Välj kommun.',
  create_grave_validation_cemetery_required: 'Välj kyrkogård.',
  create_grave_validation_relation_required: 'Välj relation.',
  create_grave_validation_reciprocal_relation_required: 'Välj ömsesidig relation.',
  create_grave_validation_reason_required: 'Välj dödsorsak.',
  create_grave_validation_other_reason_required: 'Välj annan orsak.',
  create_grave_select_document_heading: 'Välj dokument',
  create_grave_select_document_message: 'Välj dokumentet du vill ladda upp och godkänn villkoren',
  spark_feeling: 'Välj perspektiv',
  added_spark_feeling_Reflecting: 'skapar gnista med reflektion',
  added_spark_feeling_Wonder: 'skapar gnista med förundran',
  added_spark_feeling_Connection: 'skapar gnista med förbindelse',
  added_spark_feeling_Freedom: 'skapar gnista med frihet',
  added_spark_feeling_Hopeful: 'skapar gnista med hopp',
  added_spark_feeling_Gratitude: 'skapar gnista med tacksamhet',
  added_spark_feeling_Peace: 'skapar gnista med fred',
  added_reflection_feeling_Reflecting: 'reflekterar med reflektion',
  added_reflection_feeling_Wonder: 'reflekterar med förundran',
  added_reflection_feeling_Connection: 'reflekterar med förbindelse',
  added_reflection_feeling_Freedom: 'reflekterar med frihet',
  added_reflection_feeling_Hopeful: 'reflekterar med hopp',
  added_reflection_feeling_Gratitude: 'reflekterar med tacksamhet',
  added_reflection_feeling_Peace: 'reflekterar med fred',
  spark_reflections_header: 'Reflektioner',
  spark_add_reflection: 'Lägg till reflektion',
  spark_reflections_empty: 'Var först med att lägga till en reflektion.',
  spark_reflections_count: '{count, plural, one {# reflektion} other {# reflektioner}}',
  spark_reflectors_count: '{count, plural, one {# person} other {# personer}}',
  spark_reflecting_on: 'Reflekterar över',
  spark_reflection_feeling: 'Tillstånd: {state}',
  spark_original_label: 'Ursprunglig gnista',
  spark_reflection_context_label: 'Reflektion',
  spark_unknown_user: 'Någon',
  spark_reactions_empty: 'Inga reaktioner för det här urvalet ännu.',
  memory_feeling_Remembering: 'Minns',
  memory_feeling_Remembering_description:
    'Återupplev fina stunder och berättelser som håller minnet levande.',
  memory_feeling_Honoring: 'Sätter pris på',
  memory_feeling_Honoring_description:
    'Uttryck tacksamhet och erkänn de värderingar och spår de lämnade efter sig.',
  memory_feeling_Reflecting: 'Reflekterar',
  memory_feeling_Reflecting_description:
    'Ta en paus för att känna efter vad deras liv och närvaro betyder för dig.',
  memory_feeling_Thankful: 'Tacksam',
  memory_feeling_Thankful_description:
    'Dela vad du är tacksam för – deras kärlek, visdom eller minnen du bär med dig.',
  memory_feeling_Missing: 'Saknar',
  memory_feeling_Missing_description: 'Sätt ord på saknaden och det tomrum deras frånvaro lämnar.',
  memory_feeling_Forgiving: 'Förlåter',
  memory_feeling_Forgiving_description: 'Väljer att förlåta och släppa taget.',
  added_memory_feeling_Remembering: 'minns {graveName}',
  added_memory_feeling_Honoring: 'sätter pris på {graveName}',
  added_memory_feeling_Reflecting: 'reflekterar över {graveName}',
  added_memory_feeling_Thankful: 'är tacksam för {graveName}',
  added_memory_feeling_Missing: 'saknar {graveName}',
  added_memory_feeling_Forgiving: 'förlåter {graveName}',
  view_header_desktop: 'Skrivbords­förhandsvisning',
  view_header_mobile: 'Mobil­förhandsvisning',
  memory_posts: 'Minnes­inlägg',
  view_deceased_name: 'Gravens namn',
  grave_duplicate_title: 'Denna grav finns redan',
  grave_duplicate_message:
    'En grav med samma namn och detaljer finns redan på Nätgrav. Vi skapar inte en ny grav när vi hittar en säker matchning. Besök den som finns för att knyta an.',
  grave_duplicate_button: 'Gå till befintlig grav',
  create_grave_pending_review_notice:
    'Graven har skickats till Nätgrav för granskning och är inte offentligt synlig ännu.',
  create_grave_create_error: 'Graven kunde inte skapas. Kontrollera uppgifterna och försök igen.',
  create_grave_potential_duplicates_title: 'Vi hittade en liknande grav',
  create_grave_potential_duplicates_message:
    'Kontrollera om någon av dessa är samma person innan du skapar en ny grav.',
  create_grave_potential_duplicates_button: 'Gå till graven',
  grave_create_invalid_date_title: 'Ogiltig datum­ordning',
  grave_create_invalid_date_message:
    'Dödsdatum kan inte vara före födelsedatum. Kontrollera datumen och försök igen.',
  memory_feeling_tooltip: 'Känsla',
  memory_feeling: 'Känsla',
  conscious_verified_badge:
    'Du får en verifierad badge – ett tecken på förtroende, närvaro och omsorg i gemenskapen',
  conscious_supports_free_graves:
    'Du hjälper till att hålla alla gravar öppna och omhändertagna, så att alla kan minnas sina kära oavsett betalningsförmåga.',
  conscious_ad_free_safe_space:
    'Du stödjer ett säkert, reklamfritt utrymme baserat på tillhörighet, värme och ärlighet.',
  conscious_supports_community_and_mission:
    'Ditt bidrag upprätthåller Nätgrav-gemenskapen och den bredare End Of Time-missionen, nu och i framtiden.',
  partner_page_title: 'Partner – The End of Time',
  partner_page_mission: 'Stöd minne, tacksamhet och sanning.',
  partner_welcome_title: 'Välkommen!',
  partner_welcome_message:
    'Bli partner. Stöd minne, tacksamhet och sanning för familjer och samhällen.',
  partner_company_name: 'Företagsnamn',
  partner_company_website: 'Företagswebbplats',
  partner_company_mission: 'Kort missions­beskrivning',
  partner_company_logo: 'Logotyp',
  partner_continue: 'Fortsätt',
  partner_choose_context_title: 'Välj var du vill stödja',
  partner_appears_memory_album: 'Visas försiktigt vid familjernas minnesalbum.',
  partner_appears_value_archive: 'Tacksamhet möjliggörs tack vare våra partners.',
  partner_appears_funeral_room: 'I samarbete med dig för minnet.',
  partner_appears_anniversary_calendar: 'Firar minnen med partners hjälp.',
  partner_appears_groups: 'Gemenskapsstöd möjligtgörs av partners.',
  partner_appears_store: 'Sänt till dig med omsorg av partners.',
  partner_upload_or_generate_title: 'Ladda upp eller generera din annons',
  partner_upload_image_video: 'Ladda upp bild/video',
  partner_select_theme: 'Välj tema',
  partner_select_theme_remembrance: 'Minnesstund',
  partner_select_theme_gratitude: 'Tacksamhet',
  partner_select_theme_support: 'Stöd',
  partner_or: 'Eller',
  partner_describe_generate:
    "Beskriv vad du vill generera (t.ex. 'ett mjukt ljus med mild bakgrund')",
  partner_generate_ai: 'Generera med AI',
  partner_upload_success: 'Kreativt innehåll uppladdat!',
  partner_generate_success: 'Genererat med AI!',
  partner_write_message_title: 'Skriv ditt meddelande',
  partner_write_message_placeholder: 'Skriv ett varmt, stödjande meddelande…',
  partner_make_warmer: 'Gör det varmare / poetiskt',
  partner_live_preview: 'Live förhandsvisning',
  partner_message_preview_placeholder: 'Ditt meddelande kommer att synas här.',
  partner_set_commitment_title: 'Ange ditt åtagande',
  partner_commitment_cpm: 'CPM (per 1 000 visningar)',
  partner_commitment_cpm_desc: '~6 200 visningar/månad, 140 kr CPM',
  partner_commitment_cpc: 'CPC (per klick)',
  partner_commitment_cpc_desc: 'Betala endast för varje klick',
  partner_commitment_flat: 'Fast månadssponsring',
  partner_commitment_flat_desc: 'Fast avgift, allt inkluderat',
  partner_campaign_summary: 'Din kampanjsammanfattning',
  partner_estimated_monthly_reach: 'Beräknad månatlig räckvidd',
  partner_commitment: 'Åtagande',
  partner_submit_review: 'Skicka för granskning',
  partner_status_thank_you: 'Tack! Ditt partnerskap granskas inom 24 timmar.',
  partner_status_subtitle:
    'Du får uppdatering via e-post när det godkänts. Du kan följa status på din instrumentpanel.',
  partner_go_to_dashboard: 'Gå till instrumentpanelen',
  partner_your_campaigns: 'Dina kampanjer',
  partner_placement: 'Placering',
  partner_status: 'Status',
  partner_impressions: 'Visningar',
  partner_clicks: 'Klick',
  partner_actions: 'Åtgärder',
  partner_view_company: 'Visa företag',
  partner_sponsored: 'End Of Time Call',
  partner_call_cta: 'End Of Time Call',
  partner_supported_by: 'Stöds av ❤️ {count} medvetna medlemmar',
  partner_highlight_this_partner: 'Lyft fram denna partner',
  partner_about: 'Om',
  partner_partner_since: 'Partner sedan: {date}',
  partner_causes_supported: 'Stödda ändamål:',
  partner_active_campaigns: 'Aktiva kampanjer:',
  partner_families_supported: 'Stödda familjer',
  partner_testimonials: 'Omdömen:',
  partner_total_highlights: 'Totala framhävningar',
  partner_see_support_helps: 'Se hur ditt stöd hjälper',
  partner_share_impact: 'Dela denna partners inverkan',
  partner_invite_more_causes: 'Bjud in denna partner att stötta fler ändamål',
  partner_review_preview_title: 'Granska & Förhandsvisa',
  partner_review_ad_preview: 'Annonsförhandsvisning',
  partner_review_placement: 'Placering',
  partner_review_company: 'Företag',
  partner_review_website: 'Webbplats',
  partner_review_mission: 'Mission',
  partner_review_billing: 'Fakturering',
  partner_confirm_submit: 'Bekräfta & Skicka',
  partner_appears_key_memory_album: 'Minnealbum',
  partner_appears_key_value_archive: 'Egenskaper',
  partner_appears_key_funeral_room: 'Minnesrum',
  partner_appears_key_anniversary_calendar: 'Minnesdagskalender',
  'settings.security.title': 'Säkerhet',
  'settings.security.sessions.title': 'Där du är inloggad',
  'settings.security.sessions.device': 'Enhet',
  'settings.security.sessions.this_device': 'Denna enhet',
  'settings.security.sessions.last_active': 'Senast aktiv',
  'settings.security.sessions.created': 'Skapad',
  'settings.security.sessions.expires': 'Löper ut',
  'settings.security.sessions.ip': 'IP',
  'settings.security.sessions.logout': 'Logga ut',
  'settings.security.sessions.logout_all': 'Logga ut från alla enheter',
  'settings.security.sessions.logout_others': 'Logga ut från andra enheter',
  'security.alerts.reuse_detected.title': 'Vi avslutade din session för din säkerhet',
  'security.alerts.reuse_detected.body':
    'Vi märkte en inloggning som såg ovanlig ut. Vi loggade ut dig på alla enheter. Om det inte var du, ändra ditt lösenord.',
  'gettingStarted.title': 'Välkommen',
  'gettingStarted.subtitle': 'Börja med att söka på namnet för att hitta graven.',
  'gettingStarted.search': 'Sök',
  'gettingStarted.search.placeholder': 'Sök på namn',
  'gettingStarted.addRelation': 'Lägg till person',
  'gettingStarted.explainer':
    'Sätt din relation så får du uppdateringar, årsdagar och vänliga påminnelser.',
  partner_appears_key_groups: 'Grupper/Gemenskap',
  partner_appears_key_store: 'Butik/Webbshop',
  account_form_email_label: 'E-post',
  account_form_email_placeholder: 'Ange din e-post',
  account_form_email_required: 'Ange e-post',
  account_form_email_invalid: 'Ange en giltig e-postadress',
  account_form_userName_label: 'Namn',
  account_form_userName_placeholder: 'Ange ditt namn',
  account_form_userName_required: 'Ange ditt namn',
  account_form_userName_invalid: 'Namnet måste innehålla minst en bokstav',
  account_form_gender_label: 'Kön',
  account_form_gender_placeholder: 'Välj kön',
  account_form_gender_required: 'Välj kön',
  account_form_gender_option_male: 'Man',
  account_form_gender_option_female: 'Kvinna',
  account_form_gender_option_other: 'Annat',
  account_form_password_label: 'Lösenord',
  account_form_password_placeholder: 'Ange ditt lösenord',
  account_form_password_required: 'Ange lösenord',
  account_form_password_min: 'Använd minst 8 tecken.',
  account_form_password_max: 'Använd högst 128 tecken.',
  account_form_confirmPassword_label: 'Bekräfta lösenord',
  account_form_confirmPassword_placeholder: 'Bekräfta ditt lösenord',
  account_form_confirmPassword_required: 'Bekräfta ditt lösenord',
  account_form_confirmPassword_match: 'Lösenorden matchar inte',
  not_authorized: 'Du är inte auktoriserad',
  account_form_country_label: 'Land',
  account_form_country_placeholder: 'Välj land',
  account_form_country_required: 'Välj ditt land',
  account_form_dateOfBirth_label: 'Födelsedatum',
  account_form_dateOfBirth_placeholder: 'Välj datum',
  account_form_dateOfBirth_required: 'Välj ditt födelsedatum',
  account_form_dateOfBirth_underage: 'Tillgängligt från 13 år.',
  account_form_language_label: 'Språk',
  account_form_language_placeholder: 'Välj språk',
  account_form_language_required: 'Välj önskat språk',
  language_english: 'Engelska',
  language_norwegian: 'Norska',
  language_danish: 'Danska',
  language_swedish: 'Svenska',
  language_finnish: 'Finska',
  account_form_checked_label: 'Jag godkänner {termsLink}',
  account_form_checked_required: 'Godkänn för att fortsätta.',
  account_form_creating_account: 'Skapar konto...',
  account_form_submit: 'Skapa konto',
  registration_too_many_attempts:
    'För många registreringsförsök. Vänta en stund innan du försöker igen.',
  registration_failed: 'Vi kunde inte skapa kontot. Försök igen.',
  grave_tab: 'Sök',
  home_welcome: 'Ta graven till molnet med natgrav.se.',
  home_subheading: 'Tillgänglig och nära i ditt liv. Sök på namn för att komma igång.',
  home_create_account: 'Skapa konto',
  home_login: 'Logga in',
  home_terms: 'Genom att fortsätta godkänner du våra',
  footer_copyright: '© 2013–2026 Natgrav.se.',
  footer_built_by: 'The End Of Time Corporation',
  footer_teotc_name: 'Nätgrav utvecklas och drivs av The End of Time Corporation (TEOTC).',
  footer_intro_eyebrow: 'Nätgrav — där kärleken aldrig tar slut.',
  footer_intro_body: 'Produkter och tjänster från ett perspektiv — det som består genom all tid.',
  footer_col_nettgrav: 'Nätgrav',
  footer_col_explore: 'Utforska',
  footer_col_teotc: 'End of Time',
  footer_col_contact: 'Kontakt',
  footer_find_grave: 'Hitta en grav',
  footer_graves: 'Sök bland alla gravar',
  footer_about: 'Om Nätgrav',
  footer_create_spark: 'Skapa Gnista',
  footer_my_light: 'Mitt ljus',
  footer_rooms: 'Rum',
  footer_partner: 'Partner',
  footer_how_it_works: 'Så fungerar Nätgrav',
  footer_create_nettgrav: 'Skapa en Nätgrav',
  footer_about_teotc: 'Om TEOTC',
  footer_nettarv: 'Nettarv',
  footer_matvarebutikken: 'Matvarebutikken',
  footer_become_partner: 'Bli partner',
  footer_privacy: 'Integritet',
  footer_terms: 'Villkor',
  footer_cookies: 'Cookies',
  footer_end_of_time_center: 'The End of Time Center',
  footer_end_of_time_chat: 'End Of Time Chat',
  my_light_info_title: 'Mitt ljus',
  my_light_info_intro: 'En plats för det som betyder mest för dig, i din egen takt.',
  my_light_info_body_1: 'Mitt ljus är din livssida i Nätgrav.',
  my_light_info_body_2:
    'Här knyter du dig till människor du bryr dig om, bygger relationer över tid — och kan göra det viktigaste tydligt.',
  my_light_info_body_3: 'Det handlar inte om att dela mest.',
  my_light_info_body_4: 'Det handlar om att vara närvarande.',
  my_light_info_section_what_you_can_do_title: 'Vad du kan göra i Mitt ljus',
  my_light_info_body_5: 'Du kan:',
  my_light_info_body_6: 'stärka relationerna till människorna du bryr dig om',
  my_light_info_body_7: 'dela ord och närvaro som gör gott',
  my_light_info_body_8: '• säga goda ord till varandra — medan vi lever',
  my_light_info_body_9: 'välja Månar — de närmaste du litar på',
  my_light_info_body_10:
    'sätta riktning med Min kompass och göra det viktigaste tydligt i Efter mig',
  my_light_info_body_11: 'Mitt ljus rymmer både livet nu — och riktningen framåt.',
  my_light_info_section_not_title: 'Vad detta inte är',
  my_light_info_body_12:
    'Mitt ljus är inte ett socialt nätverk. Det handlar inte om tempo, uppmärksamhet eller tillväxt.',
  my_light_info_body_13: 'Här kan det viktigaste delas med ro, närhet och omtanke.',
  my_light_info_section_why_title: 'Varför finns det?',
  my_light_info_body_14: 'För att människor behöver varandra.',
  my_light_info_body_15: 'Och för att det är gott att säga det som betyder något — medan vi lever.',
  my_light_info_cta: 'Gå till Mitt ljus',
  'my_light_guest_preview.eyebrow': 'För dig som är gäst',
  'my_light_guest_preview.supporting': 'Här ser du vad Mitt ljus innehåller.',
  'my_light_guest_preview.primary_cta': 'Logga in till Mitt ljus',
  'my_light_guest_preview.secondary_cta': 'Skapa konto',
  'my_light_guest_preview.panel_label': 'Det här innehåller Mitt ljus',
  'my_light_guest_preview.modules_title': 'Så ser Mitt ljus ut',
  'my_light_guest_preview.modules_intro': 'Det här är områdena du möter i Mitt ljus.',
  'my_light_guest_preview.card_about_title': 'Om mig',
  'my_light_guest_preview.card_about_body':
    'En kort introduktion, några rader om vem du är, och tre frågor som fångar livet så som det känns nu.',
  'my_light_guest_preview.card_relations_title': 'De nära omkring dig',
  'my_light_guest_preview.card_relations_body':
    'Här ser du de närmaste runt dig, och vem som har en särskild roll när något betyder mest.',
  'my_light_guest_preview.card_compass_title': 'Min kompass',
  'my_light_guest_preview.card_compass_body':
    'Här kan du sätta ord på vad som håller dig på kurs, vad som betyder mest och vad andra bör förstå om dig.',
  'my_light_guest_preview.card_moons_title': 'Månar',
  'my_light_guest_preview.card_moons_body':
    'Månar är de nära runt dig som påverkar ditt liv med närhet, riktning och trygghet.',
  'my_light_guest_preview.card_after_me_title': 'Efter mig',
  'my_light_guest_preview.card_after_me_body':
    'Efter mig är platsen där du gör det viktigaste tydligt för dem du älskar.',
  'my_light_guest_preview.footer_title': 'En personlig plats för relation och ansvar',
  'my_light_guest_preview.sample_name': 'Exempelprofil',
  'my_light_guest_preview.sample_role': 'Lärare och förälder',
  'my_light_guest_preview.sample_bio':
    'Jag försöker ge plats åt ärliga samtal, lugna morgnar och människorna jag behöver hålla mig nära.',
  'my_light_guest_preview.answer_1': 'Att värna tiden med människorna jag älskar.',
  'my_light_guest_preview.answer_2': 'Promenader, stillhet och ett sant samtal.',
  'my_light_guest_preview.connection_name_1': 'Anna Berg',
  'my_light_guest_preview.connection_role_1': 'Syster',
  'my_light_guest_preview.connection_name_2': 'Isak Berg',
  'my_light_guest_preview.connection_role_2': 'Familjevän',
  'my_light_guest_preview.compass_value_1':
    'Jag vill inte förlora kontakten med det som betyder mest.',
  'my_light_guest_preview.compass_value_2': 'Skapar detta mer sanning, eller bara mindre obehag?',
  'my_light_guest_preview.moon_name_1': 'Liv',
  'my_light_guest_preview.moon_role_1': 'Nära vän',
  'my_light_guest_preview.moon_name_2': 'Maren',
  'my_light_guest_preview.moon_role_2': 'Dotter',
  'my_light_guest_preview.moon_status': 'Måne',
  'my_light_guest_preview.after_me_status': 'Tydligt',
  'my_light_guest_preview.after_me_updated': 'Uppdaterad nyligen',
  'my_light_guest_preview.after_me_message':
    'Om något händer, låt det få vara enkelt, varmt och utan gissningar.',
  end_of_time_center_title: 'The End of Time Center',
  end_of_time_center_intro: 'Ett arbete som börjar där livet tar slut.',
  end_of_time_center_body_1: 'En grav finns för att en människa har dött.',
  end_of_time_center_body_2:
    'Vi söker förståelse för varför liv tar slut, och hur kunskap, insikt och forskning kan bidra till att färre liv gör det i framtiden.\nInte genom löften, utan genom långsiktigt arbete.',
  end_of_time_center_section_1_title: 'Från förlust till handling',
  end_of_time_center_section_1_body_1:
    'De flesta stannar vid döden.\nThe End of Time Center börjar där.',
  end_of_time_center_section_1_body_2:
    'När en människa dör uppstår frågor som inte kan besvaras av minnen ensamma. Här samlas forskning, reflektion och utveckling för att förstå livets sårbarhet och tidens roll i sjukdom, åldrande och död.',
  end_of_time_center_section_1_body_3: 'Detta är inte ett minnesarbete.\nDet är ett ansvar.',
  end_of_time_center_section_2_title: 'Graven som bro',
  end_of_time_center_section_2_body_1:
    'Genom Nätgrav blir graven mer än en plats för stillhet.\nDen blir en bro mellan det som har varit – och det som kan bli.',
  end_of_time_center_section_2_body_2:
    'Handlingar knutna till graven – ljus, cirklar och närvaro – är förankrade i The End of Time Center. På så sätt får graven en riktning vidare, mot förståelse, sammanhang och forskning om livets gränser.\nDetta arbete kallas End of Time Care.',
  end_of_time_center_section_3_title: 'Ett långsiktigt arbete',
  end_of_time_center_section_3_body_1:
    'The End of Time Center är ett långsiktigt initiativ under The End Of Time Corporation. Arbetet är förankrat i Norge och utvecklas med respekt för livets komplexitet och människans behov av mening.',
  end_of_time_center_section_3_body_2:
    'Detta är inte ett projekt som ska skalas snabbt.\nDet är ett arbete som ska bestå över tid.',
  end_of_time_center_section_4_title: 'Därför finns The End of Time Center',
  end_of_time_center_section_4_body_1:
    'För att ett liv tog slut.\nDet blev till en grav.\nOch för att det förpliktar.',
  end_of_time_chat_title: 'End Of Time Chat',
  end_of_time_chat_intro: 'Samtal som tål stillhet',
  end_of_time_chat_beta_label: 'Beta-version',
  end_of_time_chat_beta_short:
    'Det grundläggande krypteringsskyddet är aktivt. Eftersom detta är en beta kan funktioner och delar av gränssnittet ändras.',
  end_of_time_chat_open_beta: 'Öppna beta-chatten',
  end_of_time_chat_explore_security: 'Så skyddas dina samtal',
  end_of_time_chat_security_eyebrow: 'Privat från början',
  end_of_time_chat_security_summary_title: 'Skyddsstatus',
  end_of_time_chat_security_active: 'Aktiv',
  end_of_time_chat_security_note:
    'Dina samtal skyddas med kryptering och andra säkerhetsåtgärder, men ingen digital tjänst kan garantera fullständig säkerhet.',
  end_of_time_chat_beta_title: 'Redo att användas, förbättras fortfarande',
  end_of_time_chat_beta_body:
    'End of Time Chat är nu tillgängligt som beta. Du kan stöta på ofärdiga detaljer medan vi förbättrar stabilitet, samtal, synkronisering och helhetsupplevelsen.',
  end_of_time_chat_beta_point_1:
    'Funktioner och detaljer i gränssnittet kan ändras under beta-perioden.',
  end_of_time_chat_beta_point_2:
    'Tillfälliga problem med synkronisering eller samtalsanslutning kan förekomma.',
  end_of_time_chat_beta_point_3:
    'Använd inte en beta-tjänst för nödsituationer eller tidskritisk kommunikation.',
  end_of_time_chat_security_title: 'Byggt för att skydda samtalet',
  end_of_time_chat_security_intro:
    'Kryptering är inte ett valfritt tillägg. Det är en del av hur meddelanden, grupper och samtal utformas från början.',
  end_of_time_chat_e2ee_title: 'Totalsträckskryptering',
  end_of_time_chat_e2ee_body:
    'Samtalets innehåll krypteras på deltagarnas enheter. Nätgrav transporterar krypterade data i stället för en läsbar kopia av ditt samtal.',
  end_of_time_chat_pq_title: 'Hybrid postkvantsskydd',
  end_of_time_chat_pq_body:
    'Hybrid X-Wing-nyckeletablering kombinerar etablerad kryptografi med postkvantsskydd. Det bidrar till att minska risken för att krypterad trafik lagras i dag och dekrypteras av framtida kvantdatorer.',
  end_of_time_chat_mls_title: 'Säker rotation av gruppnycklar',
  end_of_time_chat_mls_body:
    'Messaging Layer Security uppdaterar grupphemligheter när medlemskap och samtalstillstånd ändras och hjälper till att begränsa effekten av en komprometterad nyckel över tid.',
  end_of_time_chat_cta_title: 'Ett tryggare rum för samtal som betyder något',
  end_of_time_chat_cta_body:
    'Använd betan, berätta vad som inte fungerar som förväntat och hjälp oss att göra privat kommunikation mer tillförlitlig.',
  end_of_time_chat_feedback: 'Rapportera ett beta-problem',
  end_of_time_chat_body_1: 'Kommer snart',
  end_of_time_chat_body_2:
    'Vissa samtal är för sårbara för det öppna. Andra är för sanna för att försvinna.',
  end_of_time_chat_body_3:
    'End of Time Chat är skapat för människor som vill ha ett tryggt rum för nära samtal – där relationer kan leva vidare med ärlighet, ömhet och tid.',
  end_of_time_chat_section_1_title: 'Ett rum, inte ett flöde',
  end_of_time_chat_section_1_body_1:
    'Det här är inte en social plattform.\nDet är inte en plats för synlighet, tempo eller prestation.',
  end_of_time_chat_section_1_body_2:
    'End of Time Chat är ett slutet rum mellan människor som har valt varandra.\nSamtalen får vara det de är – utan publik.',
  end_of_time_chat_section_2_title: 'Byggt för trygghet',
  end_of_time_chat_section_2_body_1:
    'Samtalen är end-to-end-krypterade och byggda med säkerhet som grundprincip. Det som delas stannar mellan dem det tillhör.',
  end_of_time_chat_section_2_body_2: 'Tekniken finns av en anledning:\nAtt skydda det mänskliga.',
  end_of_time_chat_section_3_title: 'Varför End Of Time Chat finns',
  end_of_time_chat_section_3_body_1:
    'För att relationer inte slutar när livet blir svårt.\nFör att närhet behöver rum som inte utnyttjar sårbarhet.\nFör att vissa ord bara kan delas när det är tryggt att göra det.',
  end_of_time_chat_section_3_body_2:
    'End of Time Chat är också skapat för samtalen man vill ta medan man lever.\nFör att kunna säga det man tror på.\nFör att visa vad som är viktigt.\nFör att vara den som säger jag älskar dig först.',
  end_of_time_chat_section_3_body_3:
    'Det finns styrka i att vara äkta.\nÄven när det inte möts.\nÄven när det gör en sårbar.',
  end_of_time_chat_section_4_title: 'En del av Nätgrav',
  end_of_time_chat_section_4_body_1:
    'End of Time Chat är utvecklat som en del av Nätgrav.\nEn plats för liv, relationer och närvaro – också efter förlust.',
  end_of_time_chat_section_5_title: 'En grundprincip',
  end_of_time_chat_section_5_body_1:
    'End of Time Chat är inte en produkt.\nDet är ett rum som skyddar relationer.',
  about_nettgrav_title: 'Om Nätgrav',
  about_nettgrav_intro:
    'Nätgrav är skapat för närhet både till dem som är begravda och till dem som lever vidare.',
  about_nettgrav_body_1:
    'När döden inträffar uppstår det ofta behov som en fysisk grav ensam inte kan rymma. Nätgrav gör det möjligt att vara närvarande också på nätet – över tid, avstånd och livssituationer.',
  about_nettgrav_body_2:
    'En grav är mer än en plats. Den rymmer en människa, ett levt liv och relationerna omkring. Nätgrav är skapat för att ge detta rum värdighet och varaktighet.',
  about_nettgrav_body_3:
    'Nätgrav existerar oberoende av den fysiska graven. Även om en grav ändras, flyttas eller återanvänds, består den digitala platsen som ett varaktigt rum för närhet och minnen.',
  about_nettgrav_body_4:
    'Tjänsten är utvecklad i Norge med fokus på varaktighet, respekt och mänsklig närhet. Nätgrav stöds av offentliga innovationsmedel genom Innovation Norway, och är till stor del byggd med stöd från familj och vänner.',
  about_nettgrav_body_5:
    'Bakom Nätgrav står samma människor som The End Of Time Corporation – ett norskt, långsiktigt arbete för att skapa tjänster som möter döden, tiden och människans behov av mening och sammanhang.',
  create_spark_title: 'Skapa Gnista',
  create_spark_intro: 'Ett rum för det som är sant för dig',
  create_spark_body_1: 'Att stå för det man tror på kan vara en känslomässig resa.',
  create_spark_body_2:
    'Skapa Gnista ger utrymme att sätta ord på det som är sant för dig – medan du lever.',
  create_spark_body_3: 'En gnista kan vara en tanke, ett värde, en undran eller en reflektion.',
  create_spark_body_4: 'Något du vill uttrycka, utan krav på facit eller respons.',
  create_spark_body_5:
    'Att skapa en gnista handlar inte om att övertyga andra, utan om att vara ärlig i mötet med sig själv och världen omkring.',
  create_spark_body_6: 'I Nätgrav finns både liv och minnen.',
  create_spark_body_7: 'Gravarna rymmer historien. Gnistor rymmer det som lever nu.',
  partner_title: 'Partner',
  partner_intro:
    'Nätgrav samarbetar med partner som vill bidra till goda liv för människor och familjer som använder Nätgrav.',
  partner_body_1:
    'Samarbete på Nätgrav handlar om att stödja människor i livets viktiga ögonblick – med närhet, omsorg och långsiktighet. Tillsammans vill vi stärka emotionell och psykisk robusthet, och val som bär mening över tid.',
  partner_body_2:
    'För organisationer och varumärken som vill bygga samhälle genom delning och generositet finns vårt partnerprogram i samarbete med End of Time – ett nätverk som investerar resurser där de behövs.',
  partner_cta: 'Bli partner',
  how_it_works_title: 'Så fungerar Nätgrav',
  how_it_works_intro:
    'Nätgrav är en plats för närhet till dina människor och det som betyder något.',
  how_it_works_lead_1:
    'En plats som finns vid sidan av den fysiska graven – och som består över tid.',
  how_it_works_lead_2: 'Den här sidan förklarar hur Nätgrav fungerar och vad du kan förvänta dig.',
  create_nettgrav_title: 'Skapa en Nätgrav',
  create_nettgrav_intro: 'En Nätgrav kan skapas när det behövs.',
  create_nettgrav_body_1:
    'För att skapa en Nätgrav anger du namnet på den som är begravd och väljer kommun och kyrkogård om detta är känt.',
  create_nettgrav_body_2: 'Nätgrav är inte beroende av den fysiska graven.',
  create_nettgrav_body_3: 'Den begravda är vår utgångspunkt – inte platsen.',
  create_nettgrav_section_create_title: 'Skapa grav på nätet',
  create_nettgrav_section_missing_title: 'När kommun eller kyrkogård saknas',
  create_nettgrav_missing_body_1:
    'Nätgrav kommer över tid inte att fokusera på att registrera alla kommuner och kyrkogårdar.',
  create_nettgrav_missing_body_2: 'Om kommunen eller kyrkogården inte finns i listan väljer du:',
  create_nettgrav_missing_body_3: 'Nätgrav som kommun',
  create_nettgrav_missing_body_4: 'End Of Time Cemetery som kyrkogård',
  create_nettgrav_missing_body_5: 'Då skapas Nätgraven utan kostnad.',
  create_nettgrav_missing_body_6:
    'Denna Nätgrav fungerar på samma sätt som alla andra och ger en varaktig digital plats för närhet, minnen och relationer.',
  create_nettgrav_section_place_title: 'Digital grav skapande – en plats som består',
  create_nettgrav_place_body_1: 'Nätgrav bygger på en enkel tanke:',
  create_nettgrav_place_body_2: 'Den begravda är någon annanstans än den fysiska graven.',
  create_nettgrav_place_body_3:
    'Därför är Nätgrav gjort för dem som lever vidare – familj, vänner och nära – och för förbindelsen som består över tid.',
  create_nettgrav_place_body_4:
    'End Of Time Cemetery är Nätgravs egen kyrkogård, skapad för att rymma Nätgravar oberoende av fysisk plats och menad att bestå över tid.',
  create_nettgrav_section_login_title: 'Logga in och skapa en ny Nätgrav',
  create_nettgrav_login_body_1: 'Logga in och skapa en ny Nätgrav',
  create_nettgrav_login_cta: 'Logga in och skapa en ny Nätgrav',
  how_it_works_section_1_title: 'En plats vid sidan av den fysiska graven',
  how_it_works_section_1_body_1: 'Den fysiska graven är en plats man kan besöka.',
  how_it_works_section_1_body_2:
    'Nätgrav gör det möjligt att vara närvarande även på nätet, när avstånd, tid eller livssituation gör det svårt att komma dit.',
  how_it_works_section_1_body_3: 'Nätgrav är oberoende av den fysiska gravens varaktighet.',
  how_it_works_section_1_body_4:
    'Även om en grav ändras, flyttas eller återanvänds består Nätgraven som en varaktig plats för tillhörighet.',
  how_it_works_section_2_title: 'Hitta eller besök en grav',
  how_it_works_section_2_body_1: 'På Nätgrav kan du:',
  how_it_works_section_2_body_2: 'hitta befintliga gravar',
  how_it_works_section_2_body_3: 'skapa en ny Nätgrav',
  how_it_works_section_2_body_4: 'besöka en grav online',
  how_it_works_section_2_body_5: 'knyta din relation till den som är begravd',
  how_it_works_section_2_body_6:
    'lära känna människan graven representerar. Du behöver inte göra något särskilt. Det går att bara vara där – stilla och utan krav.',
  how_it_works_section_3_title: 'Små handlingar som betyder något',
  how_it_works_section_3_body_1: 'Nätgrav är byggt kring enkla handlingar:',
  how_it_works_section_3_body_2: 'skicka en gåva',
  how_it_works_section_3_body_3: 'dela några ord',
  how_it_works_section_3_body_4: 'lägga till en bild eller ett minne',
  how_it_works_section_3_body_5: 'markera årsdagar',
  how_it_works_section_3_body_6: 'Allt är frivilligt och kan göras när det känns rätt.',
  how_it_works_section_3_body_7: 'Inga förväntningar. Inga tidsfrister.',
  how_it_works_section_4_title: 'Familj och nära',
  how_it_works_section_4_body_1: 'Nätgrav kan delas med familj och människor som hör till.',
  how_it_works_section_4_body_2: 'Du väljer själv:',
  how_it_works_section_4_body_3: 'vem som har tillgång',
  how_it_works_section_4_body_4: 'vad som delas',
  how_it_works_section_4_body_5: 'hur graven förvaltas över tid',
  how_it_works_section_4_body_6: 'Så kan fler vara närvarande – på egna villkor.',
  how_it_works_section_5_title: 'Integritet och trygghet',
  how_it_works_section_5_body_1: 'Nätgrav är skapat för känslomässig och mänsklig trygghet.',
  how_it_works_section_5_body_2: 'Innehåll kan vara:',
  how_it_works_section_5_body_3: 'privat',
  how_it_works_section_5_body_4: 'synligt för inbjudna',
  how_it_works_section_5_body_5: 'öppet för alla som besöker graven',
  how_it_works_section_5_body_6: 'Du har kontroll och kan ändra detta när det känns rätt.',
  how_it_works_section_6_title: 'Skapa Gnista – liv som lever nu',
  how_it_works_section_6_body_1: 'Utöver Nätgrav finns Skapa Gnista.',
  how_it_works_section_6_body_2:
    'Skapa Gnista är ett rum för reflektion, tankar och det som är sant för dig – medan du lever.',
  how_it_works_section_6_body_3: 'Här kan ord delas som uttryck för liv, mening och sammanhang.',
  how_it_works_section_6_body_4: 'Gravarna rymmer historien.',
  how_it_works_section_6_body_5: 'Gnistor rymmer det som lever nu.',
  how_it_works_section_7_title: 'En plats gjord för att vara varaktig',
  how_it_works_section_7_body_1: 'Nätgrav är byggt med tiden i åtanke.',
  how_it_works_section_7_body_2:
    'Det är en plats som inte försvinner och som inte kräver underhåll.',
  how_it_works_section_7_body_3: 'Ett varaktigt rum för närhet till livet.',
  how_it_works_section_7_body_4: 'Du kan komma tillbaka när du vill.',
  how_it_works_section_7_body_5: 'Det räcker att vara där.',
  orbit_section_header: 'Jordens position',
  orbit_intro_text:
    'Vi reser alla tillsammans på denna stora resa runt solen. Du är aldrig ensam här.',
  orbit_day_progress: 'Dag {day} av 365',
  orbit_position_label: 'Jordens position: {position}°',
  page_not_found: 'Sidan finns inte.',
  grave_load_server_error: 'Något gick fel på servern. Ladda om sidan och försök igen.',
  grave_load_failed: 'Vi kunde inte hämta gravplatsen. Försök igen.',
  grave_user_load_failed: 'Vi kunde inte hämta användarinformationen. Försök igen.',
  grave_static_data_load_failed: 'Vi kunde inte hämta nödvändig information. Försök igen.',
  see_more: 'se mer',
  filter_button: 'Filtrera gravar',
  search_event: 'Sök händelse, datum',
  add_new: 'Lägg till ny',
  search_tab_all: 'Alla',
  search_tab_graves: 'Gravar',
  search_tab_members: 'Människor',
  search_people_none_text: 'Inga medlemmar hittades för',
  user_age: 'Ålder:',
  user_shared_grave: 'delad grav',
  user_shared_graves: 'delade gravar',
  view_life_page: 'Visa Livssidan',
  see_my_light: 'Se Mitt Ljus',
  see_user_light: 'Se {name}s Ljus',
  relation_to: 'till',
  user_values_heading:
    'Här kan de som är knutna till dig uttrycka hur de upplever dig. Du kan också besöka en person och göra gott för dem.',
  add_user_values: 'Säg något du ser',
  user_values_modal_title: 'Vad ser du i {name}?',
  user_values_modal_subtitle:
    'To let someone know that you value and see their inner being is truly valuable. The value given and received is unending.',
  user_values_select_category: 'Select category',
  user_values_select_value: 'Välj ett ord som du känner igen.',
  user_values_save: 'Save',
  user_values_note_placeholder: 'Lägg till en anteckning',
  family_tree_page_title: 'Släktträd',
  family_tree_set_relationships: 'Ange relationer',
  family_tree_set_relationship: 'Ange relation',
  family_tree_choose_my_relation: 'Välj min relation',
  family_tree_people_you_might_know: 'Personer du kanske känner',
  family_tree_no_suggestions: 'Inga förslag ännu',
  family_tree_relations_in_tree: 'Relationer i trädet',
  family_tree_relations_radius_hint:
    'Visar relationer som finns med i trädet inom {count} generationer.',
  family_tree_focus_in_tree: 'Fokusera i trädet',
  family_tree_group_parents: 'Föräldrar',
  family_tree_group_partners: 'Partner',
  family_tree_group_siblings: 'Syskon',
  family_tree_group_children: 'Barn och efterkommande',
  family_tree_group_grandparents_list: 'Mor- och farföräldrar samt äldre släktled',
  family_tree_group_extended_family: 'Andra i familjen',
  family_tree_open_relation: 'Öppna',
  family_tree_open_grave: 'Gå till grav',
  family_tree_open_light: 'Gå till ljus',
  family_tree_suggestion_likely_relation: 'Kan vara din {relation}',
  family_tree_suggestion_via: 'Via {name}',
  family_tree_your_relations: 'Dina relationer',
  family_tree_empty_title: 'Ditt släktträd börjar växa här.',
  family_tree_empty_description:
    'Du kan redan sätta relationer till de begravda och se banden ta form. Detta är en tidig version – fler grenar och funktioner kommer snart.',
  family_tree_card_title: 'Ditt släktträd',
  family_tree_card_members: '{count} medlemmar',
  family_tree_card_description: 'Du och dina två söner är här',
  family_tree_view_tree: 'Visa släktträd',
  family_tree_empty_state:
    'Dina relationer visas här. Börja med att knyta en relation till en grav eller en person.',
  family_tree_no_relations: 'Inga relationer ännu',
  family_tree_connect_relation: 'Anslut relation',
  family_tree_load_more: 'Ladda mer',
  family_tree_no_info: 'Ingen information',
  family_tree_single_node_hint:
    'Släktträdet växer när du kopplar relationer till gravar och personer, till exempel föräldrar eller barn.',
  family_tree_relation_kind_blood: 'Blodsband',
  family_tree_relation_kind_spouse: 'Make/maka',
  family_tree_relation_kind_in_law: 'Ingifta',
  family_tree_relation_kind_step: 'Styvfamilj',
  family_tree_relation_kind_other: 'Annat',
  family_tree_relation_confidence_explicit: 'Uttrycklig',
  family_tree_spouses_label: 'Makar',
  family_tree_sources_label: 'Källor',
  family_tree_no_root: 'Välj en person för att se relationerna.',
  family_tree_error: 'Vi kunde inte ladda släktträdet. Försök igen.',
  family_tree_self_label: 'Fokusperson',
  family_tree_no_self: 'Ingen fokusperson',
  family_tree_group_descendants: 'Ättlingar',
  family_tree_group_in_laws: 'Ingifta',
  family_tree_group_empty: 'Inget att visa än.',
  family_tree_meta_summary: '{count} personer • radie {radius}',
  still_alive: 'fortfarande i livet',
  family_tree_modal_title: 'Välj din relation till {name}',
  family_tree_modal_suggestion_title: 'Välj din relation till {name}',
  family_tree_modal_claim_title: 'Omsorgsansvar för graven',
  family_tree_modal_add_mother_title: 'Lägg till din mamma',
  family_tree_modal_add_father_title: 'Lägg till din pappa',
  family_tree_role_mother: 'mamma',
  family_tree_role_father: 'pappa',
  family_tree_role_person: 'person',
  family_tree_modal_tab_relation: 'Relation',
  family_tree_modal_tab_care: 'Bli vårdnadshavare',
  family_tree_modal_select_grave_label: 'Skriv och välj grav-/livssida',
  family_tree_modal_select_grave_placeholder: 'Skriv och välj ett namn',
  family_tree_modal_search_person_label: 'Sök och välj person',
  family_tree_modal_search_person_placeholder: 'Sök efter din {role}',
  family_tree_modal_search_person_hint: 'Skriv minst 2 bokstäver för att söka på namn.',
  family_tree_modal_locked_relation_label: 'Relation',
  family_tree_modal_locked_relation_value: 'Registreras som: {relation}',
  family_tree_modal_invite_person:
    'Inga träffar än. Prova fullständigt namn eller en annan stavning.',
  family_tree_modal_relation_to_person_label: 'Din relation till {name}',
  family_tree_modal_relation_to_you_label: 'Vilken relation har denna person till dig?',
  family_tree_modal_relation_to_you_with_name_label: 'Vilken relation har {name} till dig?',
  family_tree_connect_relations_modal_title: 'Koppla relationer',
  family_tree_connect_relations_modal_subtitle: 'Lätt att koppla olika släktingar till varandra',
  family_tree_connect_relations_first_label: 'Välj en släkting',
  family_tree_connect_relations_second_label: 'Välj släktingen du vill koppla till den ovan',
  family_tree_connect_relations_third_label: 'Välj {from}s relation till {to}',
  family_tree_connect_relations_third_label_default:
    'Välj första personens relation till den andra',
  family_tree_connect_relations_fourth_label: 'Vad är {to}s relation till {from}',
  family_tree_connect_relations_fourth_label_default:
    'Vad är den andra personens relation till den första',
  family_tree_tab: 'Släktträd',
  waiting_for_approval: 'Väntar på godkännande',
  family_tree_tree_tab: 'Träd',
  family_tree_no_grave_selected: 'Välj en person för att starta familjeträdet.',
  family_tree_me_label: 'Jag',
  family_tree_you_label: 'Du',
  family_tree_you_are_relation: 'Du är {relation}',
  family_tree_additional_connections: '+{count} fler',
  family_tree_connected_relatives: 'Anslutna släktingar',
  family_tree_modal_reciprocal_label: '{name}s relation till dig',
  family_tree_modal_more_relations: 'Fler val',
  family_tree_modal_confirm_relation: 'Bekräfta relationen',
  family_tree_modal_confirm_care: 'Bekräfta omsorgsansvar',
  family_tree_modal_relation_search_placeholder: 'Sök relationer',
  family_tree_modal_relation_search_no_results: 'Inga matchande relationer',
  family_tree_depth: 'Djup',
  family_tree_radius_label: 'Generationer',
  family_tree_radius_help: 'Visa fler generationer i släktträdet.',
  family_tree_radius_decrease: 'Visa färre generationer',
  family_tree_radius_increase: 'Visa fler generationer',
  family_tree_zoom_label: 'Zoom',
  family_tree_zoom_in: 'Zooma in',
  family_tree_zoom_out: 'Zooma ut',
  family_tree_fit_view: 'Anpassa hela trädet',
  family_tree_center_viewer: 'Centrera på mig',
  family_tree_toggle_panel: 'Panel',
  family_tree_children: 'Barn',
  family_tree_partners: 'Partners',
  family_tree_siblings: 'Syskon',
  family_tree_relation_of_user: '{relation} till {name}',
  family_tree_deceased_relation_to_user: '{deceased} är {relation} till {name}',
  family_tree_unknown_person: 'Den här personen',
  family_tree_senses_title: 'Sinnen',
  family_tree_add_skill: 'Lägg till talang',
  family_tree_talent_name_placeholder: 'Talang, gåva eller förmåga',
  family_tree_talent_note_placeholder: 'Valfri anteckning (hur detta visar sig i livet)',
  family_tree_no_skills: 'Inga talanger tillagda ännu',
  family_tree_cycles_broken_title: 'Mönster som bröts',
  family_tree_add_cycle_broken: 'Lägg till förändring',
  family_tree_cycle_name_placeholder:
    'Mönster som bröts, eller något som fördes vidare på ett annat sätt',
  family_tree_cycle_note_placeholder: 'Vad gjorde den här förändringen möjlig?',
  family_tree_no_cycles_broken: 'Inga förändringar tillagda ännu',
  family_tree_shared_lineage_title: 'Mönster i familjen',
  family_tree_shared_lineage_intro: 'Vissa saker går igen genom generationer.',
  family_tree_no_shared_lineage: 'Här kan sådana mönster bli synliga med tiden.',
  family_tree_trait_signal_personal_memory: 'Personligt minne',
  family_tree_trait_signal_possible_family_pattern: 'Möjligt familjemönster',
  family_tree_trait_signal_family_confirmed: 'Familjebekräftat',
  family_tree_trait_signal_personal_transformation: 'Personlig förändring',
  family_tree_trait_signal_possible_family_transformation: 'Möjlig familjeförändring',
  family_tree_trait_signal_family_confirmed_transformation: 'Familjebekräftad förändring',
  family_tree_group_cycles: 'Förändringar',
  family_tree_find_and_add: 'Hitta och lägg till',
  family_tree_done: 'Klar',
  family_tree_search_loading: 'Laddar...',
  family_tree_search_no_matches: 'Inga träffar. Du kan fortfarande lägga till manuellt nedan.',
  family_tree_unified_search_placeholder: 'Sök bland sinnen, talanger och förändringar...',
  family_tree_suggested_senses: 'Föreslagna sinnen',
  family_tree_suggested_talents: 'Föreslagna talanger',
  family_tree_suggested_cycles: 'Föreslagna förändringar',
  family_tree_origin_personal: 'Personlig',
  family_tree_origin_possible_family_pattern: 'Möjligt familjemönster',
  family_tree_origin_family_pattern: 'Familjemönster',
  family_tree_origin_personal_change: 'Personlig förändring',
  family_tree_origin_possible_family_change: 'Möjlig familjeförändring',
  family_tree_origin_family_change: 'Familjeförändring',
  family_tree_added_by_you: 'Tillagd av dig',
  family_tree_chip_added_in_family: 'Tillagd i familjen',
  family_tree_agree: 'Känner igen',
  family_tree_agreed: 'Känner igen',
  family_tree_shared_in_lineage: 'Delad i släktlinjen',
  family_tree_kind_sense: 'Sinne',
  family_tree_kind_talent: 'Talang',
  family_tree_kind_cycle: 'Förändring',
  family_tree_lineage_type_cycle: 'Förändring',
  family_tree_lineage_type_talent: 'Talang',
  family_tree_parents_title: 'Föräldrar',
  family_tree_no_parents: 'Inga föräldrar registrerade',
  family_tree_add_mother: 'Lägg till mor',
  family_tree_add_father: 'Lägg till far',
  family_tree_detached_title: 'Kända personer utan koppling ännu',
  family_tree_detached_description:
    'Dessa personer är registrerade, men har ännu ingen familjekoppling i detta träd.',
  family_tree_close_panel: 'Stäng detaljpanelen',
  family_tree_remove_talent: 'Ta bort talang',
  family_tree_remove_change: 'Ta bort förändring',
  family_tree_add_note: 'Lägg till text',
  family_tree_edit_note: 'Redigera text',
  user_has_already_been_taken: 'Användaren är redan upptagen',
  relation_already_exists: 'Relationen finns redan',
  coin_store_categories: 'Kategorier',
  coin_store_price: 'Pris',
  coin_store_category_all: 'Alla',
  coin_store_category_flowers: 'Blommor',
  coin_store_category_plants: 'Växter',
  coin_store_category_candles: 'Ljus',
  coin_store_category_cure: 'Cure',
  coin_store_occasions: 'Tillfällen',
  coin_store_add_to_cart: 'Välj denna',
  coin_store_preview: 'Se förhandsvisning',
  coin_store_preview_frame: 'Se cirkeln',
  coin_store_preview_candle: 'Se ljuset',
  coin_store_already_subscribed: 'Redan prenumererad',
  coin_store_no_products: 'Inga produkter tillgängliga',
  coin_store_no_frames: 'Inga ramar tillgängliga',
  coin_store_no_flowers: 'Inga blommor tillgängliga',
  coin_store_no_candles: 'Inga ljus tillgängliga',
  coin_store_no_plants: 'Inga växter tillgängliga',
  coin_store_no_cure_products: 'Inga Cure-produkter tillgängliga',
  coin_store_search_placeholder: 'Sök',
  coin_store_sort_placeholder: 'Sortera',
  coin_store_sort_name: 'Namn',
  coin_store_sort_price_low: 'Pris: Lågt till högt',
  coin_store_sort_price_high: 'Pris: Högt till lågt',
  coin_store_tab_all: 'ALLA',
  coin_store_tab_physical: 'FYSISKT',
  coin_store_tab_digital: 'DIGITALT',
  coin_store_tab_gift: 'GE EN TJÄNST',
  coin_store_category_frames: 'Cirklar',
  coin_store_hero_heading: 'End Of Time Collection',
  coin_store_hero_subheading: 'Varje ljus och cirkel för närvaron tillbaka.',
  coin_store_hero_image_alt: 'store illustration',
  coin_store_hero_pill_label: 'Everlight – följer dygnsrytmen vid graven',
  coin_store_hero_note1: 'lugn animation, skonsam för ögonen',
  coin_store_hero_note2: 'designad för närvaro – inte brus',
  coin_store_filters: 'Filter',
  nav_section: 'Navigering',
  account_section: 'Konto',
  aria_menu: 'meny',
  aria_profile_menu: 'profilmeny',
  aria_notifications: 'aviseringar',
  aria_home: 'hem',
  aria_my_light: 'mitt ljus',
  aria_open_search: 'öppna sök',
  aria_close_search: 'stäng sök',
  verified: 'Verifierad',
  claimed_by_you: 'Registrerad av dig',
  claimed_explainer: 'Denna grav är verifierad och kopplad till ditt konto.',
  composer_visibility: 'Synlighet',
  composer_public: 'Offentlig',
  composer_relatives: 'Slektsringar',
  composer_private: 'Privat',
  composer_public_desc: 'alla',
  composer_relatives_desc: 'Synlig för släkt/följare',
  composer_private_desc: 'Endast för dig',
  composer_more: 'Fler val …',
  composer_fewer: 'Färre val',
  composer_caption_ph: 'Bildtext (valfritt)',
  composer_add_link_prompt: 'Klistra in en länk (URL)',
  composer_add_link: 'Lägg till länk',
  composer_add_emoji: 'Lägg till emoji',
  composer_search_emoji: 'Sök emojis',
  reply: 'Svara',
  store_products: 'Cirklar och ljus',
  store_products_subheading: 'Välj nu. Använd det från Mina val efter köpet.',
  store_intro_eyebrow: 'Närvaro på Nätgraven',
  store_intro_title: 'För någon du tänker på',
  store_intro_body: 'Här hittar du ljus och cirklar som kan ge din tanke ett personligt uttryck.',
  store_intro_candles: 'Tänd ett ljus',
  store_intro_frames: 'Välj en cirkel',
  store_intro_inventory: 'Se Mina val',
  store_frames_description:
    'En digital cirkel runt profilbilden på graven. Efter köpet väljer du vilken grav den ska användas på från Mina val.',
  store_candles_description:
    'Ett digitalt ljus som du kan tända på en grav nu eller på en minnesdag. Ett köp ger ett ljus i Mina val.',
  store_view_all: 'Se alla {category}',
  store_choose_frame: 'Välj den här cirkeln',
  store_choose_candle: 'Välj det här ljuset',
  store_preview_no_grave: 'Du kan slutföra valet nu och välja grav från Mina val efter köpet.',
  store_preview_example_grave: 'Exempel på en grav',
  store_cart_open: 'Öppna ditt val',
  store_cart_close: 'Stäng ditt val',
  store_cart_decrease: 'Minska antal',
  store_cart_increase: 'Öka antal',
  store_cart_remove: 'Ta bort från valet',
  store_cart_empty: 'Du har inte valt något ännu.',
  store_continue_checkout: 'Gå vidare',
  store_favorites_section: 'Sparat till senare',
  store_favorite_add: 'Spara till senare',
  store_favorite_remove: 'Ta bort sparad',
  coin_store_select_frame_title: 'Välj en cirkel',
  coin_store_select_frame_subtitle: 'Välj en ram du vill lägga till i ditt inventarium.',
  coin_store_select_frame_confirm: 'Välj den här?',
  frame_upload_title: 'Add New Frame',
  frame_upload_name_label: 'Name',
  frame_upload_name_placeholder: 'Frame name',
  frame_upload_name_required: 'Enter frame name',
  frame_upload_kind_label: 'Kind',
  frame_upload_kind_svg: 'SVG',
  frame_upload_kind_lottie: 'Lottie',
  frame_upload_kind_gif: 'GIF',
  frame_upload_kind_apng: 'APNG',
  frame_upload_kind_webp: 'WebP',
  frame_upload_kind_mp4: 'MP4',
  frame_upload_kind_webm: 'WebM',
  frame_upload_kind_mov: 'MOV',
  frame_upload_kind_tgs: 'TGS',
  frame_upload_viewbox_label: 'ViewBox',
  frame_upload_viewbox_placeholder: 'e.g., 0 0 100 100',
  frame_upload_viewbox_extra: "Format: 'minX minY width height'",
  frame_upload_inner_circle_label: 'Inner Circle',
  frame_upload_inner_circle_extra: 'Circle center (cx, cy) and radius (r) in viewBox units',
  frame_upload_inner_circle_cx_placeholder: 'cx',
  frame_upload_inner_circle_cy_placeholder: 'cy',
  frame_upload_inner_circle_r_placeholder: 'r',
  frame_upload_asset_file_label: 'Asset File',
  frame_upload_asset_file_button: 'Select file',
  frame_upload_asset_file_required: 'Please select at least one file.',
  frame_upload_price_label: 'Price',
  frame_upload_price_placeholder: 'Enter price',
  frame_upload_price_required: 'Enter price',
  frame_upload_description_label: 'Description',
  frame_upload_description_placeholder: 'Describe this frame',
  frame_upload_color_label: 'Färg',
  frame_upload_color_red: 'Röd',
  frame_upload_color_blue: 'Blå',
  frame_upload_color_green: 'Grön',
  frame_upload_theme_label: 'Tema',
  frame_upload_theme_light: 'Ljus',
  frame_upload_theme_dark: 'Mörk',
  frame_upload_submit: 'Upload',
  frame_upload_delete_title: 'Delete Frame',
  frame_upload_delete_content: 'Detta är permanent.',
  frame_upload_delete_ok: 'Delete',
  frame_apply: 'Använd',
  frame_buy_more: 'Välj cirkel',
  frame_available_quantity: 'Tillgänglig: x{count}',
  frame_applied_at: 'Aktiv på:',
  frame_no_graves_yet: 'Dina kopplade gravar visas här',
  frame_no_graves_active: 'Inga aktiva gravar än.',
  no_frames_available: 'Du har inga cirklar ännu. Se cirklarna du kan välja mellan.',
  frame_modal_title: 'Välj cirkel eller ladda upp bild',
  frames_store_title: 'Cirklar',
  send_gift: 'Tänd ett ljus',
  gift_message_label: 'Ord till graven',
  gift_event_context_time: 'på {event} · {time}',
  gift_message_placeholder: 'Skriv några ord, om du vill',
  no_gifts_available: 'Inga gåvor tillgängliga.',
  no_gifts_yet: 'Tänd ett ljus för {graveName}',
  candles: 'Ljus',
  choose_candle: 'Välj ljus',
  add_candle: 'Lägg till ljus',
  buy_gifts: 'Köp gåvor',
  gifts_title: 'Gåvor',
  gifts_empty_state: 'No gifts have been added yet.',
  previous_gift: 'Föregående gåva',
  next_gift: 'Nästa gåva',
  gift_update_success: 'Gift updated',
  gift_delete_success: 'Gift deleted',
  gifts_load_error: 'Unable to load gifts right now.',
  gift_update_error: 'Unable to update gift.',
  gift_delete_error: 'Unable to delete gift.',
  gift_edit_title: 'Redigera gåva',
  gift_sent: 'Gåva skickad',
  gift_send_error: 'Det gick inte att skicka gåvan',
  gift_event_by_user: '{event} av {user}',
  edit_text_description: 'Lägg till, ändra eller ta bort text',
  products_title: 'Cirklar och ljus',
  my_light_tooltip: 'Din Gnista gör världen till en bättre plats.',
  products_add_product: 'Lägg till produkt',
  products_edit_product: 'Redigera produkt',
  products_table_index: 'Nr',
  products_table_name: 'Namn',
  products_table_image_or_frame: 'Bild eller ram',
  products_table_price: 'Pris',
  products_table_description: 'Beskrivning',
  products_table_action: 'Åtgärd',
  products_action_edit: 'Redigera',
  products_action_delete: 'Ta bort',
  products_form_type_label: 'Typ',
  products_form_type_frame: 'Ram',
  products_form_type_cure: 'Skötsel',
  products_form_type_flower: 'Blomma',
  products_form_type_plant: 'Växt',
  products_form_type_candle: 'Ljus',
  products_form_cure_name_label: 'Namn',
  products_form_cure_name_placeholder: 'Produktnamn',
  products_form_cure_name_required: 'Ange produktnamn',
  products_form_cure_lengths_label: 'Längder',
  products_form_cure_lengths_placeholder: 'Ange abonnemangstider',
  products_form_cure_lengths_required: 'Ange längder',
  products_form_cure_price_label: 'Pris',
  products_form_cure_price_placeholder: 'Ange pris',
  products_form_cure_price_required: 'Ange pris',
  products_form_cure_description_label: 'Beskrivning',
  products_form_cure_description_placeholder: 'Beskriv produkten',
  products_form_cure_image_label: 'Bild',
  products_form_cure_image_required: 'Välj en bild.',
  products_form_upload_button: 'Ladda upp',
  products_form_translations_label: 'Översättningar',
  products_form_add_translation: 'Lägg till översättning',
  products_form_translations_help:
    'Lägg till valfri språkversion för att ersätta den engelska standardtexten.',
  products_form_translation_locale_label: 'Språk',
  products_form_translation_locale_required: 'Välj ett språk',
  products_form_translation_locale_placeholder: 'Välj språk',
  products_form_translation_name_label: 'Namn',
  products_form_translation_name_required: 'Ange ett namn',
  products_form_translation_name_placeholder: 'Översatt produktnamn',
  products_form_translation_description_label: 'Beskrivning',
  products_form_translation_description_placeholder: 'Översatt beskrivning (valfritt)',
  products_form_translation_remove: 'Ta bort översättning',
  products_delete_error_in_use:
    'Det går inte att ta bort produkten eftersom den fortfarande används.',
  checkout_purchase_success: 'Köpet lyckades',
  checkout_payment_failed: 'Betalningen misslyckades',
  checkout_missing_payment_method_id: 'Betalningsmetod-ID saknas',
  lighthouse_title: 'End Of Time Collection',
  lighthouse_subtitle: 'Varje ljus och cirkel för närvaron tillbaka.',
  lighthouse_description:
    'Ett orubbligt ljus vid horisonten som leder kärleken genom mörka vatten. Lugna hav, stilla styrka och en stråle som säger: du är aldrig ensam. En varsam hyllning till kustens hjärtan och till alla som förde andra tryggt hem.',
  lighthouse_go_to_store: 'Se samlingen',
  frame_info_title: 'Så här sätter du en ram',
  frame_info_description:
    '1. Gå till graven du vill ändra.\n2. Klicka på gravens profilbild.\n3. Välj en ram – den syns på graven direkt.',
  profile_and_settings: 'Profil och inställningar',
  help_and_support: 'Hjälp & stöd',
  report_problem: 'Rapportera ett problem',
  light_theme: 'Ljust tema',
  dark_theme: 'Mörkt tema',
  toggle_theme: 'Byt tema',
  toggle_theme_to_dark: 'Byt till mörkt läge',
  toggle_theme_to_light: 'Byt till ljust läge',
  partner_title: 'Partner',
  partner_become_seller: 'Bli partner (säljarkonto)',
  partner_status_pending: 'Partnerstatus: väntar på godkännande',
  partner_apply: 'Ansök om att bli partner',
  partner_open_portal: 'Öppna partnerportalen',
  partner_dashboard: 'Partnerdashboard',
  partner_create_ad: 'Skapa annons/produkt',
  partner_payouts: 'Utbetalningar',
  'designSystem.showcase.title': 'Design System',
  'designSystem.colors.title': 'Portalens färgschema',
  'designSystem.colors.silver': 'Silver',
  'designSystem.colors.gold': 'Guld',
  'designSystem.colors.roseGold': 'Roséguld',
  'designSystem.colors.bronze': 'Brons',
  'designSystem.colors.titanium': 'Titan',
  'designSystem.colors.emerald': 'Smaragd',
  'designSystem.colors.platinum': 'Platina',
  'designSystem.colors.copper': 'Koppar',
  'designSystem.colors.amethyst': 'Ametist',
  'designSystem.colors.sapphire': 'Safir',
  'designSystem.colors.ruby': 'Rubin',
  'designSystem.colors.obsidian': 'Obsidian',
  'designSystem.colors.aqua': 'Akvamarin',
  'designSystem.colors.sunset': 'Solnedgång',
  'designSystem.colors.surfaces': 'Ytfärger',
  'designSystem.colors.text': 'Textfärger',
  'designSystem.colors.metallic': 'Metalliska paletter',
  'designSystem.colors.viewMetallicIcons': 'Visa metallikon-demo',
  'designSystem.anniversaries.upcoming': 'Kommande årsdagar',
  'designSystem.anniversaries.breakdown.title': 'Kommande 7 dagar',
  'designSystem.anniversaries.grave': 'Grav',
  'designSystem.anniversaries.user': 'Användare',
  'designSystem.anniversaries.public': 'Offentliga',
  'designSystem.anniversaries.total': 'Totalt',
  'designSystem.grid.sectionTitle': 'Rutnätslayout',
  'designSystem.grid.controls.title': 'Interaktiva kontroller',
  'designSystem.grid.controls.align': 'Vertikal justering',
  'designSystem.grid.controls.justify': 'Horisontell justering',
  'designSystem.grid.controls.horizontalGutter': 'Horisontellt mellanrum (px)',
  'designSystem.grid.controls.verticalGutter': 'Vertikalt mellanrum (px)',
  'designSystem.grid.controls.wrap': 'Radbryt',
  'designSystem.grid.controls.currentProps': 'Aktiva egenskaper',
  'designSystem.grid.preview.title': 'Förhandsvisning',
  'designSystem.grid.align.top': 'Toppen',
  'designSystem.grid.align.middle': 'Mitten',
  'designSystem.grid.align.bottom': 'Botten',
  'designSystem.grid.align.stretch': 'Sträck',
  'designSystem.grid.justify.start': 'Start',
  'designSystem.grid.justify.center': 'Center',
  'designSystem.grid.justify.end': 'Slut',
  'designSystem.grid.justify.spaceBetween': 'Mellanrum mellan',
  'designSystem.grid.justify.spaceAround': 'Mellanrum runt',
  'designSystem.grid.justify.spaceEvenly': 'Mellanrum jämnt',
  'designSystem.grid.box.label': 'Kolumn {index}',
  'designSystem.grid.box.span': 'span {value}',
  'designSystem.grid.box.offset': 'Förskjutning {value}',
  'designSystem.grid.box.order': 'Ordning {value}',
  'designSystem.grid.box.flex': 'flex {value}',
  'designSystem.grid.box.grow': 'Fyller återstående utrymme',
  'designSystem.grid.responsive.title': 'Responsivt exempel',
  'designSystem.grid.responsive.description':
    'Ändra fönsterstorlek för att se mellanrum och justering ändras mellan brytpunkter.',
  'designSystem.grid.box.responsive': 'xs 24 → md 12',
  'designSystem.grid.box.responsiveDetail': 'Staplas på mobil, delas på skrivbord',
  'designSystem.grid.box.responsiveAlign': 'Delar mellanrum automatiskt via kontext',
  'designSystem.grid.docs.title': 'Rutnätslayout – Row & Col',
  'designSystem.grid.docs.notes':
    'Row beräknar responsiva mellanrum och justering, och Col speglar dem via kontext för ett enhetligt layout.',
  'designSystem.mediaUpload.triggerLabel': 'Select files',
  'designSystem.mediaUpload.type.media': 'media',
  'designSystem.mediaUpload.type.image': 'images',
  'designSystem.mediaUpload.type.video': 'videos',
  'designSystem.mediaUpload.type.audio': 'audio',
  'designSystem.mediaUpload.type.file': 'files',
  'designSystem.mediaUpload.dropHint': 'Drag & drop to upload or browse files',
  'designSystem.mediaUpload.dropActive': 'Release to upload',
  'designSystem.mediaUpload.emptyState': 'No files selected yet',
  'designSystem.mediaUpload.previewVideoLabel': 'Preview of {name}',
  'designSystem.mediaUpload.previewImageAlt': 'Preview of {name}',
  'designSystem.mediaUpload.removeFile': 'Remove {name}',
  'designSystem.mediaUpload.editFile': 'Redigera {name}',
  'designSystem.mediaUpload.zoom': 'Zoom',
  'designSystem.mediaUpload.unnamed': 'Untitled file',
  'designSystem.mediaUpload.showcase.defaultLabel': 'Media library',
  'designSystem.mediaUpload.showcase.defaultDescription':
    'Upload new photos, videos or audio to share with your team.',
  'designSystem.mediaUpload.showcase.controlTitle': 'Configuration',
  'designSystem.mediaUpload.showcase.mediaTypeLabel': 'Media type',
  'designSystem.mediaUpload.showcase.multipleLabel': 'Allow multiple files',
  'designSystem.mediaUpload.showcase.maxFilesLabel': 'Max files',
  'designSystem.mediaUpload.showcase.duplicatesLabel': 'Allow duplicate files',
  'designSystem.mediaUpload.showcase.dragLabel': 'Enable drag & drop',
  'designSystem.mediaUpload.showcase.selectedCount':
    '{count, plural, =0 {No files yet} one {# file selected} other {# files selected}}',
  'designSystem.mediaUpload.showcase.helper': 'Maximum {limit} MB per file',
  'designSystem.mediaUpload.showcase.tooLarge': '{name} exceeds the {limit} MB limit',
  'designSystem.mediaUpload.showcase.untitledFile': 'Selected file',
  'designSystem.mediaUpload.showcase.trigger': 'Upload {label}',
  'designSystem.mediaUpload.showcase.dropHint': 'Drag & drop {label} or browse files',
  'designSystem.mediaUpload.showcase.examplesTitle': 'Examples',
  'designSystem.mediaUpload.showcase.imageTitle': 'Gallery images',
  'designSystem.mediaUpload.showcase.imageDescription':
    'Upload retina-ready hero images for landing pages.',
  'designSystem.mediaUpload.showcase.imageHelper': 'PNG or JPG up to {limit} MB each.',
  'designSystem.mediaUpload.showcase.videoTitle': 'Promo video',
  'designSystem.mediaUpload.showcase.videoDescription':
    'Collect a single teaser video for campaigns.',
  'designSystem.mediaUpload.showcase.videoHelper':
    'MP4 up to {limit} MB. We’ll transcode automatically.',
  'designSystem.mediaUpload.showcase.audioTitle': 'Audio tribute',
  'designSystem.mediaUpload.showcase.audioDescription': 'Gather spoken memories or music clips.',
  'designSystem.mediaUpload.showcase.audioHelper': 'MP3 or WAV up to {limit} MB.',
  'designSystem.mediaUpload.showcase.fileTitle': 'Document upload',
  'designSystem.mediaUpload.showcase.fileDescription': 'Store memorial programs or consent forms.',
  'designSystem.mediaUpload.showcase.fileHelper': 'PDF or DOCX up to {limit} MB each.',
  'designSystem.mediaUpload.showcase.buttonTitle': 'Quick upload button',
  'designSystem.mediaUpload.showcase.buttonDescription':
    'Single tap button with icon for quick uploads.',
  'designSystem.mediaUpload.showcase.buttonHelper': 'Tap the button to pick one or more files.',
  'designSystem.mediaUpload.showcase.buttonTrigger': 'Choose files',
  'designSystem.mediaUpload.showcase.imageButtonCaption':
    'Tap the media button or drop hero images here.',
  'designSystem.mediaUpload.showcase.imageButtonAria': 'Add gallery image',
  'designSystem.mediaUpload.showcase.videoButtonCaption':
    'Drop or select a promo trailer to share.',
  'designSystem.mediaUpload.showcase.videoButtonAria': 'Add campaign video',
  'library.mediaUpload.trigger': '{count, plural, =0 {Upload media} other {Add more media}}',
  'library.mediaUpload.helper': 'Drag files here or browse from your device.',
  'search.publicNotice.title': 'Offentliga uppgifter',
  'search.publicNotice.body': 'Logga in för att se bilder, minnen och mer.',
  // Header/Notifications additions
  design_system: 'Designsystem',
  settings: 'Inställningar',
  logout: 'Logga ut',
  account_menu: 'Kontomeny',
  guest_menu: 'Meny',
  'guest_menu.subtitle': 'Utforska mer av Nätgrav eller logga in för att fortsätta.',
  more_information: 'Mer information',
  accepted: 'Godkänd',
  rejected: 'Avvisad',
  // Groups & Group Details
  'groups.title': 'Rum',
  'groups.loading': 'Laddar grupper…',
  'groups.error': 'Kunde inte ladda grupper',
  'groups.empty': 'Inga grupper ännu.',
  'groups.createGroup': 'Skapa grupp',
  'groups.form.name': 'Namn',
  'groups.form.description': 'Beskrivning',
  'groups.form.category': 'Kategori',
  'groups.form.paid': 'Betalt rum',
  'groups.mode.explore': 'Utforska rum',
  'groups.mode.mine': 'Mina rum',
  'groups.search': 'Sök rum',
  'groups.category': 'Kategori',
  'groups.category.all': 'Alla kategorier',
  'groups.create.title': 'Skapa ett rum',
  'groups.form.desc': 'Beskrivning (valfritt)',
  'groups.form.create': 'Skapa rum',
  'groups.view': 'Visa',
  'groups.join': 'Gå med i rum',
  'groups.empty.hint': 'Prova att ändra filter eller skapa ett nytt rum.',
  loading: 'Loading…',
  'error.generic': 'Something went wrong.',
  'pagination.prev': 'Föregående',
  'pagination.next': 'Nästa',
  notifications_load_more: 'Ladda mer',
  'groups.subtitle': 'Vad vill du prata om i dag?',
  'groups.categories.label': 'Kategorier',
  'groups.mine.filters.sub': 'Filtrera rum efter din roll.',
  'groups.mine.filter.all': 'Alla',
  'groups.mine.filter.led': 'Leds av dig',
  'groups.mine.filter.member': 'Medlem',
  'groups.mine.filter.pending': 'Väntar',
  'groups.mine.section.led': 'Rum du leder',
  'groups.mine.section.led.sub': 'Rum där du är ägare eller admin.',
  'groups.mine.section.member': 'Rum du är med i',
  'groups.mine.section.member.sub': 'Rum där du är aktiv medlem.',
  'groups.mine.section.pending': 'Väntande förfrågningar',
  'groups.mine.section.pending.sub': 'Rum där din förfrågan eller inbjudan fortfarande väntar.',
  'groups.mine.empty.title': 'Inga rum i den här delen ännu',
  'groups.mine.empty.hint': 'Byt filter eller utforska rum att gå med i.',
  'groups.mine.empty.cta': 'Utforska rum',
  'groups.mine.empty.all.title': 'Du är inte med i några rum ännu',
  'groups.mine.empty.all.hint': 'Utforska rum eller skapa ett för att komma igång.',
  'groups.mine.overview.title': 'Dina rum',
  'groups.mine.overview.sub': 'Rum du leder, deltar i eller väntar på att gå med i.',
  'groups.mine.load_error.title': 'Det gick inte att läsa in dina rum',
  'groups.mine.load_error.text': 'Försök igen om en stund.',
  'groups.mine.retry': 'Försök igen',
  'groups.mine.search_empty.title': 'Inga rum matchar din sökning',
  'groups.mine.search_empty.text': 'Prova ett annat rumsnamn eller rensa sökningen.',
  'groups.mine.search_empty.clear': 'Rensa sökning',
  'groups.mine.feed.error.title': 'Det gick inte att läsa in senaste aktivitet',
  'groups.mine.feed.error.text': 'Dina rum är fortfarande tillgängliga ovanför.',
  'groups.sidebar.mine.title': 'Dina senaste rum',
  'groups.sidebar.mine.sub': 'Snabb åtkomst till rum du redan följer.',
  'groups.category_name.local': 'Lokalt',
  'groups.category_name.science_and_tech': 'Vetenskap och teknik',
  'groups.category_name.education': 'Utbildning',
  'groups.category_name.health': 'Hälsa',
  'groups.category_name.lifestyle': 'Livsstil',
  'groups.category_name.travel': 'Resor',
  'groups.category_name.sports': 'Sport',
  'groups.category_name.technology': 'Teknik',
  'groups.category_name.family': 'Familj',
  'groups.category_name.grief_and_loss': 'Sorg och förlust',
  'groups.category_name.spirituality': 'Religion och tro',
  'groups.category_name.relationships': 'Relationer',
  'groups.category_name.life_choices': 'Livsval',
  'groups.category_name.existence': 'Existens',
  'groups.category_name.guidance': 'Vägledning',
  'groups.create.cta': 'Skapa rum',
  'groups.empty.title': 'Inga rum hittades',
  'groups.empty.hint': 'Det finns inga rum som matchar din sökning just nu.',
  'groups.empty.initial.title': 'Inga öppna rum ännu',
  'groups.empty.initial.hint':
    'Skapa det första rummet och bjud in människor till ett meningsfullt samtal.',
  'groups.empty.clear': 'Rensa sökning och filter',
  'groups.card.view': 'Öppna',
  'groups.card.owner': 'Rumsansvarig',
  'groups.card.owner.you': 'Du',
  'create_group.title': 'Skapa rum',
  'create_group.name': 'Vad ska rummet heta?',
  'create_group.desc': 'Vad vill du att rummet ska rymma?',
  'create_group.category': 'Välj inriktning',
  'create_group.paid': 'Betalt medlemskap',
  'create_group.free': 'Gratis',
  'create_group.submit': 'Skapa',
  'create_group.cancel': 'Avbryt',
  'create_group.cover.label': 'Rumsbild (valfritt)',
  'create_group.cover.preview_alt': 'Förhandsvisning av rumsbild',
  'create_group.cover.empty': 'Ingen rumsbild vald ännu.',
  'create_group.cover.choose': 'Välj rumsbild',
  'create_group.cover.adjust_crop': 'Justera beskärning',
  'create_group.cover.remove': 'Ta bort',
  'create_group.cover.hint':
    'Bilden läggs till när rummet skapas och kan ändras senare i Inställningar.',
  'create_group.cover.upload_error':
    'Kunde inte ladda upp rumsbild. Du kan lägga till den i Inställningar.',
  'create_group.cover.image_only': 'Välj en bildfil.',
  'groups.settings.cover.crop': 'Anpassa rumsbilden',
  'groups.settings.cover.safe_area': 'Håll viktiga detaljer innanför den streckade ramen.',
  crop_zoom: 'Zoom',
  'gravesHub.title': 'Dina nära',
  'gravesHub.hero.eyebrow': 'Hålla nära',
  'gravesHub.hero.title': 'Personerna jag tar hand om',
  'gravesHub.hero.subtitle':
    'Allt om dem du ser till finns här—uppdateringar, datum och vilka som är med.',
  'gravesHub.hero.graveCount':
    'Du följer för närvarande {count, plural, one {# person} other {# personer}} i Nätgrav.',
  'gravesHub.hero.cta': 'Lägg till någon ny',
  'gravesHub.hero.secondary': 'Se inbjudningar',
  'gravesHub.myGraves': 'Mina gravar',
  'gravesHub.myGraves.count': '{count}',
  'gravesHub.create': 'Lägg till en person',
  'gravesHub.myGraves.empty':
    'Ingen här ännu. Lägg till någon eller acceptera en inbjudan för att komma igång.',
  'gravesHub.myGraves.emptyAction': 'Lägg till någon ny',
  'gravesHub.myGraves.viewInvites': 'Acceptera inbjudan',
  'gravesHub.guest':
    'Här hittar du gravarna du hör till. En plats för närhet, närvaro och omsorg över tid. Logga in för att komma igång.',
  'gravesHub.guest_preview.name_1': 'Lorense Hansen',
  'gravesHub.guest_preview.role_1': 'Mormor',
  'gravesHub.guest_preview.name_2': 'Oskar Johansen',
  'gravesHub.guest_preview.role_2': 'Far',
  'gravesHub.guest_preview.name_3': 'Anna Solberg',
  'gravesHub.guest_preview.role_3': 'Familjevän',
  'gravesHub.guest_preview.place': 'Vestre gravlund, Oslo',
  'gravesHub.guest_preview.selected_copy':
    'En plats för att se gravarna du är knuten till, öppna gravsidan och bjuda in andra som också är knutna till graven.',
  'gravesHub.guest_preview.visit': 'Öppna gravsidan',
  'gravesHub.guest_preview.invite': 'Bjud in familj',
  'gravesHub.guest_preview.update_author_1': 'Maren delade ett inlägg',
  'gravesHub.guest_preview.update_time_1': 'För 2 timmar sedan',
  'gravesHub.guest_preview.update_body_1':
    'Maren är tacksam för Lorense Hansen. Ett tecken på närvaro, utan att det behöver vara många ord.',
  'gravesHub.guest_preview.update_author_2': 'Isak delade ett inlägg',
  'gravesHub.guest_preview.update_time_2': 'I går',
  'gravesHub.guest_preview.update_body_2':
    'Isak saknar Lorense Hansen. Inlägg, bilder och länkar från de närmaste visas här.',
  'gravesHub.loading.graves': 'Samlar personerna du ser till...',
  'gravesHub.loading.error':
    'Vi kunde inte hämta dina personer just nu. Uppdatera för att försöka igen.',
  'gravesHub.loading.completed': 'Synkroniserat på {seconds}s',
  'gravesHub.feed.title': 'Gravväggen',
  'gravesHub.invite': 'Bjud in familjen att ta hand om graven',
  'gravesHub.selected.copy': 'Håll koll på det som händer och ta med andra du litar på.',
  'gravesHub.memory.photoOnly': 'Lade till ett foto på graven',
  'gravesHub.memory.view': 'Läs minne',
  'gravesHub.memory.empty': 'Inga uppdateringar ännu—dela en tanke så alla vet att du var här.',
  'gravesHub.memory.loadMore': 'Visa fler uppdateringar',
  'gravesHub.visitNamed': 'Besök {name}s grav',
  'gravesHub.visitFallback': 'Besök graven',
  'gravesHub.feed.noSelection': 'Välj en person för att vara närvarande.',
  'gravesHub.feed.empty': 'Här är det tills vidare stilla.',
  'gravesHub.invitations.shortcut':
    '{count, plural, one {# inbjudan väntar} other {# inbjudningar väntar}}',
  'gravesHub.invitations.title': 'Inbjudningar till gemensam omsorg',
  'gravesHub.invitations.manage': 'Hantera',
  'gravesHub.invitations.invitedBy': 'Vill hjälpa dig att ta hand om graven',
  'gravesHub.invitations.accept': 'Acceptera',
  'gravesHub.invitations.decline': 'Avböj',
  'gravesHub.invitations.acceptSuccess': 'Inbjudan accepterades',
  'gravesHub.invitations.declineSuccess': 'Inbjudan avböjdes',
  'gravesHub.invitations.actionError': 'Något gick fel. Försök igen.',
  'gravesHub.gettingStarted.title': 'I dag',
  'gravesHub.gettingStarted.reminders': 'E‑postpåminnelser',
  'gravesHub.gettingStarted.remindersHint':
    'Få ett vänligt meddelande före viktiga dagar eller nya uppdateringar.',
  'gravesHub.starter.anniversaries.title': 'Märkedagar',
  'gravesHub.starter.anniversaries.body':
    'Lägg till datum som hjälper familjen att minnas tillsammans.',
  'gravesHub.starter.anniversaries.action': 'Lägg till datum',
  'gravesHub.starter.memory.title': 'Bilder',
  'gravesHub.starter.memory.body': 'Lägg till bilder som familjen vill bevara tillsammans.',
  'gravesHub.starter.memory.action': 'Lägg till bilder',
  'gravesHub.shortcuts.title': 'Genvägar',
  'gravesHub.shortcuts.invite': 'Bjud in familjen att hjälpa',
  'gravesHub.shortcuts.invite.copy':
    'Dela åtkomst så familjen kan lägga till minnen, bilder och sammanhang.',
  'gravesHub.shortcuts.email': 'E‑postinställningar',
  'gravesHub.shortcuts.email.copy': 'Finjustera påminnelser och aviseringar.',
  'gravesHub.shortcuts.open': 'Öppna graven',
  'gravesHub.shortcuts.open.copy':
    'Besök hela gravsidan för berättelser, bilder och det ni tar hand om tillsammans.',
  'gravesHub.tips.title': 'Håll kontakten',
  'home.actions.title': 'Nätgrav: Ett varaktigt hem för våra liv.',
  'home.actions.subtitle':
    'Ett nätverk byggt för sanning och gemenskap, drivet av varaktig mening.',
  'home.actions.create.title': 'Skapa en Nätgrav',
  'home.actions.create.body':
    'Samla familjen och skapa er permanenta Nätgrav – helt kostnadsfritt. Dela ord, bilder och ljus och bevara historien tillsammans var ni än är i världen.',
  'home.actions.create.cta': 'Starta Nätgrav',
  'home.actions.find.title': 'Hitta en grav',
  'home.actions.find.body':
    'Hitta den du saknar. Se bekräftade minnen och få aviseringar om viktiga dagar.',
  'home.actions.find.cta': 'Sök efter gravar',
  'home.actions.invite.title': 'Bjud in bidragsgivare',
  'home.actions.invite.body':
    'Bjud in bidragsgivare. Dela åtkomst med dina närmaste för att bygga livsberättelsen tillsammans och hålla minnet levande.',
  'home.actions.invite.cta': 'Skicka inbjudningar',
  'home.actions.spark.title': 'Tänd din Gnista',
  'home.actions.spark.body':
    'Dela det som är viktigt för dig nu. Din Gnista är rummet för dina reflektioner och inre sanningar. Dela ditt ljus med världen och väck eftertanke hos andra.',
  'home.actions.spark.cta': 'Skapa Gnista',
  'gravesHub.tips.applyFrame.title': 'Gör sidan personlig',
  'gravesHub.tips.applyFrame.body':
    'Du har ramar redo. Vill du lägga till en som passar {hasName, select, yes {{firstName}} other {dem}}?',
  'gravesHub.tips.applyFrame.cta': 'Använd en ram',
  'gravesHub.tips.invite.title': 'Bjud in pålitliga närstående',
  'gravesHub.tips.invite.body':
    'Dela ansvar och tillgång, så att berättelser och omsorg bärs tillsammans.',
  'gravesHub.tips.invite.cta': 'Skicka inbjudan',
  'gravesHub.tips.reminders.title': 'Påminnelse via e-post',
  'gravesHub.tips.reminders.body': 'Få en påminnelse via e-post före viktiga händelser.',
  'gravesHub.tips.info.title': 'Bygg en stadig omsorgsrytm',
  'gravesHub.tips.info.body':
    'Använd påminnelser, uppdateringar och delad åtkomst för att hålla omsorgen jämn över tid.',
  'gravesHub.store.title': 'Små handlingar med stor betydelse',
  'gravesHub.store.description':
    'Upptäck End Of Time Collection – ljus och cirklar som för närvaron tillbaka.',
  'gravesHub.store.candle.title': 'Tänd ljus',
  'gravesHub.store.candle.body': 'En stilla handling av kärlek.',
  'gravesHub.store.candle.cta': 'Håll ljuset tänt',
  'gravesHub.store.frame.title': 'Välj cirkel',
  'gravesHub.store.frame.body': 'Hitta den som speglar er närhet.',
  'gravesHub.store.frame.cta': 'Välj cirkel',
  'gravesHub.store.tree.title': 'Plantera ett träd',
  'gravesHub.store.tree.body': 'Plantera en levande hyllning i deras namn via våra partners.',
  'gravesHub.store.tree.cta': 'Plantera ett träd',
  'gravesHub.notifications.updated': 'Påminnelseinställningar uppdaterade',
  'gravesHub.notifications.error':
    'Vi kunde inte uppdatera dina påminnelseinställningar. Försök igen.',
  'gravesHub.notifications.noSelection': 'Välj en person för att fortsätta.',
  'gravesHub.sidePanel.title': 'Stöd och vägledning',
  'gravesHub.sidePanel.empty':
    'Välj en person för att se tips och verktyg för att hålla sidan uppdaterad.',
  // Efter köp – använd ram
  'postPurchase.applyFrame.title': 'Använd ditt nya köp nu?',
  'postPurchase.applyFrame.body': 'Du kan lägga det du just köpte på en grav direkt.',
  'postPurchase.applyFrame.select': 'Välj en person',
  'postPurchase.applyFrame.apply': 'Använd på den här sidan',
  'postPurchase.applyFrame.inventory': 'Gå till Min samling',
  'postPurchase.applyFrame.skip': 'Hoppa över nu',
  // Inventar snabbapplicering
  'inventory.applyFrame': 'Använd den nu',
  'inventory.applyFrame.select': 'Välj en person',
  'inventory.applyFrame.open': 'Öppna sidan',
  'inventory.apply.select': 'Välj en person',
  'inventory.apply.button.frame': 'Använd cirkeln nu',
  'inventory.apply.button.candle': 'Tänd ljuset nu',
  'inventory.apply.button.default': 'Använd detta nu',
  'inventory.apply.title.frame': 'Vem ska få cirkeln?',
  'inventory.apply.title.candle': 'Vem tänder du ljuset för?',
  'inventory.apply.title.default': 'Använd det du köpte direkt',
  'inventory.apply.link.store': 'Hitta ett nytt ljus i butiken',
  'inventory.buyMore.frame': 'Hitta en ny cirkel',
  'inventory.buyMore.candle': 'Hitta ett nytt ljus',
  'inventory.buyMore.default': 'Hitta något nytt',
  grave_candles_light_now: 'Tänd ljuset för {name}',
  grave_candles_browse_store: 'Hitta ett nytt ljus',
  cover_photo_adjust_hint: 'Justera bilden tills det känns rätt',
  cover_photo_drag_hint: 'Dra för att justera',
  cover_photo_reset: 'Återställ utsnitt',
  frame_apply_success: 'Ram tillämpad',
  frame_apply_failed: 'Kunde inte tillämpa ramen',
  remove_grave_frame: 'Ta bort profilram',
  frame_remove_success: 'Ramen togs bort',
  frame_remove_failed: 'Kunde inte ta bort ramen',
  'create_group.invite.title': 'Invite friends (optional)',
  'create_group.invite.placeholder_name': 'Enter name or email',
  'create_group.invite.placeholder_msg': 'Write message',
  loading: 'Loading…',
  'per_page.label': 'Per page',
  'notifications.group_invite.eyebrow': 'Gruppinbjudan',
  'notifications.group_invite.title': '{inviterName} bjöd in dig till {groupName}',
  'notifications.group_invite.body': 'Acceptera inbjudan för att gå med i gruppkonversationen.',
  'notifications.group_invite.accepted': 'Gruppinbjudan accepterad.',
  'notifications.group_invite.declined': 'Gruppinbjudan avböjd.',
  'notifications.group_invite.action_error': 'Kunde inte uppdatera gruppinbjudan.',
  'notifications.group_join_request.eyebrow': 'Förfrågan om att gå med i grupp',
  'notifications.group_join_request.title': '{requesterName} bad om att gå med i {groupName}',
  'notifications.group_join_request.accepted': 'Förfrågan om att gå med i gruppen godkändes.',
  'notifications.group_join_request.declined': 'Förfrågan om att gå med i gruppen avböjdes.',
  'notifications.group_join_request.action_error':
    'Kunde inte uppdatera förfrågan om att gå med i gruppen.',
  'groups.accept.working': 'Accepting your invitation…',
  'groups.accept.ok': 'You’ve joined the group.',
  'groups.accept.view': 'Go to group',
  'groups.accept.fail': 'Invite is invalid or expired.',
  'groups.accept.back': 'Back to groups',
  'groups.accept.title': 'Group invite',
  'groups.accept.loading': 'Loading invitation...',
  'groups.accept.auth_required': 'Login or create an account to view this group invitation.',
  'groups.accept.member_count': '{count, plural, one {# member} other {# members}}',
  'groups.accept.invite_label': 'Group invitation',
  'groups.members.label': 'De som är med: {count}',
  'groups.confirm.delete': 'Delete this group?',
  'groupDetails.loading': 'Loading group…',
  'groupDetails.error': 'Error loading group',
  'groupDetails.edit': 'Redigera rum',
  'groups.banner.join': 'Gå med',
  'groups.banner.request_join': 'Begär att få gå med',
  'groups.banner.joined': 'Medlem',
  'groups.files.empty': 'Inga filer ännu.',
  'groups.join.unavailable': 'Att gå med kräver inbjudan eller ägarens godkännande.',
  'groups.join.success': 'Du har gått med i rummet.',
  'groups.leave': 'Lämna rummet',
  'groups.leave.confirm': 'Lämna den här gruppen?',
  'groups.leave.success': 'Du har lämnat rummet.',
  'groups.leave.unavailable': 'Det gick inte att lämna gruppen.',
  'groupDetails.form.name': 'Name',
  'groupDetails.form.description': 'Description',
  'groupDetails.form.category': 'Category',
  'groupDetails.addMember.title': 'Bjud in till rummet',
  'groupDetails.addMember.searchLabel': 'Bjud in person (sök på namn)',
  'groupDetails.addMember.placeholder': 'Search users…',
  'groupDetails.addMember.selected': 'Selected',
  'groupDetails.addMember.selectedId': 'Selected user ID:',
  'groupDetails.addMember.role': 'Role',
  'groupDetails.addMember.status': 'Status',
  'groupDetails.addMember.submit': 'Bjud in',
  'groupDetails.addMember.loadMore': 'Load more',
  'groupDetails.members.title': 'Members',
  'groupDetails.members.empty': 'No members yet.',
  'groupDetails.members.table.id': 'ID',
  'groupDetails.members.table.user': 'User',
  'groupDetails.members.table.role': 'Role',
  'groupDetails.members.table.status': 'Status',
  'groupDetails.members.table.actions': 'Actions',
  'groupDetails.members.remove': 'Remove',
  'groupDetails.confirm.remove': 'Remove member?',
  'groupDetails.categoryPrefix': 'Category: {name}',
  'groupDetails.fallbackTitle': 'Group #{id}',
  create_grave_validation_full_date_required: 'Välj år, månad och dag',
  create_grave_date_help: 'Välj år, sedan månad och dag',
  'nav.sparks': 'Skapa Gnista',
  'nav.my_family': 'Släktträd',
  'nav.home': 'Hem',
  'nav.groups': 'Rum',
  'rooms.navigation.unread_label':
    'Rum, {count, plural, one {# oläst meddelande} other {# olästa meddelanden}}',
  'rooms.mine.navigation.unread_label':
    'Mina rum, {count, plural, one {# oläst meddelande} other {# olästa meddelanden}}',
  'rooms.inbox.muted': 'Aviseringar är avstängda',
  'rooms.inbox.room_unread_label':
    '{count, plural, one {# oläst meddelande} other {# olästa meddelanden}}',
  'nav.familyTree': 'Släktträd',
  'nav.graves': 'Mina gravar',
  'nav.store': 'Närvaro',
  'nav.primary': 'Huvudnavigering',
  'nav.mobile_graves': 'Gravar',
  'header.openMessages': 'Öppna meddelanden',
  'messenger.searchPlaceholder': 'Sök i konversationer',
  'messenger.newConversation': 'Ny konversation',
  'messenger.loading': 'Laddar konversationer…',
  'messenger.error': 'Vi kunde inte hämta dina meddelanden.',
  'messenger.emptyState':
    'Inga konversationer ännu. Starta en konversation för att hålla kontakten.',
  'messenger.selectThread': 'Välj en konversation för att visa meddelanden.',
  'messenger.emptyMessages': 'Inga meddelanden ännu. Säg hej för att komma igång.',
  'messenger.attach': 'Bifoga fil',
  'messenger.emoji': 'Infoga emoji',
  'messenger.send': 'Skicka',
  'messenger.call': 'Starta samtal',
  'messenger.typing': 'Skriver…',
  'messenger.online': 'Online',
  'messenger.status.online': 'Online',
  'messenger.status.offline': 'Offline',
  'messenger.status.lastSeen': 'Senast aktiv {time}',
  'messenger.status.group': 'Gruppchatt',
  'messenger.status.groupCount': '{online} av {total} online',
  'messenger.loadingContacts': 'Laddar kontakter…',
  'messenger.errorContacts': 'Vi kunde inte ladda dina kontakter.',
  'messenger.noContacts':
    'Inga relationer hittades ännu. Lägg till relationer för att starta en konversation.',
  'messenger.conversations': 'Konversationer',
  'messenger.status.live': 'Live',
  'messenger.status.reconnecting': 'Återansluter…',
  'messenger.status.connecting': 'Ansluter…',
  'messenger.loadOlder': 'Ladda äldre meddelanden',
  'messenger.decryptionFailed': 'Meddelandet kunde inte dekrypteras.',
  'messenger.encryptedPlaceholder': '🔒 Krypterat meddelande väntar på synkronisering…',
  'messenger.mls.syncingEncryption': 'Synkar kryptering… (försöker igen)',
  'messenger.mls.pendingSync': 'Synkar krypterade meddelanden…',
  'messenger.mls.notEnabled':
    'Den här chatten stöder inte MLS. Starta en ny krypterad konversation.',
  'messages.title': 'Messages',
  'messages.search': 'Search conversations',
  'messages.new.title': 'Start a conversation',
  'messages.new.recipient': 'Recipient ID',
  'messages.new.subject': 'Subject (optional)',
  'messages.new.start': 'Start',
  'messages.empty': 'No conversations yet',
  'messages.empty.hint': 'Start one from the form on the left.',
  'messages.list.unread': 'Unread',
  'messages.list.open': 'Open',
  'messages.thread.title': 'Conversation',
  'messages.thread.loading': 'Loading messages…',
  'messages.thread.error': 'Could not load messages.',
  'messages.thread.placeholder': 'Write a message…',
  'messages.thread.send': 'Send',
  'pagination.prev': 'Föregående',
  'pagination.next': 'Nästa',
  'error.generic': 'Something went wrong.',
  'sparks.weeklyQuestion.title': 'Veckans fråga',
  'sparks.weeklyQuestion.body':
    'Vad hjälper dig att känna dig mest sammankopplad med dem du har förlorat?',
  'sparks.weeklyQuestion.answerCta': 'Skapa en Gnista',
  'sparks.composer.open': 'Skapa en Gnista',
  'sparks.topics.title': 'Ämnen',
  'sparks.topics.empty': 'Inga ämnen än.',
  'sparks.highlights.title': 'Höjdpunkter',
  'sparks.highlights.empty': 'Inga höjdpunkter än.',
  'sparks.feed.empty': 'Inga gnistor än.',
  'sparks.filters.title': 'Filter',
  'sparks.filters.newest': 'Nyast',
  'sparks.filters.mostActive': 'Mest aktiva',
  'sparks.filters.stars': 'Stjärnor',
  'sparks.filters.open': 'Filter och ämnen',
  'sparks.quote.title': 'En tanke i dag',
  'sparks.quote.loading': 'Hittar dagens tanke…',
  'sparks.quote.empty': 'Tänk om livet handlar om att göra världen lite bättre för någon?',
  'sparks.suggestions.title': 'Förslag',
  'sparks.suggestions.empty': 'Inga förslag än.',
  'sparks.rooms.title': 'Rum för det vi har gemensamt',
  'sparks.rooms.body':
    'Möt människor som känner igen sig i det som betyder något för dig. Dela erfarenheter, hitta stöd och utforska det ni bryr er om.',
  'sparks.rooms.cta': 'Utforska Rum',
  spark_submit_error: 'Ett fel uppstod när din gnista skulle publiceras. Försök igen.',
  media_uploaded: 'Uppladdning klar',
  search_set_relation_title: 'Hitta graven för att ange din relation',
  filter_graves: 'Filtrera gravar',
  country: 'Land',
  municipality: 'Kommun',
  search_placeholder: 'Sök efter namn',
  clear: 'Rensa',
  set_relation: 'Välj din relation',
  go_to_grave: 'Gå till graven',
  relation_confirmed: 'Relation bekräftad',
  relation_waiting_for_approval: 'Relation väntar på godkännande',
  relation_modal_title: 'Ange relation',
  relation_modal_desc: 'Välj båda sidor av relationen. Vi sparar när båda är valda.',
  their_relation_to_you: 'Deras relation till dig',
  your_relation_to_them: 'Din relation till dem',
  optional_note: 'Valfri anteckning',
  relation_note_placeholder: 'Lägg till en kort anteckning eller ett minne (valfritt)',
  bond_saved_confirmation: 'Relationen sparas: {a} och {b}.',
  select_both_relations_hint: 'Välj båda relationerna för att fortsätta.',
  save_relation: 'Spara relation',
  cancel: 'Avbryt',
  results_count_one: 'Visar {count} träff',
  results_count_other: 'Visar {count} träffar',
  search_grave_results_one: '{count} grav hittad',
  search_grave_results_other: '{count} träffar',
  search_grave_load_more: 'Visa fler gravar',
  spark_feeling_tooltip_reflecting: 'Gå med reflektion i stillhet.',
  spark_feeling_tooltip_freedom: 'Stå med frihet, öppen och orädd.',
  spark_feeling_tooltip_wonder: 'Se med förundran, ögon öppna och nya.',
  spark_feeling_tooltip_gratitude: 'Lev med tacksamhet, namnge det som är gott.',
  spark_feeling_tooltip_peace: 'Vila i fred, mjuk närvaro för hjärtat.',
  spark_feeling_tooltip_hopeful: 'Gå med hopp mot det som kommer.',
  spark_feeling_tooltip_connection: 'Var med andra i delad gemenskap.',
  spark_category_question_description: 'Bjud in andra att undra tillsammans.',
  spark_category_story_description: 'Berätta ett ögonblick så som det hände.',
  spark_category_insight_description: 'Dela en sanning du har lagt märke till.',
  spark_category_feeling_description: 'Sätt ord på det som lever i dig nu.',
  spark_category_intention_description: 'Något du planerar eller önskar göra.',
  'designSystem.timePicker.label.hour': 'Timme',
  'designSystem.timePicker.label.minute': 'Minut',
  'designSystem.timePicker.label.period': 'Tid på dygnet',
  'designSystem.timePicker.placeholder.hour': 'Välj timme',
  'designSystem.timePicker.placeholder.minute': 'Välj minut',
  'designSystem.timePicker.placeholder.period': 'Välj tid på dygnet',
  'designSystem.timePicker.clear': 'Rensa tid',
  'designSystem.timePicker.period.am': 'AM',
  'designSystem.timePicker.period.pm': 'PM',
  'designSystem.select.noResults': 'Inga träffar',
  'designSystem.select.clear': 'Rensa val',
  'designSystem.select.searchPlaceholder': 'Skriv för att söka',
  aunt_in_law_parent: 'Ingift faster/mosters förälder',
  aunt_in_law_sibling: 'Ingift faster/mosters syskon',
  aunt_in_law_sibling_daughter: 'Ingift faster/mosters syskons dotter',
  aunt_in_law_sibling_daughter_daughter: 'Ingift faster/mosters syskons dotters dotter',
  brother_in_law_parent: 'Svågers förälder',
  brother_in_law_sibling: 'Svågers syskon',
  brother_in_law_sibling_son: 'Svågers syskons son',
  brother_in_law_sibling_son_son: 'Svågers syskons sons son',
  brother_in_law_son: 'Svågers son',
  father_in_law_parent: 'Svärfars förälder',
  father_in_law_sibling: 'Svärfars syskon',
  father_in_law_sibling_parent: 'Svärfars syskons förälder',
  father_in_law_sibling_sibling: 'Svärfars syskons syskon',
  father_in_law_sibling_sibling_son: 'Svärfars syskons syskons son',
  father_in_law_sibling_son: 'Svärfars syskons son',
  father_in_law_sibling_son_son: 'Svärfars syskons sons son',
  father_in_law_son: 'Svärfars son',
  father_parent_sibling_sibling: 'Fars förälders syskons syskon',
  father_sibling_sibling: 'Fars syskons syskon',
  father_sibling_sibling_son: 'Fars syskons syskons son',
  first_cousin_once_removed_in_law: 'Ingift syssling',
  grandfather_in_law: 'Svärfarfar',
  grandmother_in_law: 'Svärfarmor',
  mother_in_law_daughter: 'Svärmors dotter',
  mother_in_law_parent: 'Svärmors förälder',
  mother_in_law_sibling: 'Svärmors syskon',
  mother_in_law_sibling_daughter: 'Svärmors syskons dotter',
  mother_in_law_sibling_daughter_daughter: 'Svärmors syskons dotters dotter',
  mother_in_law_sibling_parent: 'Svärmors syskons förälder',
  mother_in_law_sibling_sibling: 'Svärmors syskons syskon',
  mother_in_law_sibling_sibling_daughter: 'Svärmors syskons syskons dotter',
  mother_parent_sibling_sibling: 'Mors förälders syskons syskon',
  mother_sibling_sibling: 'Mors syskons syskon',
  parent_spouse: 'Förälders make/maka',
  sister_in_law_daughter: 'Svägerskas dotter',
  sister_in_law_parent: 'Svägerskas förälder',
  sister_in_law_sibling: 'Svägerskas syskon',
  sister_in_law_sibling_daughter: 'Svägerskas syskons dotter',
  sister_in_law_sibling_daughter_daughter: 'Svägerskas syskons dotters dotter',
  spouse_daughter: 'Make/makas dotter',
  spouse_son: 'Make/makas son',
  uncle_in_law_parent: 'Ingift farbror/morbrors förälder',
  uncle_in_law_sibling: 'Ingift farbror/morbrors syskon',
  uncle_in_law_sibling_son: 'Ingift farbror/morbrors syskons son',
  uncle_in_law_sibling_son_son: 'Ingift farbror/morbrors syskons sons son',
  'home_page.brand_name': 'Nätgrav',
  'home_page.hero_title': 'Det som binder oss samman',
  'home_page.hero_subtitle':
    'Nätgrav samlar människorna, värderingarna och berättelserna som formar ett liv. Här kan du ta hand om det som betyder något, medan livet pågår och för dem som kommer efter.',
  'home_page.cta_my_light': 'Utforska Mitt ljus',
  'home_page.cta_search_graves': 'Sök gravar',
  'home_page.cta_create_grave': 'Skapa en Nätgrav',
  'home_page.cta_shop_frames': 'Till märkesdagen',
  'home_page.chip_invite_family': 'Familj',
  'home_page.chip_share_memory': 'Tro',
  'home_page.chip_light_candle': 'Hopp',
  'home_page.chip_apply_frame': 'Kärlek',
  'home_page.hero_pick_grave': 'Välj en grav',
  'home_page.hero_select_details': 'Välj för att se detaljer',
  'home_page.chip_anniversary_tomorrow': 'Årsdag i morgon',
  'home_page.hero_quote': 'Hon lärde oss att kärlek är något man gör, inte bara något man känner.',
  'home_page.life_preview_label': 'Mitt ljus',
  'home_page.life_preview_title': 'Det som är viktigt förtjänar en plats',
  'home_page.life_preview_body':
    'En plats för det du står för, människorna omkring dig och det du vill föra vidare.',
  'home_page.life_preview_values_title': 'Det jag står för',
  'home_page.life_preview_values_body': 'Värderingar och ord som berättar något om dig.',
  'home_page.life_preview_compass_title': 'Min kompass',
  'home_page.life_preview_compass_body': 'Riktningen du vill hålla fast vid.',
  'home_page.life_preview_people_title': 'Mina människor',
  'home_page.life_preview_people_body': 'Relationerna som formar ditt liv.',
  'home_page.life_preview_after_title': 'Efter mig',
  'home_page.life_preview_after_body': 'Det du vill att andra ska veta en dag.',
  'home_page.life_preview_cta': 'Se hur Mitt ljus fungerar',
  'home_page.btn_light_candle': 'Se ljusen',
  'home_page.btn_add_memory': 'Skriv några ord',
  'home_page.btn_apply_frame': 'Livscirklar',
  'home_page.btn_invite_family': 'Bjud in familj',
  'home_page.nearby_btn_light_candle': 'Besök graven',
  'home_page.nearby_btn_add_memory': 'Skriv några ord',
  'home_page.nearby_btn_apply_frame': 'Livscirklar',
  'home_page.nearby_btn_invite_family': 'Lägg till bild',
  'home_page.graves_hub_title': 'En gravplats som alltid är nära',
  'home_page.graves_hub_subtitle':
    'Nätgrav är kostnadsfritt för alla familjer. Besök gravplatsen när du vill och ta hand om bilder, berättelser och minnen tillsammans.',
  'home_page.people_care_for': 'Personer jag bryr mig om',
  'home_page.people_add': '+ Lägg till',
  'home_page.placeholder_name': 'Ingeborg Larsen',
  'home_page.tag_new_memory': 'Nytt minne',
  'home_page.pick_grave': 'Välj en grav',
  'home_page.select_to_view': 'Välj för att se detaljer',
  'home_page.birthday_soon': 'Födelsedag snart',
  'home_page.recent_updates': 'Senaste uppdateringar',
  'home_page.updates_placeholder': 'Uppdateringar eller påminnelser visas här.',
  'home_page.memorial_title': 'Varje person har en historia.',
  'home_page.memorial_subtitle':
    'På gravväggen kan familj och vänner samla bilder, ord och upplevelser. På så sätt kan fler bidra till berättelsen om människan som graven representerar.',
  'home_page.select_grave': 'Välj en grav',
  'home_page.add_guardian': 'Lägg till förmyndare',
  'home_page.invite_family_contribute': 'Bjud in familjen att bidra',
  'home_page.share_memory_prompt': 'Dela en bild, skriv några ord eller visa att du har varit här.',
  'home_page.btn_share_memory': 'Skriv på gravväggen',
  'home_page.from_family': 'Från familjen',
  'home_page.family_quote':
    '”Hon höll alltid ljusen tända på vintern, så huset kändes varmt när vi kom in.”',
  'home_page.added_days_ago': 'Tillagd för 3 dagar sedan',
  'home_page.explore_memorial': 'Utforska {name}',
  'home_page.this_memorial': 'detta minne',
  'home_page.social_title': 'Byggd för livet mellan människor',
  'home_page.social_subtitle':
    'Nätgrav samlar samtal, gemenskap och det vi vill dela på en plats. För relationerna vi bygger medan vi lever och närheten vi bevarar genom hela livet.',
  'home_page.social_chat_title': 'Samtal som håller människor nära',
  'home_page.social_chat_body':
    'Skriv, ring eller möts på video. Prata privat en till en, eller samla familj och vänner i en grupp.',
  'home_page.social_chat_security': 'Ende-till-ende-krypterad med hybrid postkvantskydd.',
  'home_page.social_chat_cta': 'Öppna Chat',
  'home_page.social_rooms_title': 'Rum för det vi har gemensamt',
  'home_page.social_rooms_body':
    'Möt människor med erfarenheter, intressen eller frågor som berör något av detsamma.',
  'home_page.social_rooms_cta': 'Utforska Rum',
  'home_page.social_sparks_title': 'Skapa Gnist',
  'home_page.social_sparks_body':
    'Dela en tanke, erfarenhet eller fråga. Något litet för dig kan betyda mycket för andra.',
  'home_page.social_sparks_cta': 'Utforska Gnistor',
  'home_page.store_title': 'För någon du tänker på',
  'home_page.store_subtitle':
    'På Nätgraven kan ljus och cirklar ge din tanke ett personligt uttryck.',
  'home_page.store_description':
    'Välj ett ljus för en märkesdag, eller en cirkel som berättar något om människan.',
  'home_page.store_quote':
    'En Nätgrav rymmer mer än namn och datum. Den kan också berätta om människan, relationerna och det som fortfarande betyder något.',
  'home_page.store_frames': 'Cirklar för livet',
  'home_page.store_candles': 'Ljus för märkesdagar',
  'home_page.store_view': 'Visa',
  'home_page.store_visit': 'Utforska Närvaro',
  'home_page.reminders_title': 'Märkesdagar, på ditt sätt',
  'home_page.reminders_subtitle':
    'Nätgrav samlar märkesdagarna för dem du bryr dig om och hjälper dig att vara närvarande när det känns rätt.',
  'home_page.reminder_label_tomorrow': 'I morgon',
  'home_page.reminder_title_birthday': 'Ingeborgs födelsedag',
  'home_page.reminder_body_birthday': 'En stund att minnas, på ditt eget sätt.',
  'home_page.reminder_label_next_week': 'Nästa vecka',
  'home_page.reminder_title_visit': 'Dags för ett besök',
  'home_page.reminder_body_visit': 'När det känns rätt att vara närvarande.',
  'home_page.reminder_action_visit': 'Anpassa tidpunkten så att den passar dig',
  'home_page.reminder_label_new': 'Nytt',
  'home_page.reminder_title_memory': 'Nytt foto från Line',
  'home_page.reminder_body_memory':
    'Ett nytt foto har delats. När det läggs till på graven blir det en del av berättelsen som varar.',
  'home_page.reminder_action_memory': 'Se minne',
  'home_page.family_title': 'Vi hör samman genom generationer',
  'home_page.family_subtitle':
    'Se relationerna mellan människor, bevara familjens historia och ge nästa generation en plats att hitta den.',
  'home_page.family_grandparents': 'Mor- och farföräldrar',
  'home_page.family_linked_graves': 'Länkade gravar',
  'home_page.family_children': 'Barn',
  'home_page.family_living': 'Levande och minnesatta',
  'home_page.family_open': 'Öppna släktträd',
  'home_page.family_beta': 'Beta',
  'home_page.why_title': 'En människa är mer än ett namn på en grav',
  'home_page.why_subtitle':
    'Nätgrav ger minnen, relationer och berättelser en plats att leva vidare. Kostnadsfritt för alla familjer.',
  'home_page.why_secure_title': 'För alla familjer',
  'home_page.why_secure_body':
    'Alla ska kunna ge dem de har förlorat en meningsfull gravplats oavsett ekonomi eller bostadsort.',
  'home_page.why_connected_title': 'Byggt för närhet',
  'home_page.why_connected_body':
    'Bevara minnen tillsammans, håll kontakten med människor och hitta gemenskap när du behöver den.',
  'home_page.why_tools_title': 'Historien finns kvar',
  'home_page.why_tools_body':
    'Det ni samlar i dag ger kommande generationer en plats att hitta människorna och berättelserna som kom före dem.',
  'home_page.why_footer_quote':
    '”Vi arbetar mot vår egen irrelevans — och det är det mest meningsfulla vi vet att göra.”',
  'home_page.why_footer_source': 'End of Time Center — forskning om liv, död och det som består',
  circle_description1:
    'Cirklarna bär profilbilden och ger ett stilla uttryck för personens värderingar, personlighet och närvaro.',
  presence_description1: 'Du väljer graven, och ljuset tänds där.',
  presence_description2: 'För många är ljus ett bra sätt att visa hopp och möta tankar.',
  new_home_page_store_description:
    'Nätgrav är <link>End of Time Care</link> i praktiken: omsorg som inte tar slut, utan fortsätter i de handlingar vi gör för varandra.',
  'groups.sidebar.quick': 'Rum du kanske gillar',
  'groups.sidebar.quick.sub': 'Rum som är öppna och används.',
  'groups.categories.sub': 'Bläddra i kategorier för att hitta relevanta rum snabbare.',
  'groups.section.top': 'Utforska rum',
  'groups.section.top.sub': 'Öppna rum du kan gå in i nu.',
  'groups.section.mine.sub': 'Grupper du äger eller deltar i.',
  'groups.section.suggested': 'Föreslaget för dig',
  'groups.section.suggested.sub': 'Grupper som matchar din sökning och dina filter.',
  'groups.section.new': 'Nya grupper',
  'groups.section.new.sub': 'Nyligen skapade grupper du kan gå med i.',
  'groups.rules.placeholder': 'En regel per rad',
  'groups.rules.empty': 'Inga egna riktlinjer har lagts till.',
  'groups.members.creator': 'Rumansvarig',
  'groups.members.co_creators': 'Medansvariga',
  'groups.members.send_message': 'Skicka meddelande',
  'groups.members.message_soon': 'Direktmeddelanden från rum kommer snart i End of Time-chatten.',
  'groups.members.make_creator': 'Gör till rumansvarig',
  'groups.members.remove_from_group': 'Ta bort från rummet',
  'groups.members.turn_on_post_approval': 'Slå på inläggsgodkännande',
  'groups.members.turn_off_post_approval': 'Slå av inläggsgodkännande',
  'groups.members.change_to_member_only': 'Ändra till endast medlem',
  'groups.members.leave_group': 'Lämna rummet',
  'groups.members.cancel_at_period_end': 'Avslutas vid slutet av perioden',
  'groups.members.period_end_info':
    'När förnyelsen stoppas behåller personen åtkomst till slutet av den pågående perioden.',
  'groups.members.make_creator.success': 'Rumansvarig uppdaterad.',
  'groups.members.action_error': 'Kunde inte uppdatera medlem.',
  'groups.files.photos': 'Bilder',
  'groups.files.videos': 'Videor',
  'groups.files.documents': 'Dokument',
  'groups.files.upload_photo': 'Ladda upp bild',
  'groups.files.upload_video': 'Ladda upp video',
  'groups.files.upload_document': 'Ladda upp dokument',
  'groups.files.upload_success': 'Filen har laddats upp.',
  'groups.files.upload_error': 'Kunde inte ladda upp filen.',
  'groups.files.upload_too_large': 'Filen är för stor. Maximal storlek är {size}.',
  'groups.files.delete_error': 'Kunde inte ta bort filen.',
  'groups.files.delete_success': 'Filen har tagits bort.',
  'groups.files.type_tabs': 'Filtyper',
  'groups.files.open_photo': 'Öppna {name}',
  'groups.files.play_video': 'Spela upp {name}',
  'groups.files.load_error.title': 'Det gick inte att läsa in filerna',
  'groups.files.load_error.text': 'Försök igen om en stund.',
  'groups.files.retry': 'Försök igen',
  'groups.files.delete_confirm.title': 'Ta bort filen?',
  'groups.files.delete_confirm.text': '{name} tas bort permanent från rummet.',
  'groups.files.loading': 'Laddar filer...',
  'groups.files.photos.empty': 'Inga bilder ännu.',
  'groups.files.videos.empty': 'Inga videor ännu.',
  'groups.files.documents.empty': 'Inga dokument ännu.',
  'groups.files.sort': 'Sortera dokument',
  'groups.files.sort.newest': 'Nyast',
  'groups.files.sort.name': 'Namn',
  'groups.files.view': 'Visa',
  'groups.files.download': 'Ladda ner',
  'groups.files.details': 'Detaljer',
  'groups.files.delete': 'Ta bort',
  'groups.files.action.view': 'Visning kommer snart.',
  'groups.files.action.download': 'Nedladdning blir tillgänglig snart.',
  'groups.files.action.details': '{name} · {size} KB',
  'groups.subscribe.saved_methods': 'Sparade betalmetoder',
  'groups.subscribe.saved_methods.loading': 'Laddar sparade metoder...',
  'groups.subscribe.saved_methods.none': 'Inga sparade betalmetoder hittades.',
  'groups.subscribe.saved_methods.use_other': 'Använd en annan metod',
  'groups.subscribe.saved_methods.default': 'Standard',
  'groups.subscribe.next_step.saved':
    'Nästa: vi använder din sparade metod och fortsätter till säker bekräftelse.',
  'groups.subscribe.next_step.vipps': 'Nästa: du fortsätter i Vipps för att bekräfta medlemskapet.',
  'groups.subscribe.next_step.card': 'Nästa: du fortsätter i Stripe för att bekräfta medlemskapet.',
  'groups.composer.placeholder': 'Dela något i rummet…',
  'groups.preview.author': 'Rumansvarig',
  'groups.preview.just_now': 'just nu',
  'groups.cta.post': 'Dela',
  'groups.join.toPost': 'Gå med i rummet för att dela.',
  'groups.see_comments': 'Se samtalet',
  'groups.comments.create_error': 'Kunde inte dela svaret.',
  'groups.comments.update_error': 'Kunde inte uppdatera svaret.',
  'groups.comments.delete_error': 'Kunde inte ta bort svaret.',
  'groups.comments.delete.confirm': 'Ta bort svaret?',
  'groups.comments.delete.title': 'Ta bort svar',
  'groups.comments.delete.body': 'Svaret tas bort från samtalet. Det går inte att ångra.',
  'groups.comments.placeholder': 'Skriv ett svar...',
  'groups.comments.empty': 'Inga svar ännu.',
  'groups.comments.post': 'Dela',
  'groups.hide_comments': 'Dölj samtalet',
  'groups.post.pending': 'Delar...',
  'groups.post.awaiting_approval': 'Väntar på godkännande',
  'groups.post.create_error': 'Kunde inte publicera inlägget. Försök igen.',
  'groups.post.update_error': 'Kunde inte uppdatera inlägget.',
  'groups.post.delete.confirm': 'Ta bort inlägget?',
  'groups.post.delete_error': 'Kunde inte ta bort inlägget.',
  'groups.post.delete.title': 'Ta bort inlägg',
  'groups.post.delete.body': 'Inlägget och dess svar tas bort från rummet. Det går inte att ångra.',
  'groups.post.share': 'Dela',
  'groups.post.share_success': 'Länken till inlägget har kopierats.',
  'groups.post.share_error': 'Det gick inte att dela inlägget.',
  'groups.day.today': 'Idag',
  'groups.day.yesterday': 'Igår',
  'groups.day.unknown': 'Tidigare',
  'groups.tabs.members': 'De som är med',
  'groups.tabs.requests': 'Förfrågningar',
  'groups.tabs.settings': 'Inställningar',
  'groups.invite.sent': 'Inbjudan skickad.',
  'groups.banner.subscribe': 'Gå med i rummet',
  'groups.subscribe.title': 'Gå med i rummet',
  'groups.subscribe.header': 'Gå med i rummet',
  'groups.subscribe.cta': 'Gå med i rummet',
  'groups.subscribe.success': 'Tillgången är aktiv. Du är nu med i rummet.',
  'groups.framework.title': 'Så fungerar Rum',
  'groups.framework.subtitle': 'Nätgrav-ramen gäller för alla rum.',
  'groups.framework.principle_1.title': 'Värdighet',
  'groups.framework.principle_1.body':
    'Vi möter varandra med respekt. Ingen rangordning. Inga angrepp.',
  'groups.framework.principle_2.title': 'Mänsklighet',
  'groups.framework.principle_2.body':
    'Vi skriver som människor. Inte som roller. Inte som varumärken.',
  'groups.framework.principle_3.title': 'Stillhet',
  'groups.framework.principle_3.body': 'Stillhet är tillåten. Ingen förväntan på svar.',
  'groups.framework.principle_4.title': 'Ansvar',
  'groups.framework.principle_4.body':
    'Rumansvarig håller rummet tryggt, men äger det inte som makt.',
  'groups.suggested_members': 'Förslag på vem du kan bjuda in',
  'groups.paid.why.body':
    'Rum ger människor möjlighet att använda sin erfarenhet och kunskap för att stötta andra och få hållbarhet i det arbetet.',
  'groups.subscribe.saved_method.invalid':
    'Sparad betalmetod är inte längre giltig. Välj en annan metod och försök igen.',
  'admin.group_moderation.approve': 'Godkänn',
  'admin.group_moderation.category.paid': 'Godkännande av betalt rum',
  'admin.group_moderation.category.report': 'Rapporterat rum',
  'admin.group_moderation.empty': '(Tom)',
  'admin.group_moderation.filter.all': 'Alla',
  'admin.group_moderation.filter.paid': 'Betalda godkännanden',
  'admin.group_moderation.filter.reports': 'Rapporter',
  'admin.group_moderation.filter.unread': 'Olästa',
  'admin.group_moderation.mark_read': 'Markera som läst',
  'admin.group_moderation.mark_unread': 'Markera alla som olästa',
  'admin.group_moderation.meta.group': 'Rom',
  'admin.group_moderation.meta.reason': 'Orsak',
  'admin.group_moderation.meta.reporter': 'Visselblåsare',
  'admin.group_moderation.note_placeholder': 'Valfri anmärkning (krävs vid avslag).',
  'admin.group_moderation.open_group': 'Öppna rum',
  'admin.group_moderation.refresh': 'Uppdatera',
  'admin.group_moderation.reject': 'Neka',
  'admin.group_moderation.reject_note_required': 'Lägg till en avslagsanteckning innan du avvisar.',
  'admin.group_moderation.resolution.at': 'Tid',
  'admin.group_moderation.resolution.by': 'AV',
  'admin.group_moderation.resolution.note': 'Notering',
  'admin.group_moderation.resolution.placeholder': 'Lösningsanteckning (valfritt).',
  'admin.group_moderation.search': 'Sök efter rum, orsak eller aviseringar',
  'admin.group_moderation.state.pending': 'Vilande',
  'admin.group_moderation.state.resolved': 'Löst',
  'admin.group_moderation.subtitle': 'Hantera rapporter och godkännanden för betalda rum.',
  'admin.group_moderation.summary.total': 'Totalt',
  'admin.group_moderation.summary.unread': 'Olästa',
  'admin.group_moderation.summary.visible': 'Synlig',
  'admin.group_moderation.nav': 'Rummoderering',
  'admin.group_moderation.title': 'Rummoderering',
  'create_group.intro': 'Öppna ett rum med en tydlig riktning.',
  'create_group.audience.label': 'Vem är det här rummet för?',
  'create_group.audience.placeholder': 'Beskriv vem som ska känna sig hemma i det här rummet.',
  'create_group.audience.required': 'Lägg till vem rummet är för.',
  'create_group.safety_intent.label': 'Hur vill du hålla rummet tryggt?',
  'create_group.safety_intent.placeholder': 'Skriv några rader om ton, gränser och omsorg.',
  'create_group.safety_intent.hint':
    'För din egen tydlighet när du öppnar rummet. Detta visas inte offentligt.',
  'create_group.life_category.grief': 'Sorg',
  'create_group.life_category.life_choices': 'Livsval',
  'create_group.life_category.relationships': 'Relationer',
  'create_group.life_category.health': 'Hälsa',
  'create_group.life_category.existence': 'Existens',
  'create_group.life_category.guidance': 'Vägledning',
  'create_group.life_category.other': 'Annat',
  'create_group.invite.info': 'Bjud in någon i rummet',
  'create_group.invite.sent_count': '{count} inbjudningar skickade',
  'create_group.tip.name': 'Ge rummet ett tydligt namn',
  'create_group.tip.visibility': 'Vem kan se rummet?',
  'create_group.visibility': 'Synlighet',
  'create_group.visibility.closed': 'Stängt rum',
  'create_group.visibility.closed_desc':
    'Rummet är synligt, men du måste bli inbjuden eller godkänd för att gå med.',
  'create_group.visibility.private': 'Privat rum',
  'create_group.visibility.private_desc':
    'Rummet är dolt för andra. Endast inbjudna medlemmar kan se och delta.',
  'create_group.visibility.public': 'Öppet rum',
  'groupDetails.confirm.remove.ok': 'Ta bort',
  'groupDetails.confirm.remove.title': 'Ta bort från rummet',
  'groupDetails.unavailable': 'Inte tillgänglig',
  'groups.about.empty': 'Ingen beskrivning',
  'groups.aria.invite_name': 'Bjud in {name}',
  'groups.banner.members': '{count, number} medlemmar · {posts, number} inlägg/dag',
  'groups.composer.helper': 'Dela några ord, en bild eller en video i rummet.',
  'groups.section.about.title': 'Om rummet',
  'groups.section.about.text': 'Se beskrivningen, ramarna och vem som håller rummet.',
  'groups.section.members.title': 'Personer i rummet',
  'groups.section.members.text': 'Se vilka som är med och bjud in fler när det passar.',
  'groups.section.files.title': 'Bilder, videor och dokument',
  'groups.section.files.text': 'Allt som delats i rummet, samlat på ett ställe.',
  'groups.section.requests.title': 'Väntande förfrågningar',
  'groups.section.requests.text': 'Granska medlems- och inläggsförfrågningar här.',
  'groups.section.settings.title': 'Rumsinställningar',
  'groups.section.settings.text': 'Justera synlighet, ramar och hur rummet fungerar.',
  'groups.tabs.mobile_nav': 'Rumssektion',
  phone_number: 'Telefonnummer',
  'groups.banner.members_only': '{count, number} medlemmar',
  'groups.banner.default_subtitle': 'Ett rum för lugna samtal.',
  'groups.banner.held_by': 'Hålls av {name}',
  'groups.comments.load_more': 'Visa fler ({0})',
  'groups.cta.invite': 'Bjud in',
  'groups.edit.name_required': 'Rumsnamn krävs.',
  'groups.edit.no_changes': 'Inga ändringar@ item',
  'groups.edit.save_error': 'Kunde inte spara rumsinformationen.',
  'groups.edit.saved': 'Rumsinformationen har sparats.',
  'groups.invite': 'Bjud in',
  'groups.invite.subtitle': 'Bjud in personer till det här rummet',
  'groups.invite.title': 'Bjud in medlemmar',
  'groups.join.request_sent': 'Begäran skickad. Väntar på godkännande.',
  'groups.joined': 'Du gick med i rummet.',
  'groups.quiet.cta': 'Sätt rummet till stilla',
  'groups.quiet.active': 'Rummet är stilla',
  'groups.quiet.confirm': 'Sätta detta rum till stilla för nu?',
  'groups.quiet.enabled': 'Rummet är nu stilla en stund.',
  'groups.quiet.notice': 'Rummet är stilla för nu.',
  'groups.members': 'De som är med',
  'groups.members.empty': 'Inga medlemmar ännu.',
  'groups.members.no_results': 'Inga medlemmar matchar din sökning.',
  'groups.members.actions': 'Medlemsåtgärder',
  'groups.members.owner_admin': 'Ägare/administratör',
  'groups.members.see_all': 'Se alla',
  'groups.mine.feed.empty': 'Inga samtal ännu.',
  'groups.mine.feed.sub': 'Nya inlägg från rum du är en del av.',
  'groups.mine.feed.title': 'Senaste aktivitet',
  'groups.paid.approval.approve': 'Godkänn',
  'groups.paid.approval.approved': 'Godkänt betalt rum.',
  'groups.paid.approval.note_placeholder': 'Anteckning (visas för rumsansvarig/administratör).',
  'groups.paid.approval.reject': 'Neka',
  'groups.paid.approval.reject_note': 'Lägg först till en avslagsanteckning.',
  'groups.paid.approval.rejected': 'Betalt rum avböjt.',
  'groups.paid.approval.request': 'Begär en granskning',
  'groups.paid.approval.requested': 'Betyg för betalt rum har skickats.',
  'groups.paid.awaiting_approval': 'Väntar på godkännande',
  'groups.paid.connect_cta': 'Anslut till betalningar',
  'groups.paid.connect_hint': 'Anslut till betalningar för att aktivera betalt utrymme.',
  'groups.paid.connect_required': 'Anslut till betalningar innan du aktiverar betalt utrymme.',
  'groups.paid.details.audience': 'Målgrupp',
  'groups.paid.details.audience.hint': 'Vem är det här rummet för?',
  'groups.paid.details.audience.placeholder':
    'För personer som vill ha strukturerat stöd och veckovis uppföljning.',
  'groups.paid.details.benefits': 'Fördelardosa',
  'groups.paid.details.benefits.hint': 'Vad får medlemmarna?',
  'groups.paid.details.benefits.placeholder':
    'Månatliga livesändningar, praktiska övningar, direkt feedback...',
  'groups.paid.details.refund': 'Återbetalning',
  'groups.paid.details.refund.hint': 'Beskriv återbetalningspolicyer',
  'groups.paid.details.refund.placeholder':
    'Avslutas när som helst. Åtkomsten gäller under den betalda perioden.',
  'groups.paid.details.title': 'Information om betalda rum',
  'groups.paid.details_required':
    'Lägg till medlemsförmåner och vem rummet är för innan du skapar ett betalt rum.',
  'groups.paid.enabled_hint': 'Sätt ett månadspris från {min} till {max} NOK.',
  'groups.paid.enabled_hint_currency': 'Sätt ett månadspris från {min} till {max} {currency}.',
  'groups.paid.onboarding_note': 'Betalda rum blir synliga efter godkännande.',
  'groups.paid.preview.net': 'Nät till rumsansvarig',
  'groups.paid.preview.platform': 'Netto gravandel',
  'groups.paid.preview.price': 'Pris',
  'groups.paid.preview.stripe': 'Stripe-avgift',
  'groups.paid.preview.title': 'Prisöversikt',
  'groups.paid.price_range': 'Priset måste vara mellan {min} och {max} NOK.',
  'groups.paid.price_range_currency': 'Priset måste vara mellan {min} och {max} {currency}.',
  'groups.paid.why.cta': 'Läs mer om betalda rum',
  'groups.paid.why.point_1': 'Sätt ett månadspris som passar din målgrupp.',
  'groups.paid.why.point_2': 'Ge medlemmarna tydliga förmåner och uppföljning.',
  'groups.paid.why.point_3': 'Gör säkra betalningar med Vipps eller kort.',
  'groups.paid.why.title': 'Varför betalda rum?',
  'groups.payout_mode': 'Utbetalningsläge',
  'groups.payout_mode.automatic': 'Automatiskt via Stripe',
  'groups.payout_mode.automatic.hint':
    'Kräver Stripe Connect. Utbetalning sker automatiskt till ditt konto.',
  'groups.payout_mode.manual': 'Manuellt via Nätgrav',
  'groups.payout_mode.manual.hint':
    'Du behöver inte Stripe. Nätgrav tar emot betalning och betalar ut månadsvis.',
  'groups.photos.recent': 'Nyligen publicerade foton',
  'groups.photos.see_all': 'Se alla',
  'groups.photos.add': 'Lägg till bild',
  'groups.photos.loading': 'Laddar bilder...',
  'groups.photos.load_error': 'Kunde inte ladda bilderna.',
  'groups.photos.empty': 'Inga bilder har delats ännu.',
  'groups.invite.search_label': 'Sök efter personer',
  'groups.invite.search_hint': 'Skriv minst två tecken för att söka.',
  'groups.invite.searching': 'Söker...',
  'groups.invite.no_results': 'Inga personer hittades.',
  'groups.post.upload_error': 'Kunde inte ladda upp media. Försök igen.',
  'groups.posting': 'Inlägg',
  'groups.report.cta': 'Rapporter',
  'groups.report.details': 'Detaljer (valfritt)',
  'groups.report.details.placeholder':
    'Lägg till kontext som hjälper administratören att bedöma snabbt.',
  'groups.report.reason': 'Orsak',
  'groups.report.reason.abuse': 'Trakasserier eller övergrepp',
  'groups.report.reason.illegal': 'Olagligt innehåll',
  'groups.report.reason.other': 'Annat',
  'groups.report.reason.spam': 'Spam eller bedrägeri',
  'groups.report.submit': 'Skicka rapport',
  'groups.report.success': 'Tack. Din rapport har mottagits.',
  'groups.report.title': 'Rapportera rum',
  'groups.post.report': 'Rapportera inlägg',
  'groups.post.report.title': 'Rapportera inlägg',
  'groups.requests.action_error': 'Kunde inte uppdatera begäran.',
  'groups.requests.confirm': 'Godkänn',
  'groups.requests.decline': 'Neka',
  'groups.requests.member_empty': 'Inga medlemsförfrågningar.',
  'groups.requests.member_title': 'Medlemsförfrågningar',
  'groups.requests.post_empty': 'Inga inlägg väntar på godkännande.',
  'groups.requests.post_title': 'Förfrågningar om inlägg',
  'groups.requests.load_error.title': 'Det gick inte att läsa in förfrågningarna',
  'groups.requests.load_error.text': 'Försök igen om en stund.',
  'groups.requests.retry': 'Försök igen',
  'groups.requests.member.requested': 'Begärde åtkomst {time}',
  'groups.requests.attachment': 'Öppna bilaga',
  'groups.requests.member.approve_success': 'Medlemsförfrågan har godkänts.',
  'groups.requests.member.decline_success': 'Medlemsförfrågan har avslagits.',
  'groups.requests.post.approve_success': 'Inlägget har godkänts.',
  'groups.requests.post.decline_success': 'Inlägget har avslagits.',
  'groups.requests.member.decline_title': 'Avslå medlemsförfrågan?',
  'groups.requests.post.decline_title': 'Avslå inlägget?',
  'groups.requests.member.decline_text': 'Förfrågan från {name} kommer att avslås.',
  'groups.requests.post.decline_text': 'Inlägget från {name} kommer inte att publiceras.',
  'groups.read_more': 'Läs mer',
  'groups.show_less': 'Visa mindre',
  'groups.rules': 'Regler',
  'groups.settings.chat.admins': 'Endast administratör',
  'groups.settings.chat.members': 'Medlemmar och administratörer',
  'groups.settings.chat_permissions': 'Behörigheter för rumschatt',
  'groups.settings.chat.readonly_note': 'Behörigheter för rumschatt är fasta i denna version.',
  'groups.settings.membership.admins': 'Endast rumsansvarig och medansvariga',
  'groups.settings.membership.anyone': 'Alla i rummet',
  'groups.settings.membership_approval': 'Godkännande av medlemskap',
  'groups.settings.membership.readonly_note':
    'Godkännande av medlemskap följer rummets synlighet och inbjudningsflöde.',
  'groups.settings.post_approval': 'Godkännande efter inlägg',
  'groups.settings.post_approval.none': 'Inget godkännande',
  'groups.settings.post_approval.require': 'Alla inlägg måste godkännas.',
  'groups.settings.posting.admins': 'Endast administratör',
  'groups.settings.posting.anyone': 'Alla i rummet',
  'groups.settings.posting_permissions': 'Publiceringsrättigheter',
  'groups.settings.privacy': 'Integritet',
  'groups.settings.cover': 'Rumsbild',
  'groups.settings.cover.empty': 'Ingen rumsbild ännu.',
  'groups.settings.cover.upload': 'Ladda upp rumsbild',
  'groups.settings.cover.remove': 'Ta bort rumsbild',
  'groups.settings.cover.instant_save': 'Ändringar av rumsbild sparas direkt.',
  'groups.settings.cover.upload_success': 'Rumsbilden har uppdaterats.',
  'groups.settings.cover.upload_error': 'Kunde inte ladda upp rumsbild.',
  'groups.settings.cover.remove_success': 'Rumsbilden har tagits bort.',
  'groups.settings.cover.remove_error': 'Kunde inte ta bort rumsbild.',
  'groups.settings.save_error': 'Kunde inte spara inställningarna.',
  'groups.settings.saved': 'Inställningarna är sparade.',
  'groups.settings.room_status': 'Rumsstatus',
  'groups.settings.room_status.active': 'Rummet är aktivt.',
  'groups.settings.unsaved.confirm':
    'Du har osparade ändringar. Vill du lämna sidan utan att spara?',
  'groups.settings.categories.loading': 'Laddar kategorier...',
  'groups.settings.categories.empty': 'Inga kategorier är tillgängliga.',
  'groups.settings.categories.error': 'Kunde inte ladda kategorierna.',
  'groups.settings.categories.retry': 'Försök igen',
  'groups.settings.current_rules': 'Så fungerar rummet',
  'groups.settings.current_rules.hint': 'En översikt över reglerna som gäller i rummet nu.',
  'groups.settings.membership.public': 'Alla kan gå med',
  'groups.settings.membership.closed': 'Rumsansvariga godkänner förfrågningar',
  'groups.settings.membership.private': 'Endast via inbjudan',
  'groups.quiet.reactivate': 'Gör rummet aktivt',
  'groups.quiet.reactivate_confirm': 'Vill du göra rummet aktivt igen?',
  'groups.quiet.disabled': 'Rummet är aktivt igen.',
  'groups.quiet.update_error': 'Kunde inte uppdatera rummets status.',
  'groups.subscribe.benefit_1': 'Exklusivt innehåll och uppföljning',
  'groups.subscribe.benefit_2': 'Tryggt samhälle med tydliga gränser',
  'groups.subscribe.benefit_3': 'Direkt stöd från chefer och handledare',
  'groups.subscribe.breakdown': 'Prisfördelning',
  'groups.subscribe.card': 'Kort',
  'groups.subscribe.monthly': 'Per månad',
  'create_group.paid_price_currency': 'Månadspris ({currency})',
  'groups.subscribe.pending': 'Betalningen slutförs. Uppdatera om en stund.',
  'groups.subscribe.total': 'Totalt',
  'groups.subscribe.local_estimate': 'Ca. {amount} i lokal valuta.',
  'groups.subscribe.cancel.cta': 'Avsluta deltagande',
  'groups.subscribe.cancel.success': 'Du är inte längre med i rummet.',
  'groups.subscribe.vipps_info': 'Du bekräftar betalningen säkert i Vipps.',
  'groups.subscribe.vipps_currency_note': 'Betalning via Vipps debiteras i NOK.',
  'groups.subscribe.vipps_unavailable_currency':
    'Vipps är inte tillgängligt för den här valutan. Välj kort.',
  'groups.tabs.about': 'Om',
  'groups.tabs.files': 'Filer',
  'groups.time.2h': 'för ett ögonblick sedan',
  'messenger_v2.brand.title': 'End of Time',
  'messenger_v2.brand.beta': 'Beta',
  'messenger_v2.brand.tagline': 'En plats för sanning. Alltid.',
  'messenger_v2.conversation.title': 'Konversationer',
  'messenger_v2.encryption.title': 'Totalsträckskrypterad',
  'messenger_v2.encryption.copy': 'Dina ord stannar mellan er.',
  'messenger_v2.encryption.learn_more': 'Läs mer',
  'messenger_v2.presence.active_now': 'Aktiv nu',
  'messenger_v2.composer.truth_placeholder': 'Vad är sant just nu?',
  'messenger_v2.message.reaction_failed': 'Det gick inte att uppdatera reaktionen.',
  'messenger_v2.message.actions': 'Meddelandeåtgärder',
  'messenger_v2.message.react_with': 'Reagera med {emoji}',
  'messenger_v2.message.reaction_count': '{emoji}, {count} reaktioner',
  'messenger_v2.message.commands': 'Meddelandekommandon',
  'messenger_v2.message.reactions': 'Reaktioner',
  'messenger_v2.message.reaction_all': 'Alla',
  'messenger_v2.message.reaction_details': 'Reaktionsdetaljer',
  'messenger_v2.message.reaction_filters': 'Reaktionsfilter',
  'messenger_v2.message.reaction_people_unavailable':
    'Reaktionsdetaljer är inte tillgängliga för det här meddelandet.',
  'messenger_v2.message.click_to_remove': 'Klicka för att ta bort',
  'messenger_v2.message.history_loading': 'Läser in tidigare meddelanden.',
  'messenger_v2.attachment.select': 'Välj {name}',
  'messenger_v2.search.placeholder': 'Sök eller starta en konversation',
  'messenger_v2.search.groups_placeholder': 'Sök grupper',
  'messenger_v2.tabs.aria': 'Meddelandesektioner',
  'messenger_v2.tabs.direct': 'Meddelanden',
  'messenger_v2.tabs.groups': 'Grupper',
  'messenger_v2.groups.add_action': 'Lägg till',
  'messenger_v2.groups.add_members': 'Lägg till medlemmar',
  'messenger_v2.groups.add_members_short': 'Lägg till',
  'messenger_v2.groups.add_members_title': 'Lägg till medlemmar',
  'messenger_v2.groups.add_description': 'Lägg till gruppbeskrivning',
  'messenger_v2.groups.contacts_loading': 'Kontakter laddas.',
  'messenger_v2.groups.create': 'Skapa grupp',
  'messenger_v2.groups.create_action': 'Skapa',
  'messenger_v2.groups.create_category_required': 'Gruppkategori är inte tillgänglig ännu.',
  'messenger_v2.groups.create_name_required': 'Gruppnamn krävs.',
  'messenger_v2.groups.create_new_group': 'Skapa ny grupp',
  'messenger_v2.groups.create_success': 'Grupp skapad.',
  'messenger_v2.groups.create_title': 'Skapa grupp',
  'messenger_v2.groups.description_label': 'Beskrivning',
  'messenger_v2.groups.description_placeholder': 'Valfritt',
  'messenger_v2.groups.details_updated': 'Gruppinformationen har uppdaterats.',
  'messenger_v2.groups.edit_description': 'Redigera gruppbeskrivning',
  'messenger_v2.groups.edit_group_picture': 'Redigera gruppbild',
  'messenger_v2.groups.edit_name': 'Redigera gruppnamn',
  'messenger_v2.groups.empty': 'Inga grupper matchade din sökning.',
  'messenger_v2.groups.error': 'Grupper kunde inte laddas.',
  'messenger_v2.groups.fallback': 'Grupp',
  'messenger_v2.groups.choose_photo': 'Välj foto',
  'messenger_v2.groups.delete_photo': 'Ta bort foto',
  'messenger_v2.groups.deleting_photo': 'Tar bort foto...',
  'messenger_v2.groups.uploading_photo': 'Laddar upp...',
  'messenger_v2.groups.avatar_crop_failed': 'Bilden kunde inte beskäras.',
  'messenger_v2.groups.avatar_read_failed': 'Bilden kunde inte öppnas.',
  'messenger_v2.groups.avatar_owner_only': 'Endast gruppskaparen kan uppdatera gruppbilden.',
  'messenger_v2.groups.avatar_updated': 'Gruppbilden har uppdaterats.',
  'messenger_v2.groups.avatar_update_failed': 'Gruppbilden kunde inte uppdateras.',
  'messenger_v2.groups.avatar_deleted': 'Gruppbilden har tagits bort.',
  'messenger_v2.groups.avatar_delete_failed': 'Gruppbilden kunde inte tas bort.',
  'messenger_v2.groups.loading': 'Grupper laddas.',
  'messenger_v2.groups.members_added': 'Medlemmar tillagda.',
  'messenger_v2.groups.update_failed': 'Gruppinformationen kunde inte uppdateras.',
  'messenger_v2.groups.members_count': '{count} medlemmar',
  'messenger_v2.groups.members_label': 'Medlemmar',
  'messenger_v2.groups.leave_group': 'Lämna',
  'messenger_v2.groups.exit_group': 'Lämna grupp',
  'messenger_v2.groups.exit_group_title': 'Lämna grupp: "{name}"?',
  'messenger_v2.groups.exit_group_notice':
    'Endast administratörer meddelas när du lämnar en grupp.',
  'messenger_v2.groups.exit_and_delete_for_me': 'Lämna och ta bort för mig',
  'messenger_v2.groups.delete_group': 'Ta bort grupp',
  'messenger_v2.groups.deleting_group': 'Tar bort grupp...',
  'messenger_v2.groups.delete_group_title': 'Ta bort grupp "{name}"?',
  'messenger_v2.groups.delete_group_warning_body':
    'Den här gruppen tas bort från din chattlista och din lokala historik rensas.',
  'messenger_v2.groups.group_deleted': 'Gruppen togs bort från din chattlista.',
  'messenger_v2.groups.delete_group_failed': 'Gruppen kunde inte tas bort.',
  'messenger_v2.groups.exiting_group': 'Lämnar grupp...',
  'messenger_v2.groups.left_group': 'Du lämnade gruppen.',
  'messenger_v2.groups.left_group_notice':
    'Du lämnade den här gruppen. Du kan se tidigare meddelanden, men du kan inte skicka nya meddelanden.',
  'messenger_v2.groups.member_removed': '{name} togs bort från gruppen.',
  'messenger_v2.groups.member_remove_failed': 'Medlemmen kunde inte tas bort.',
  'messenger_v2.groups.remove_member': 'Ta bort',
  'messenger_v2.groups.removed_notice':
    '{actor} tog bort dig från den här gruppen. Du kan se tidigare meddelanden, men du kan inte skicka nya meddelanden.',
  'messenger_v2.groups.access_removed_notice':
    'Du är inte längre medlem i den här gruppen. Du kan se tidigare meddelanden, men du kan inte skicka nya meddelanden.',
  'messenger_v2.groups.removing_member': 'Tar bort...',
  'messenger_v2.groups.name_label': 'Namn',
  'messenger_v2.groups.name_placeholder': 'Familjeuppdateringar',
  'messenger_v2.groups.no_contacts': 'Inga kontakter tillgängliga.',
  'messenger_v2.groups.no_contacts_to_add': 'Inga kontakter tillgängliga att lägga till.',
  'messenger_v2.groups.no_messages': 'Inga meddelanden ännu',
  'messenger_v2.groups.save_failed': 'Gruppen kunde inte sparas.',
  'messenger_v2.groups.saving': 'Sparar...',
  'messenger_v2.groups.select_member_required': 'Välj minst en medlem.',
  'messenger_v2.groups.selected_count': '{count} valda',
  'messenger_v2.groups.selected_fraction': '{selected}/{total}',
  'messenger_v2.groups.search_name_or_number': 'Sök efter namn eller nummer',
  'messenger_v2.groups.members_can_add': 'Alla medlemmar kan lägga till andra i den här gruppen.',
  'messenger_v2.groups.edit_group_permissions': 'Redigera gruppbehörigheter.',
  'messenger_v2.groups.group_permissions': 'Gruppbehörigheter',
  'messenger_v2.groups.invite_via_link': 'Bjud in via länk',
  'messenger_v2.groups.invite_via_link_qr': 'Bjud in via länk eller QR-kod',
  'messenger_v2.groups.frequently_contacted': 'Ofta kontaktade',
  'messenger_v2.groups.scroll_more_contacts': 'Rulla för att ladda fler',
  'messenger_v2.groups.remove_selected_member': 'Ta bort {name}',
  'messenger_v2.groups.group_link': 'Grupplänk',
  'messenger_v2.groups.group_chat_invite': 'Gruppchattinbjudan',
  'messenger_v2.groups.open_invite_link': 'Öppna den här länken för att gå med i {name}.',
  'messenger_v2.groups.join_group': 'Gå med i grupp',
  'messenger_v2.groups.invite_link_checking': 'Kontrollerar länken...',
  'messenger_v2.groups.invite_link_expired': 'Länken har gått ut',
  'messenger_v2.groups.invite_link_unavailable': 'Gruppen är inte tillgänglig',
  'messenger_v2.groups.invite_link_full': 'Gruppen är full',
  'messenger_v2.groups.invite_link_status_expired': 'Den här inbjudningslänken har gått ut.',
  'messenger_v2.groups.invite_link_status_unavailable':
    'Den här gruppinbjudan är inte längre tillgänglig.',
  'messenger_v2.groups.invite_link_status_full': 'Den här gruppen är full.',
  'messenger_v2.groups.view_group': 'Visa grupp',
  'messenger_v2.groups.invite_link_loading': 'Laddar länk...',
  'messenger_v2.groups.invite_link_copied': 'Inbjudningslänk kopierad.',
  'messenger_v2.groups.invite_link_copy_failed': 'Inbjudningslänken kunde inte kopieras.',
  'messenger_v2.groups.invite_link_failed': 'Inbjudningslänken kunde inte laddas.',
  'messenger_v2.groups.invite_share_text': 'Gå med i {name}',
  'messenger_v2.groups.invite_share_text_with_link': 'Gå med i {name}: {url}',
  'messenger_v2.groups.share_via_chat': 'Dela via chatt',
  'messenger_v2.groups.send_to': 'Skicka till',
  'messenger_v2.groups.send_action': 'Skicka',
  'messenger_v2.groups.select_chat_recipients': 'Välj chattar',
  'messenger_v2.groups.invite_link_sent': 'Inbjudningslänk skickad.',
  'messenger_v2.groups.invite_link_send_failed': 'Inbjudningslänken kunde inte skickas.',
  'messenger_v2.groups.share_link': 'Dela länk',
  'messenger_v2.groups.share_link_short': 'Dela',
  'messenger_v2.groups.copy_link': 'Kopiera länk',
  'messenger_v2.groups.qr_code': 'QR-kod',
  'messenger_v2.groups.manage_permissions': 'Hantera behörigheter',
  'messenger_v2.groups.invite_approval_not_required':
    'Administratörsgodkännande krävs inte för att gå med. Medlemmar har tillgång till den här länken här.',
  'messenger_v2.groups.permissions_members_can': 'Medlemmar kan',
  'messenger_v2.groups.permission_edit_settings': 'Redigera gruppinställningar',
  'messenger_v2.groups.permission_edit_settings_desc':
    'Detta inkluderar gruppens namn, ikon, beskrivning och avancerad chattintegritet.',
  'messenger_v2.groups.permission_send_messages': 'Skicka nya meddelanden',
  'messenger_v2.groups.permission_add_members': 'Lägga till andra medlemmar',
  'messenger_v2.groups.permission_send_history': 'Skicka meddelandehistorik',
  'messenger_v2.groups.permission_send_history_desc':
    'Tillåt medlemmar att skicka tidigare meddelanden till nya medlemmar.',
  'messenger_v2.groups.permission_invite_link': 'Bjuda in via länk',
  'messenger_v2.groups.permissions_turning_off_hint':
    'När dessa inställningar stängs av kan bara gruppadministratörer utföra åtgärden.',
  'messenger_v2.groups.permissions_admins_can': 'Administratörer kan',
  'messenger_v2.groups.permission_approve_new_members': 'Godkänna nya medlemmar',
  'messenger_v2.groups.permission_approve_new_members_desc':
    'När detta är på måste administratörer godkänna alla som vill gå med i gruppen.',
  'messenger_v2.groups.group_admins': 'Gruppadministratörer',
  'messenger_v2.groups.edit_admins': 'Redigera administratörer',
  'messenger_v2.groups.admin': 'Admin',
  'messenger_v2.groups.available_member': 'Tillgänglig medlem',
  'messenger_v2.groups.make_group_admin': 'Gör till gruppadministratör',
  'messenger_v2.groups.dismiss_as_admin': 'Ta bort som administratör',
  'messenger_v2.groups.remove_from_group': 'Ta bort från grupp',
  'messenger_v2.groups.no_members_to_manage': 'Inga medlemmar att hantera.',
  'messenger_v2.groups.admins_updated': 'Gruppadministratörer uppdaterade.',
  'messenger_v2.groups.admin_update_failed': 'Administratörsrollen kunde inte uppdateras.',
  'messenger_v2.groups.member_made_admin': '{name} är nu gruppadministratör.',
  'messenger_v2.groups.member_dismissed_admin': '{name} är inte längre gruppadministratör.',
  'messenger_v2.groups.permissions_updated': 'Gruppbehörigheter uppdaterade.',
  'messenger_v2.groups.permissions_update_failed': 'Gruppbehörigheter kunde inte uppdateras.',
  'messenger_v2.groups.no_longer_member_status': 'Inte längre medlem',
  'messenger_v2.info.member_options': 'Medlemsalternativ',
  'messenger_v2.common.search': 'Sök',
  'messenger_v2.conversation.group_fallback': 'Gruppkonversation',
  'messenger_v2.conversation.direct_fallback': 'Direktkonversation',
  'messenger_v2.conversation.new_message': 'Nytt meddelande',
  'messenger_v2.conversation.no_content': 'Inget innehåll',
  'messenger_v2.conversation.connection': 'Kontakt',
  'messenger_v2.conversation.connections': 'Kontakter',
  'messenger_v2.conversation.open': 'Öppna',
  'messenger_v2.conversation.open_failed': 'Konversationen kunde inte öppnas.',
  'messenger_v2.conversation.opening': 'Öppnar...',
  'messenger_v2.conversation.contacts_loading': 'Kontakter laddas.',
  'messenger_v2.conversation.no_contacts_matched': 'Inga kontakter matchade din sökning.',
  'messenger_v2.conversation.bootstrap_loading': 'Messenger startar.',
  'messenger_v2.conversation.none_yet': 'Inga konversationer ännu. Starta en från kontaktlistan.',
  'messenger_v2.conversation.select_title': 'Välj en konversation',
  'messenger_v2.conversation.select_copy':
    'Öppna en tråd från vänster sida eller starta en ny konversation med plusknappen.',
  'messenger_v2.conversation.show_contacts': 'Visa kontakter',
  'messenger_v2.conversation.show_conversations': 'Visa konversationer',
  'messenger_v2.presence.offline': 'Frånkopplad',
  'messenger_v2.presence.online': 'Uppkopplad',
  'messenger_v2.presence.ready': 'Redo',
  'messenger_v2.presence.not_ready_yet': 'Inte redo än',
  'messenger_v2.presence.group_online': '{onlineCount} av {totalCount} är uppkopplade',
  'messenger_v2.presence.last_seen_today_at': 'Senast sedd idag kl. {time}',
  'messenger_v2.presence.last_seen_yesterday_at': 'Senast sedd igår kl. {time}',
  'messenger_v2.presence.last_seen_date_at': 'Senast sedd {date} kl. {time}',
  'messenger_v2.timeline.today': 'Idag',
  'messenger_v2.timeline.yesterday': 'Igår',
  'messenger_v2.message.edited': 'Redigerad',
  'messenger_v2.message.edited_time': 'Redigerad {time}',
  'messenger_v2.message.read_more': 'Läs mer',
  'messenger_v2.message.show_less': 'Visa mindre',
  'messenger_v2.message.upload_failed': 'Uppladdning misslyckades',
  'messenger_v2.message.preparing_upload': 'Förbereder…',
  'messenger_v2.message.upload_progress': 'Laddar upp {progress} %',
  'messenger_v2.message.upload_paused_progress': 'Uppladdning pausad vid {progress} %',
  'messenger_v2.message.retry_upload': 'Försök ladda upp igen',
  'messenger_v2.message.retry_send': 'Försök skicka meddelandet igen',
  'messenger_v2.message.retry_reaction': 'Försök skicka reaktionen igen',
  'messenger_v2.message.retry_failed': 'Meddelandet kunde inte skickas. Försök igen.',
  'messenger_v2.message.reaction_retry_failed': 'Reaktionen kunde inte skickas. Försök igen.',
  'messenger_v2.message.pause_upload': 'Pausa uppladdning',
  'messenger_v2.message.pause': 'Pausa',
  'messenger_v2.message.resume_upload': 'Fortsätt uppladdning',
  'messenger_v2.message.resume': 'Fortsätt',
  'messenger_v2.attachment.upload_paused': 'Uppladdning pausad: {name}',
  'messenger_v2.message.failed': 'Misslyckades',
  'messenger_v2.message.read': 'Läst',
  'messenger_v2.message.delivered': 'Levererat',
  'messenger_v2.message.sent': 'Skickat',
  'messenger_v2.message.delete': 'Ta bort meddelande',
  'messenger_v2.message.delete_title': 'Ta bort meddelande?',
  'messenger_v2.message.delete_from': 'Ta bort meddelande från {name}?',
  'messenger_v2.message.delete_everyone': 'Ta bort för alla',
  'messenger_v2.message.delete_me': 'Ta bort för mig',
  'messenger_v2.message.copy': 'Kopiera meddelande',
  'messenger_v2.attachment.copy': 'Kopiera bilaga',
  'messenger_v2.clipboard.copied': 'Kopierat',
  'messenger_v2.clipboard.retry': 'Försök igen',
  'messenger_v2.message.edit': 'Redigera meddelande',
  'messenger_v2.message.clear_selection': 'Rensa markering',
  'messenger_v2.message.open_menu': 'Öppna meddelandemeny',
  'messenger_v2.message.scroll_latest': 'Rulla till senaste meddelandet',
  'messenger_v2.message.thread_loading': 'Trådhistorik laddas.',
  'messenger_v2.conversation.unavailable_title': 'Konversationen är inte tillgänglig',
  'messenger_v2.conversation.unavailable_copy':
    'Du har inte längre åtkomst till den här konversationen.',
  'messenger_v2.message.thread_empty': 'Inga meddelanden har laddats i denna tråd ännu.',
  'messenger_v2.message.thread': 'Konversationstråd',
  'messenger_v2.message.timeline': 'Meddelanden i konversationen',
  'messenger_v2.message.encrypted_pending':
    'Krypterat MLS-meddelande väntar på att runtime ska bli redo.',
  'messenger_v2.message.edit_resolve_error':
    'Det gick inte att hitta meddelandet som redigeras. Öppna redigeringsläget igen och försök igen.',
  'messenger_v2.message.reply': 'Svara',
  'messenger_v2.message.forward': 'Vidarebefordra',
  'messenger_v2.message.forwarded': 'Vidarebefordrat',
  'messenger_v2.forward.title': 'Vidarebefordra till',
  'messenger_v2.forward.preview_label': 'Vidarebefordrar',
  'messenger_v2.forward.message_preview': 'Meddelande',
  'messenger_v2.forward.search': 'Sök chattar och kontakter',
  'messenger_v2.forward.add_message': 'Lägg till ett meddelande',
  'messenger_v2.forward.add_message_placeholder': 'Lägg till ett meddelande...',
  'messenger_v2.forward.selected': 'Vald',
  'messenger_v2.forward.not_selected': 'Inte vald',
  'messenger_v2.forward.loading': 'Läser in chattar och kontakter...',
  'messenger_v2.forward.chats': 'Chattar',
  'messenger_v2.forward.connections': 'Kontakter',
  'messenger_v2.forward.no_targets': 'Inga chattar eller kontakter hittades.',
  'messenger_v2.forward.loading_message': 'Läser in meddelande...',
  'messenger_v2.forward.message_unavailable': 'Det här meddelandet är inte tillgängligt.',
  'messenger_v2.forward.send_failed': 'Meddelandet kunde inte vidarebefordras.',
  'messenger_v2.forward.unavailable': 'Det här meddelandet kan inte vidarebefordras ännu.',
  'messenger_v2.forward.sending_progress': 'Skickar {completed} av {total}',
  'messenger_v2.forward.failed_count': '{count} misslyckades',
  'messenger_v2.forward.selected_count': '{count} valda',
  'messenger_v2.forward.retry_failed': 'Försök igen',
  'messenger_v2.forward.sent_count': 'Vidarebefordrat till {count} chattar.',
  'messenger_v2.message.react': 'Reagera',
  'messenger_v2.message.cancel_reply': 'Avbryt svar',
  'messenger_v2.message.open_replied_message': 'Öppna besvarat meddelande',
  'messenger_v2.reply.photo': 'Bild',
  'messenger_v2.reply.photos_count': '{count} bilder',
  'messenger_v2.reply.video': 'Video',
  'messenger_v2.reply.videos_count': '{count} videor',
  'messenger_v2.reply.audio': 'Ljud',
  'messenger_v2.reply.media_count': '{count} medier',
  'messenger_v2.reply.pages_count': '{count} sidor',
  'messenger_v2.common.cancel': 'Avbryt',
  'messenger_v2.common.back': 'Tillbaka',
  'messenger_v2.common.close': 'Stäng',
  'messenger_v2.common.done': 'Klar',
  'messenger_v2.common.save': 'Spara',
  'messenger_v2.common.someone': 'Någon',
  'messenger_v2.common.you': 'Du',
  'messenger_v2.common.messenger': 'Messenger',
  'messenger_v2.chat.back': 'Tillbaka till konversationer',
  'messenger_v2.chat.more': 'Mer',
  'messenger_v2.chat.more_actions': 'Fler åtgärder',
  'messenger_v2.notifications.enabled': 'Skrivbordsaviseringar aktiverade',
  'messenger_v2.notifications.enabled_message': 'Skrivbordsaviseringar är aktiverade.',
  'messenger_v2.notifications.reaction_body': 'Reagerade med {emoji} på ditt meddelande.',
  'messenger_v2.conversation.reaction_preview': 'Reagerade {emoji} på ”{message}”',
  'messenger_v2.conversation.reaction_preview_unknown': 'Reagerade {emoji} på ett meddelande',
  'messenger_v2.notifications.reaction_body_with_preview':
    'Reagerade med {emoji} på ditt meddelande: “{message}”',
  'messenger_v2.notifications.blocked': 'Skrivbordsaviseringar blockerade',
  'messenger_v2.notifications.blocked_message':
    'Skrivbordsaviseringar är blockerade i webbläsarens inställningar.',
  'messenger_v2.notifications.unsupported':
    'Skrivbordsaviseringar stöds inte i den här webbläsaren.',
  'messenger_v2.notifications.enable': 'Aktivera skrivbordsaviseringar',
  'messenger_v2.typing.preview': 'Skriver...',
  'messenger_v2.typing.preview_named': '{name} skriver...',
  'messenger_v2.typing.aria': '{name} skriver',
  'messenger_v2.info.open': 'Öppna chattinfo',
  'messenger_v2.info.title': 'Chattinfo',
  'messenger_v2.info.close': 'Stäng chattinfo',
  'messenger_v2.info.contact': 'Kontakt',
  'messenger_v2.info.creator': 'Skapare',
  'messenger_v2.info.direct_chat': 'Direktchatt',
  'messenger_v2.info.message_action': 'Meddelande',
  'messenger_v2.info.block': 'Blockera',
  'messenger_v2.info.block_failed': 'Användaren kunde inte blockeras.',
  'messenger_v2.info.block_user': 'Blockera {name}',
  'messenger_v2.info.block_user_confirm':
    'Den här användaren ser inte din avatar eller status, och nya meddelanden eller samtal från dem når dig inte.',
  'messenger_v2.info.block_user_title': 'Blockera "{name}"?',
  'messenger_v2.info.blocking_user': 'Blockerar...',
  'messenger_v2.info.chat_cleared': 'Chatten rensad.',
  'messenger_v2.info.clear_all_messages': 'Rensa alla meddelanden',
  'messenger_v2.info.clear_chat': 'Rensa chatt',
  'messenger_v2.info.clear_chat_confirm': 'Gamla meddelanden tas bara bort för dig.',
  'messenger_v2.info.clear_chat_failed': 'Chatten kunde inte rensas.',
  'messenger_v2.info.clear_chat_title': 'Rensa chatten?',
  'messenger_v2.info.clear_chat_warning_body':
    'Den här chatten blir tom men ligger kvar i din chattlista.',
  'messenger_v2.info.clear_chat_warning_title': 'Rensa alla meddelanden från "{name}"?',
  'messenger_v2.info.chat_deleted': 'Chatten raderad.',
  'messenger_v2.info.delete_chat': 'Radera chatt',
  'messenger_v2.info.delete_chat_failed': 'Chatten kunde inte raderas.',
  'messenger_v2.info.delete_chat_warning_body':
    'Den här chatten tas bort från din chattlista. Om du startar chatten igen visas inte gamla meddelanden.',
  'messenger_v2.info.delete_chat_warning_title': 'Radera chatten med "{name}"?',
  'messenger_v2.info.clearing_chat': 'Rensar chatt...',
  'messenger_v2.info.info': 'Info',
  'messenger_v2.info.media': 'Media',
  'messenger_v2.info.links': 'Länkar',
  'messenger_v2.info.docs': 'Dokument',
  'messenger_v2.info.media_links_docs': 'Media, länkar och dokument',
  'messenger_v2.info.starred': 'Stjärnmärkt',
  'messenger_v2.info.encryption': 'Kryptering',
  'messenger_v2.info.members': 'Medlemmar',
  'messenger_v2.info.groups_in_common': 'Gemensamma grupper',
  'messenger_v2.info.no_media': 'Ingen media har delats i denna chatt ännu.',
  'messenger_v2.info.no_links': 'Inga länkar har delats i denna chatt ännu.',
  'messenger_v2.info.no_docs': 'Inga dokument har delats i denna chatt ännu.',
  'messenger_v2.info.no_common_groups': 'Inga gemensamma grupper ännu.',
  'messenger_v2.info.unblock': 'Avblockera',
  'messenger_v2.info.unblock_failed': 'Användaren kunde inte avblockeras.',
  'messenger_v2.info.unblock_user': 'Avblockera {name}',
  'messenger_v2.info.unblock_user_confirm': 'Den här användaren kan kontakta dig igen.',
  'messenger_v2.info.unblock_user_title': 'Avblockera "{name}"?',
  'messenger_v2.info.unblocking_user': 'Avblockerar...',
  'messenger_v2.info.user_blocked': '{name} blockerad.',
  'messenger_v2.info.user_unblocked': '{name} avblockerad.',
  'messenger_v2.info.no_members': 'Inga medlemmar att visa ännu.',
  'messenger_v2.info.pending_invitations': 'Inbjudna - väntar på svar',
  'messenger_v2.info.invitation_pending': 'Inbjudan väntar på svar',
  'messenger_v2.info.document_fallback': 'Dokument',
  'messenger_v2.info.encryption_detail': 'Meddelanden är skyddade i denna chatt.',
  'messenger_v2.info.starred_empty': 'Inga stjärnmärkta meddelanden ännu.',
  'messenger_v2.info.member': 'Medlem',
  'messenger_v2.info.you_label': '{name} (Du)',
  'messenger_v2.info.last_week': 'Förra veckan',
  'messenger_v2.info.this_month': 'Den här månaden',
  'messenger_v2.info.date_unknown': 'Tidigare',
  'messenger_v2.composer.add_note': 'Lägg till en anteckning',
  'messenger_v2.composer.add_more_attachments': 'Lägg till fler bilagor',
  'messenger_v2.composer.open_attachments': 'Öppna bilagor',
  'messenger_v2.composer.send': 'Skicka',
  'messenger_v2.composer.sending': 'Skickar',
  'messenger_v2.composer.draft': 'Utkast',
  'messenger_v2.voice.record': 'Spela in röstmeddelande',
  'messenger_v2.voice.recording': 'Spelar in röstmeddelande',
  'messenger_v2.voice.recording_preview': 'Spelar in röstmeddelande...',
  'messenger_v2.voice.paused': 'Röstinspelningen är pausad',
  'messenger_v2.voice.ready': 'Röstmeddelandet är klart',
  'messenger_v2.voice.sending': 'Skickar röstmeddelande',
  'messenger_v2.voice.pause': 'Pausa inspelningen',
  'messenger_v2.voice.pause_short': 'Pausa',
  'messenger_v2.voice.resume': 'Fortsätt inspelningen',
  'messenger_v2.voice.resume_short': 'Fortsätt',
  'messenger_v2.voice.cancel': 'Radera röstinspelningen',
  'messenger_v2.voice.send': 'Skicka röstmeddelande',
  'messenger_v2.voice.unsupported': 'Webbläsaren stöder inte röstinspelning.',
  'messenger_v2.voice.permission_denied':
    'Mikrofonåtkomst nekades. Tillåt mikrofonen och försök igen.',
  'messenger_v2.voice.microphone_unavailable': 'Ingen tillgänglig mikrofon hittades.',
  'messenger_v2.voice.too_short': 'Röstmeddelandet är för kort. Spela in igen.',
  'messenger_v2.voice.send_failed':
    'Röstmeddelandet kunde inte köas. Tryck på skicka för att försöka igen.',
  'messenger_v2.voice.recording_failed': 'Röstmeddelandet kunde inte spelas in.',
  'messenger_v2.voice.retry_playback': 'Försök spela röstmeddelandet igen',
  'messenger_v2.voice.pause_playback': 'Pausa röstmeddelandet',
  'messenger_v2.voice.play': 'Spela röstmeddelande',
  'messenger_v2.voice.seek': 'Spola i röstmeddelandet',
  'messenger_v2.voice.uploading': 'Laddar upp {progress} %',
  'messenger_v2.voice.speed': 'Uppspelningshastighet {rate}x',
  'messenger_v2.composer.send_attachments': 'Skicka bilagor',
  'messenger_v2.composer.sending_attachments': 'Skickar bilagor',
  'messenger_v2.composer.file': 'Fil',
  'messenger_v2.composer.image_or_video': 'Bild eller video',
  'messenger_v2.composer.document': 'Dokument',
  'messenger_v2.composer.preview_unavailable':
    'Förhandsvisning är inte tillgänglig. Du kan fortfarande skicka den rena länken.',
  'messenger_v2.link_preview.error': 'Länkförhandsvisning är inte tillgänglig.',
  'messenger_v2.link_preview.remove': 'Ta bort länkförhandsvisning',
  'messenger_v2.attachment.image': 'Bild',
  'messenger_v2.attachment.video': 'Video',
  'messenger_v2.attachment.audio': 'Ljud',
  'messenger_v2.attachment.document': 'Dokument',
  'messenger_v2.attachment.file': 'Fil',
  'messenger_v2.attachment.file_upper': 'FIL',
  'messenger_v2.attachment.attachment': 'Bilaga',
  'messenger_v2.attachment.fallback_name': 'Bilaga {index}',
  'messenger_v2.attachment.attachments_selected': '{count} bilagor valda',
  'messenger_v2.attachment.add_attachments': 'Lägg till bilagor',
  'messenger_v2.attachment.edit_image': 'Redigera bild',
  'messenger_v2.attachment.prepare_failed':
    'Den redigerade bilagan kunde inte förberedas. Dina ändringar finns kvar – försök igen.',
  'messenger_v2.attachment.edit_render_failed':
    'Den redigerade bilden kunde inte skapas. Dina ändringar finns kvar – försök igen.',
  'messenger_v2.attachment.encryption_failed':
    'Bilagan kunde inte krypteras på den här enheten. Försök igen.',
  'messenger_v2.attachment.storage_warning':
    'Enhetens lagringsutrymme är fullt. Håll appen öppen medan bilagorna laddas upp.',
  'messenger_v2.attachment.upload_failed':
    'Den säkra uppladdningen avbröts. Kontrollera anslutningen och försök igen.',
  'messenger_v2.attachment.send_failed':
    'Bilagorna kunde inte köas. Dina ändringar finns kvar – försök igen.',
  'messenger_v2.attachment.preparing_progress': 'Förbereder bilagor ({completed}/{total})',
  'messenger_v2.image_editor.close': 'Tillbaka',
  'messenger_v2.image_editor.crop': 'Beskär',
  'messenger_v2.image_editor.done': 'Klar',
  'messenger_v2.image_editor.draw': 'Rita',
  'messenger_v2.image_editor.emoji': 'Emoji',
  'messenger_v2.image_editor.redo': 'Gör om',
  'messenger_v2.image_editor.text': 'Text',
  'messenger_v2.image_editor.title': 'Redigera bild',
  'messenger_v2.image_editor.undo': 'Ångra',
  'messenger_v2.attachment.drop_files_here': 'Släpp filerna här',
  'messenger_v2.attachment.drop_files_hint': 'De läggs till i ditt bilageutkast.',
  'messenger_v2.attachment.no_attachments_selected_title': 'Inga bilagor valda ännu',
  'messenger_v2.attachment.no_attachments_selected_text':
    'Välj filer från bilagemenyn för att börja skapa utkastet.',
  'messenger_v2.attachment.no_files_selected_title': 'Inga filer valda ännu',
  'messenger_v2.attachment.no_files_selected_text':
    'Välj bilder, videor, dokument eller valfri fil för att skapa meddelandeutkastet.',
  'messenger_v2.attachment.preview_unavailable': 'Förhandsvisning är inte tillgänglig',
  'messenger_v2.attachment.unable_open': 'Det gick inte att öppna den här bilagan. Försök igen.',
  'messenger_v2.attachment.unable_download':
    'Det gick inte att ladda ner den här bilagan. Försök igen.',
  'messenger_v2.attachment.no_selected': 'Ingen bilaga vald',
  'messenger_v2.attachment.play_video_preview': 'Spela videoförhandsvisning',
  'messenger_v2.attachment.close_composer': 'Stäng bilagekomponisten',
  'messenger_v2.attachment.close_preview': 'Stäng bilageförhandsvisning',
  'messenger_v2.attachment.previous': 'Föregående bilaga',
  'messenger_v2.attachment.next': 'Nästa bilaga',
  'messenger_v2.attachment.previous_selected': 'Visa föregående vald bilaga',
  'messenger_v2.attachment.next_selected': 'Visa nästa vald bilaga',
  'messenger_v2.attachment.scroll_left': 'Rulla bilagor åt vänster',
  'messenger_v2.attachment.scroll_right': 'Rulla bilagor åt höger',
  'messenger_v2.attachment.scroll_selected_left': 'Rulla valda bilagor åt vänster',
  'messenger_v2.attachment.scroll_selected_right': 'Rulla valda bilagor åt höger',
  'messenger_v2.attachment.remove': 'Ta bort {name}',
  'messenger_v2.attachment.open': 'Öppna {name}',
  'messenger_v2.attachment.view': 'Visa {name}',
  'messenger_v2.attachment.download': 'Ladda ner {name}',
  'messenger_v2.attachment.download_action': 'Ladda ner',
  'messenger_v2.attachment.zoom_in': 'Zooma in bilden',
  'messenger_v2.attachment.reset_zoom': 'Återställ bildzoom',
  'messenger_v2.attachment.uploading': 'Laddar upp {name}',
  'messenger_v2.call.audio': 'Ljud',
  'messenger_v2.call.remote_audio': 'Ljud från samtalet',
  'messenger_v2.call.video': 'Video',
  'messenger_v2.call.start_voice': 'Starta röstsamtal',
  'messenger_v2.call.start_video': 'Starta videosamtal',
  'messenger_v2.call.direct_only': 'Samtal är tillgängliga i direkt krypterade chattar.',
  'messenger_v2.call.group_needs_members':
    'Lägg till en medlem till för att starta ett gruppsamtal.',
  'messenger_v2.call.unavailable': 'Samtal är inte tillgängliga för den här chatten.',
  'messenger_v2.call.blocked_unavailable': 'Samtal är inte tillgängliga för den här chatten.',
  'messenger_v2.call.start_failed': 'Det gick inte att starta röstsamtal.',
  'messenger_v2.call.start_video_failed': 'Det gick inte att starta videosamtal.',
  'messenger_v2.call.recipient_device_unavailable':
    'Mottagaren måste öppna Nätgrav Chat på sin enhet innan du kan ringa krypterat.',
  'messenger_v2.call.accept_failed': 'Det gick inte att svara på röstsamtal.',
  'messenger_v2.call.incoming': 'Inkommande röstsamtal',
  'messenger_v2.call.incoming_video': 'Inkommande videosamtal',
  'messenger_v2.call.calling': 'Ringer...',
  'messenger_v2.call.ringing': 'Ringer...',
  'messenger_v2.call.connecting': 'Ansluter...',
  'messenger_v2.call.reconnecting': 'Ansluter igen...',
  'messenger_v2.call.active': 'Röstsamtal',
  'messenger_v2.call.active_video': 'Videosamtal',
  'messenger_v2.call.accept': 'Svara på samtal',
  'messenger_v2.call.decline': 'Avvisa samtal',
  'messenger_v2.call.open': 'Öppna',
  'messenger_v2.call.join': 'Anslut',
  'messenger_v2.call.ignore': 'Ignorera',
  'messenger_v2.call.minimize': 'Minimera samtal',
  'messenger_v2.call.encrypted': 'Totalsträckskrypterat',
  'messenger_v2.call.open_chat': 'Öppna chatt',
  'messenger_v2.call.change_audio_output': 'Byt ljudutgång',
  'messenger_v2.call.mute': 'Stäng av ljud',
  'messenger_v2.call.unmute': 'Slå på ljud',
  'messenger_v2.call.camera_on': 'Slå på kamera',
  'messenger_v2.call.camera_off': 'Stäng av kamera',
  'messenger_v2.call.background_blur_on': 'Gör bakgrunden oskarp',
  'messenger_v2.call.background_blur_off': 'Stäng av oskarp bakgrund',
  'messenger_v2.call.background_blur_failed': 'Det gick inte att ändra bakgrundsoskärpa.',
  'messenger_v2.call.enter_fullscreen': 'Visa helskärm',
  'messenger_v2.call.exit_fullscreen': 'Avsluta helskärm',
  'messenger_v2.call.end': 'Avsluta samtal',
  'messenger_v2.call.participant': 'Deltagare',
  'messenger_v2.call.you_label': '{name} (du)',
  'messenger_v2.call.pin_participant': 'Fäst {name}',
  'messenger_v2.call.unpin_participant': 'Lossa {name}',
  'messenger_v2.call.screen_sharing': 'Skärmdelning',
  'messenger_v2.call.peer_muted': '{name} stängde av ljudet i samtalet',
  'messenger_v2.call.you_muted': 'Du stängde av ljudet i samtalet',
  'messenger_v2.call.history_call': 'Röstsamtal',
  'messenger_v2.call.history_video_call': 'Videosamtal',
  'messenger_v2.call.history_group_call': 'Gruppsamtal',
  'messenger_v2.call.history_group_video_call': 'Gruppvideosamtal',
  'messenger_v2.call.history_participants': '{count} medlemmar',
  'messenger_v2.call.members_title': 'Samtalsmedlemmar',
  'messenger_v2.call.history_missed': 'Missat röstsamtal',
  'messenger_v2.call.history_video_missed': 'Missat videosamtal',
  'messenger_v2.call.history_declined': 'Röstsamtal avvisat',
  'messenger_v2.call.history_video_declined': 'Videosamtal avvisat',
  'messenger_v2.call.history_cancelled': 'Röstsamtal avbrutet',
  'messenger_v2.call.history_video_cancelled': 'Videosamtal avbrutet',
  'messenger_v2.call.history_failed': 'Röstsamtal misslyckades',
  'messenger_v2.call.history_video_failed': 'Videosamtal misslyckades',
  'messenger_v2.call.duration_seconds': '{seconds} sek',
  'messenger_v2.call.duration_minutes': '{minutes} min',
  'messenger_v2.call.duration_minutes_seconds': '{minutes} min {seconds} sek',
  'messenger_v2.call.duration_hours': '{hours} tim',
  'messenger_v2.call.duration_hours_minutes': '{hours} tim {minutes} min',
  'messenger_v2.discard.title': 'Kassera ändringar?',
  'messenger_v2.discard.content': 'Är du säker på att du vill kassera dina ändringar?',
  'messenger_v2.discard.confirm': 'Kassera',
  'messenger_v2.discard.cancel': 'Fortsätt redigera',
  'emojiPicker.emojiPicker': 'Emojiväljare',
  'emojiPicker.reactionPicker': 'Reaktionsväljare',
  'emojiPicker.searchEmoji': 'Sök efter emoji',
  'emojiPicker.searchReactions': 'Sök efter reaktioner',
  'emojiPicker.findEmoji': 'Hitta den perfekta emojin',
  'emojiPicker.findReaction': 'Hitta den perfekta reaktionen',
  'emojiPicker.categories': 'Emojikategorier',
  'emojiPicker.category.frequent': 'Ofta använda',
  'emojiPicker.category.smileys': 'Smileys och känslor',
  'emojiPicker.category.people': 'Människor och kropp',
  'emojiPicker.category.animals': 'Djur och natur',
  'emojiPicker.category.food': 'Mat och dryck',
  'emojiPicker.category.travel': 'Resor och platser',
  'emojiPicker.category.activities': 'Aktiviteter',
  'emojiPicker.category.objects': 'Föremål',
  'emojiPicker.category.symbols': 'Symboler',
  'emojiPicker.category.flags': 'Flaggor',
  'emojiPicker.searchResults': 'Sökresultat',
  'emojiPicker.noResults': 'Inga emojier matchar din sökning.',
  'emojiPicker.noFrequentlyUsed': 'Dina ofta använda emojier visas här.',
  'emojiPicker.skinTone': 'Hudton',
  'emojiPicker.skinTone.default': 'Standardhudton',
  'emojiPicker.skinTone.light': 'Ljus hudton',
  'emojiPicker.skinTone.mediumLight': 'Mellanljus hudton',
  'emojiPicker.skinTone.medium': 'Mellanhudton',
  'emojiPicker.skinTone.mediumDark': 'Mellanmörk hudton',
  'emojiPicker.skinTone.dark': 'Mörk hudton',
  'messenger_v2.composer.choose_emoji': 'Välj emoji',
  'messenger_v2.message.add_reaction': 'Lägg till reaktion',
  'pwa.onboarding.install_title': 'Installera Nettgrav',
  'pwa.onboarding.install_body':
    'Ha Nettgrav bara ett tryck bort och få en mer tillförlitlig appupplevelse på den här enheten.',
  'pwa.onboarding.install_action': 'Installera Nettgrav',
  'pwa.onboarding.install_manual_action': 'Jag förstår',
  'pwa.onboarding.not_now': 'Inte nu',
  'pwa.onboarding.benefit_messages': 'Meddelandenotiser i bakgrunden',
  'pwa.onboarding.benefit_calls': 'Aviseringar om inkommande samtal',
  'pwa.onboarding.benefit_badge': 'Antal olästa på appikonen',
  'pwa.onboarding.ios_steps':
    'Tryck på Dela i webbläsaren, välj Lägg till på hemskärmen och öppna sedan Nettgrav från den nya ikonen.',
  'pwa.onboarding.mac_steps':
    'I Safari väljer du Arkiv → Lägg till i Dock och öppnar sedan Nettgrav från Dock eller Program.',
  'pwa.onboarding.notifications_title': 'Missa aldrig ett meddelande eller samtal',
  'pwa.onboarding.notifications_body':
    'Tillåt Nettgrav att meddela dig om nya krypterade meddelanden och inkommande samtal, även när appen är stängd.',
  'pwa.onboarding.notifications_action': 'Tillåt notiser',
  'pwa.onboarding.notifications_denied':
    'Notiser är blockerade. Aktivera dem för Nettgrav i webbläsarens eller enhetens notisinställningar och försök igen.',
  'rooms.invite.auth_required': 'Logga in eller skapa ett konto för att se rumsinbjudan.',
  'rooms.invite.back': 'Tillbaka till rum',
  'rooms.invite.fail': 'Inbjudan är ogiltig eller har gått ut.',
  'rooms.invite.join': 'Gå med i rummet',
  'rooms.invite.label': 'Rumsinbjudan',
  'rooms.invite.loading': 'Läser in inbjudan...',
  'rooms.invite.member_count': '{count, plural, one {# medlem} other {# medlemmar}}',
  'rooms.invite.title': 'Rumsinbjudan',
  'rooms.invite.view': 'Visa rum',
  'rooms.navigation.label': 'Rumssektioner',
  'rooms.state.archived': 'Det här rummet har arkiverats.',
  'rooms.state.error': 'Rummet kunde inte läsas in.',
  'rooms.state.loading': 'Läser in rum…',
  'rooms.state.removed': 'Det här rummet har tagits bort.',
  'rooms.state.retry': 'Försök igen',
  'rooms.tabs.members_chat': 'Medlemschatt',
  'rooms.members_chat.title': 'Krypterad medlemschatt',
  'rooms.members_chat.description':
    'En privat, totalsträckskrypterad konversation för aktiva rumsmedlemmar.',
  'rooms.members_chat.loading': 'Förbereder rumschatten…',
  'rooms.members_chat.locked_title': 'Konversation endast för medlemmar',
  'rooms.members_chat.locked':
    'Gå med i rummet för att öppna den krypterade medlemschatten. Meddelanden och förhandsvisningar är dolda tills ditt medlemskap är aktivt.',
  'rooms.members_chat.error': 'Medlemschatten kunde inte läsas in.',
  'rooms.state.unavailable': 'Rummet finns inte eller så saknar du åtkomst.',
  'rooms.provisioning.action_required': 'Rumschatten behöver åtgärdas innan den kan användas.',
  'rooms.provisioning.pending': 'Rumschatten förbereds.',
  'groups.reactions.error': 'Det gick inte att uppdatera din reaktion.',
  'groups.media.uploading': 'Laddar upp media…',
  'groups.post.published': 'Publicerat.',
  retry: 'Försök igen',
};

export default SWE;
